/** Textos de páginas (Dashboard, gestão, atendimentos). Fundido em messages.js. */

const ptBR = {
  'common.open': 'Abrir',
  'common.refresh': 'Atualizar',
  'common.active': 'Ativos',
  'common.inactive': 'Inativos',
  'common.total': 'Total',
  'common.online': 'Online',
  'common.clients': 'Clientes',
  'common.more': 'Mais',
  'common.search': 'Buscar…',
  'common.all': 'Todos',
  'common.expiring': 'Vencendo',
  'common.expired': 'Vencidos',
  'common.management': 'Gestão',

  'dash.eyebrow': 'Visão geral',
  'dash.welcome': 'Bem-vindo de volta, {name}',
  'dash.subtitle':
    'Gere testes e clientes pelos botões. Abaixo, o pulso do Office em tempo real.',
  'dash.subtitleReseller':
    'Acompanhe clientes, faturamento e catálogo da sua rede — tudo organizado em um só lugar.',
  'dash.sectionPerformance': 'Desempenho · 30 dias',
  'dash.sectionOverview': 'Resumo operacional',
  'dash.sectionOperations': 'Operação e ferramentas',
  'dash.execAria': 'Visão executiva do negócio',
  'dash.execKicker': 'Visão executiva',
  'dash.execTitle': 'Sua operação, em ordem de prioridade',
  'dash.execSub': 'Acompanhe o que exige atenção agora e acesse rapidamente as rotinas mais importantes.',
  'dash.execActive': '{n} clientes ativos',
  'dash.execExpiring': '{n} vencem em 7 dias',
  'dash.execChats': '{n} atendimentos abertos',
  'dash.manageRenewals': 'Gerenciar renovações',
  'dash.clientsOverview': 'Base de clientes',
  'dash.clientsOverviewHint': '{active} ativos · {expiring} a vencer',
  'dash.toolsPanel': 'Ferramentas',
  'dash.quickTest': 'Teste',
  'dash.newClient': 'Novo Cliente',
  'dash.periodLabel': 'Período',
  'dash.shortcuts': 'Atalhos',
  'dash.periodPrev': 'Mês passado',
  'dash.period30d': '30 dias',
  'dash.periodCur': 'Mês atual',
  'dash.revenuePeriod': 'Faturamento · 30 dias',
  'dash.salesCount': '{n} vendas',
  'dash.last7d': 'Últimos 7 dias',
  'dash.shortWindow': 'janela curta',
  'dash.today': 'Hoje',
  'dash.yesterday': 'Ontem {value}',
  'dash.activeClients': 'Clientes ativos',
  'dash.onlineNow': '{n} online agora',
  'dash.noClientsOnline': 'Nenhum cliente online',
  'dash.trialsExcluded': 'Testes não entram neste indicador',
  'dash.infra': 'Infra Servidor',
  'dash.servers': 'Servidores',
  'dash.serversOnlineHint': '{n} online · conexão estável',
  'dash.connectPanel': 'Ligue um servidor',
  'dash.liveChannels': 'Canais ao vivo',
  'dash.activeStreams': 'Canais ao vivo',
  'dash.catalog': 'Conteúdos',
  'dash.contents': 'Conteúdos',
  'dash.catalogHint': '{channels} canais · {movies} filmes · {series} séries',
  'dash.catalogHintScoped': '{channels} canais · {movies} filmes · {series} séries · bouquets padrão',
  'dash.catalogHintEmpty': 'Configure bouquets padrão em Servidores',
  'dash.channels': 'Canais',
  'dash.movies': 'Filmes',
  'dash.series': 'Séries',
  'catalog.title': 'Conteúdos',
  'catalog.subtitle':
    'Consulte canais, filmes e séries dos bouquets padrão e abra o Web Player para clientes no computador.',
  'catalog.eyebrow': 'IPTV',
  'catalog.openPlayer': 'Abrir Web Player',
  'catalog.heroKicker': 'Biblioteca do painel',
  'catalog.heroTitle': 'Conteúdos organizados para a sua operação',
  'catalog.heroText':
    'Explore o que o servidor oferece. Para assistir no computador, abra o Web Player com o usuário e a senha da linha.',
  'catalog.statusReady': 'Catálogo pronto',
  'catalog.statusOffline': 'Servidor desconectado',
  'catalog.statusLoading': 'Carregando…',
  'catalog.guideBouquets': 'Bouquets padrão',
  'catalog.guideBouquetsText':
    'Só entram conteúdos dos bouquets definidos em Servidores — não o catálogo Servidor inteiro.',
  'catalog.guideSearch': 'Busca rápida',
  'catalog.guideSearchText':
    'Filtre por categoria ou digite o título para achar canais, filmes e séries em segundos.',
  'catalog.guidePlayer': 'Web Player',
  'catalog.guidePlayerText':
    'Ideal para clientes de PC: abra o player com a linha IPTV e assista sem app externo.',
  'catalog.inactiveTitle': 'Conecte o servidor para liberar o catálogo',
  'catalog.inactiveText':
    'Sem um servidor ativo, o Office não consegue listar canais, filmes nem séries. Configure a API Admin e os bouquets padrão para montar esta biblioteca.',
  'catalog.inactiveStep1': 'Abra Servidores e adicione (ou ative) o servidor',
  'catalog.inactiveStep2': 'Informe URL Admin, chave API e DNS público',
  'catalog.inactiveStep3': 'Escolha os bouquets padrão e sincronize',
  'catalog.inactiveCta': 'Ir para Servidores',
  'catalog.inactiveHint':
    'Depois da sincronização, os totais e as categorias aparecem automaticamente aqui.',
  'catalog.statLive': 'Canais',
  'catalog.statMovies': 'Filmes',
  'catalog.statSeries': 'Séries',
  'catalog.tabLive': 'Canais',
  'catalog.tabMovies': 'Filmes',
  'catalog.tabSeries': 'Séries',
  'catalog.searchPh': 'Buscar título…',
  'catalog.categories': 'Categorias',
  'catalog.all': 'Todas',
  'catalog.showing': '{n} itens',
  'catalog.showingZero': 'Sem resultados',
  'catalog.empty': 'Nenhum conteúdo nesta categoria.',
  'catalog.emptyHint':
    'Tente outra categoria, limpe a busca ou confira se os bouquets padrão incluem este tipo de conteúdo.',
  'catalog.loadError': 'Não foi possível carregar o catálogo.',
  'catalog.watch': 'Assistir no Web Player',
  'catalog.loadMore': 'Carregar mais',
  'catalog.channelInfo': 'Informações',
  'catalog.liveHint': 'Canal ao vivo. Abra o Web Player com o usuário e a senha da linha para assistir.',
  'catalog.adultTitle': 'Conteúdo restrito (+18)',
  'catalog.adultCategory': 'Classificação etária',
  'catalog.adultMessage':
    'Este conteúdo não é exibido no catálogo Office por política da plataforma. Para assistir, abra o Web Player com o usuário e a senha da linha IPTV.',
  'catalog.adultRestricted': 'Conteúdo +18',
  'catalog.retry': 'Tentar novamente',
  'catalog.openServers': 'Configurar servidores',
  'catalog.catsEmpty': 'Categorias aparecem após sincronizar o Servidor.',
  'catalog.gridHint': 'Clique em um item para ver detalhes e abrir o Web Player.',
  'dash.commercialNet': 'Rede comercial',
  'dash.resellers': 'Revendas',
  'dash.resellersActiveHint': '{active} ativas de {total}',
  'dash.resellersOperationalHint': '{active} ativas de {total} · {review} no histórico para revisão',
  'dash.migrationReview': 'Histórico em revisão',
  'dash.awaitingActivation': 'Aguardando ativação',
  'dash.resellerHierarchy': 'Hierarquia de revendedores',
  'dash.actives': 'Ativas',
  'dash.inventoryBase': 'Base do Office',
  'dash.awaitingSigma': 'Inventário do servidor não é importado — sincronize a Sigma para trazer os seus clientes.',
  'dash.expiring7d': 'A expirar · 7d',
  'dash.newInPeriod': 'Novos em 30 dias',
  'dash.activeResellers': 'Revendas ativas',
  'dash.growthPeriod': 'Crescimento — 30 dias',
  'dash.viewClients': 'Ver clientes',
  'dash.activityPeriod': 'Atividade · últimos 30 dias',
  'dash.revenueInPeriod': 'Receita nos últimos 30 dias',
  'dash.clientBase30d': 'Base de clientes — 30 dias',
  'dash.geoSection': 'Presença geográfica',
  'dash.geoSectionSub': 'Foco no Brasil; o mapa alarga quando há clientes noutros países (IP real)',
  'dash.geoKicker': 'Mapa · foco Brasil',
  'dash.geoTitle': 'Origem dos clientes',
  'dash.geoMajority': 'Maioria em {country} ({pct}%)',
  'dash.geoMapped': '{countries} países · {online} online agora',
  'dash.geoMappedStates': '{states} estados · {online} online agora',
  'dash.geoViewLive': 'Clientes conectados',
  'dash.geoLoading': 'A analisar localizações…',
  'dash.geoLoadingBrazil': 'A carregar mapa do Brasil…',
  'dash.geoMapLoadError': 'Não foi possível carregar o mapa do Brasil.',
  'dash.geoBrazilAria': 'Mapa interativo do Brasil por estados',
  'dash.geoMapCaption': 'Passe o rato sobre os estados · use a roda para ampliar',
  'dash.geoEmptyTitle': 'Ainda sem mapa de clientes',
  'dash.geoEmptySub':
    'Quando um cliente ligar pela app IPTV (IP real), o mapa mostra o estado. Conexões via Web Player usam o IP da VPS e são ignoradas.',
  'dash.geoClientsSuffix': ' clientes',
  'dash.geoRankKicker': 'Estudo por origem',
  'dash.geoRankTitle': 'Top origens',
  'dash.geoRankStates': 'Principais estados',
  'dash.geoRankOnline': '{n} online',
  'dash.geoRankKnown': 'Último IP conhecido',
  'dash.geoSideFoot': 'IP real · estados do Brasil',
  'dash.clientRevenue30d': 'Faturamento de clientes — 30 dias',
  'dash.paidRenewals': '{n} renovações pagas',
  'dash.newClientsStable': '+{n} novos · acumulado estável',
  'dash.chartEmptyTitle': 'Sem movimento nos últimos 30 dias',
  'dash.chartEmptySub':
    'Quando houver vendas ou novos clientes, o gráfico mostra a evolução acumulada.',
  'dash.awaitingActivity': 'Aguardando atividade',
  'dash.clientBaseLegend': 'Base acumulada + novos/dia',
  'dash.chartBase': 'Base',
  'dash.chartNew': 'Novos',
  'dash.chartRevenue': 'Receita',
  'dash.creditsKicker': 'Revendas · PIX',
  'dash.creditsTitle': 'Faturamento de créditos',
  'dash.creditsBilled': 'Faturado',
  'dash.creditsUnits': 'Unidades',
  'dash.viewSales': 'Ver vendas',
  'dash.creditsEmptyTitle': 'Sem vendas de créditos nos últimos 30 dias',
  'dash.creditsEmptySub':
    'Pacotes comprados pelas revendas via PIX aparecem aqui — faturamento e créditos creditados.',
  'dash.iptvOps': 'Operação IPTV',
  'dash.renewRetention': 'Renovação e retenção',
  'dash.renewHint':
    'Priorize linhas a vencer, recupere vencidos e acompanhe quem está online agora.',
  'dash.baseHealth': 'Saúde da base',
  'dash.activeSuffix': 'ativos',
  'dash.linesOf': '{active} de {total} linhas',
  'dash.onlineNowLabel': 'Online agora',
  'dash.inbox': 'Atendimentos',
  'dash.renewQueue': 'Fila de renovação',
  'dash.renewQueueWarn':
    '{n} linha(s) a vencer em 7 dias — contate e renove agora.',
  'dash.renewQueueOk': 'Nenhuma linha crítica a expirar. Mantenha o ritmo de renovações.',
  'dash.openClients': 'Abrir clientes',
  'dash.quickAnalysis': 'Análise rápida',
  'dash.analysisHint':
    'Gere um resumo com base em renovações, receita e atividade Servidor.',
  'dash.generating': 'Gerando…',
  'dash.generateAnalysis': 'Gerar análise',
  'dash.dnsNotice': 'Aviso — novas DNS disponíveis',
  'dash.hideDns': 'Ocultar por 3 dias',
  'dash.vodReleases': 'Catálogo em destaque',
  'dash.vodHeadline': 'Novidades para seus clientes',
  'dash.vodCopyReport': 'Copiar novidades',
  'dash.vodSendWhatsApp': 'Compartilhar',
  'dash.vodCopied': 'Relatório copiado!',
  'dash.vodCopyFail': 'Não foi possível copiar.',
  'dash.vodWhatsAppOpened': 'WhatsApp aberto com o relatório.',
  'dash.vodWhatsAppPaste': 'Relatório copiado! Cole no WhatsApp com Ctrl+V (o texto é longo demais para o link).',
  'dash.vodReportTitle': 'LANÇAMENTOS — CATÁLOGO',
  'dash.vodReportFooter': 'Confira já no catálogo!',
  'dash.vodCategory': 'Categoria no servidor',
  'dash.vodCategoryUnknown': 'Categoria não informada no painel',
  'dash.vodGenre': 'Gênero',
  'dash.vodRating': 'Nota',
  'dash.vodSynopsis': 'Sinopse',
  'dash.vodNoPlot': 'Sinopse indisponível neste título.',
  'dash.vodDirector': 'Direção',
  'dash.vodCast': 'Elenco',
  'dash.vodDuration': 'Duração',
  'dash.vodDetailHint': 'Detalhes do lançamento no catálogo Servidor',
  'dash.vodLocale': 'pt-BR',
  'dash.vodScrollPrev': 'Ver títulos anteriores',
  'dash.vodScrollNext': 'Ver mais títulos',
  'dash.aiBase':
    'Sua base tem {active} clientes ativos de {total} no total',
  'dash.aiExpiring': ', com {n} a expirar em 7 dias.',
  'dash.aiRevenue': ' Receita no período: {value}. ',
  'dash.aiAction':
    'Ação recomendada: contate os clientes a expirar via WhatsApp e use o fluxo de renovação.',
  'dash.aiKeep': 'Mantenha o ritmo de ativações e monitore o ticket médio.',
  'dash.openArrow': 'Abrir',

  'common.cancel': 'Cancelar',
  'common.close': 'Fechar',
  'common.save': 'Salvar',
  'common.name': 'Nome',
  'common.email': 'Email',
  'common.role': 'Função',
  'common.remove': 'Remover',

  'account.profileTitle': 'Meu perfil',
  'account.profileHint': 'Informações da sua conta e foto de perfil.',
  'account.uploadPhoto': 'Enviar foto',
  'account.fromEmail': 'Do email',
  'account.fromEmailHint':
    'Busca foto pública (Gravatar). A foto do Gmail/Google só entra com login Google ou envio manual.',
  'account.avatarHelp':
    'Preferência: use «Enviar foto». «Do email» só encontra foto se existir no Gravatar (a foto do Gmail não é pública só pelo endereço).',
  'account.settingsTitle': 'Configurações',
  'account.settingsHint': 'Altere a senha de acesso à sua conta.',
  'account.currentPassword': 'Senha atual',
  'account.newPassword': 'Nova senha',
  'account.confirmPassword': 'Confirmar senha',
  'account.confirmNewPassword': 'Confirmar nova senha',
  'account.changePassword': 'Alterar senha',
  'account.placeholderCurrent': 'Digite sua senha atual',
  'account.placeholderNew': 'Mínimo 8 caracteres',
  'account.placeholderConfirm': 'Repita a nova senha',
  'account.role.user': 'Usuário',
  'account.role.attendant': 'Atendente',
  'pages.resellers.mfaOn': '2FA ativo',
  'pages.resellers.mfaOff': '2FA desativado',

  'sub.dashboard':
    'Resumo em tempo real do seu Office — clientes, faturamento e atividade Servidor.',
  'sub.chats': 'Conversas WhatsApp em tempo real',
  'sub.finance': 'Receitas, vendas e movimentos financeiros do Office.',
  'sub.financeLogs': 'Todas as movimentações com filtros personalizados.',
  'sub.globalLogs': 'Todas as ações do office em tempo real.',
  'sub.ranking': 'Liga semanal, metas e ranking de novos clientes.',
  'sub.templates': 'Avisos WhatsApp de revenda, créditos e segurança.',
  'sub.buyCredits': 'Recarregue o Modo crédito para operar no painel.',
  'sub.addBalance': 'Compre créditos via PIX para manter sua operação ativa.',
  'sub.clients':
    'Linhas IPTV do escritório — renovar, notificar e sincronizar com o Servidor num só lugar.',
  'sub.tests':
    'Acessos de demonstração — separados dos clientes pagos, prontos para renovar e notificar.',
  'sub.resellers':
    'Rede de revendedores Servidor — créditos, status e métricas do painel num só lugar.',
  'sub.myPortfolio':
    'Religue clientes que sumiram da lista após a migração — sem mudar senha nem derrubar a TV.',
  'sub.categories':
    'O que a sua rede vende e testa — edite aqui; a revenda só escolhe o cartão.',
  'sub.catalog':
    'Consulte canais, filmes e séries do servidor — e abra o Web Player para clientes no computador.',
  'sub.whatsapp':
    'Ligue números Evolution, escaneie o QR e sincronize o histórico para o atendimento.',
  'sub.team': 'Membros, papéis e acesso ao Office.',
  'sub.teamMonitor':
    'Ponto em tempo real, score, atestados e desempenho dos atendentes — atualização automática.',
  'sub.settings': 'Perfil, segurança e identidade visual do seu Office.',
  'sub.communitySupport':
    'Links da comunidade, contato de suporte das revendas e canal de informações nas mensagens.',
  'sub.servers': 'Conecte, acompanhe e sincronize os painéis utilizados pelo seu Office.',
  'sub.permissions':
    'Defina o que cada perfil vê no Office — grupos do Servidor, templates e exceções por revendedor.',
  'sub.leads': 'Agenda do Office — números e estágios ficam no CRM, mesmo se o WhatsApp desconectar.',
  'sub.funnel':
    'Quadro de contatos — arraste entre etapas; cada movimentação é salva automaticamente.',
  'sub.planPricing':
    'O que a sua rede vende e testa — edite aqui; a revenda só escolhe o cartão.',
  'sub.credentials': 'Padrão de usuário e senha ao criar linhas (Clientes, teste, chat).',
  'sub.resellerModes': 'Defina validade e regras do Modo crédito para a rede.',
  'sub.myResellerBilling':
    'Administre a política de créditos das sub-revendas da sua árvore.',
  'sub.gateway': 'Mercado Pago e outros bancos — checkouts PIX, créditos e carteira.',
  'sub.creditPacks': 'Monte a vitrine pré-pago: o que as revendas veem em Comprar créditos.',
  'sub.checkoutNotif': 'Avisos automáticos de pagamento no checkout.',
  'sub.salesMonitor':
    'Renovações, PIX e créditos — contato do comprador, WhatsApp e comprovantes quando disponíveis.',
  'sub.creditLedger': 'Movimentação da carteira IPTV — débitos, recargas e estornos.',
  'sub.triggers': 'Configure automações e respostas rápidas para o atendimento WhatsApp.',
  'sub.recuperacao':
    'Campanhas personalizadas no WhatsApp com agente IA, intervalos anti-bloqueio e relatórios profissionais.',
  'sub.inactiveClients':
    'Linhas vencidas, testes abandonados e clientes a vencer — notifique ou limpe em massa.',
  'sub.inactiveResellers':
    'Detecte revendedores parados, suspenda no servidor e notifique ou exclua em massa.',
  'sub.resellerMigration':
    'Importe clientes por URL M3U ou Xtream com validação antes de qualquer criação.',
  'eyebrow.tools': 'Ferramentas',
  'eyebrow.management': 'Gestão',
  'eyebrow.crm': 'Agenda',
  'eyebrow.ops': 'Operação',
  'eyebrow.config': 'Configurações',
  'eyebrow.credits': 'Créditos',
  'eyebrow.iptv': 'IPTV',
  'eyebrow.home': 'Visão geral',

  'pages.clients.eyebrow': 'Gestão',
  'pages.clients.title': 'Clientes',
  'pages.clients.subtitle':
    'Linhas IPTV do escritório — renovar, notificar e sincronizar com o Servidor num só lugar.',
  'pages.clients.new': 'Novo Cliente',
  'pages.clients.search': 'Buscar por nome, usuário ou WhatsApp…',
  'pages.clients.empty': 'Nenhum cliente encontrado',
  'pages.clients.emptyHint': 'Ajuste os filtros ou cadastre uma nova linha para começar.',
  'pages.clients.syncing': 'Sincronizando clientes…',
  'pages.clients.viewTable': 'Ver tabela',
  'pages.clients.viewCards': 'Ver cartões',
  'pages.clients.import': 'Importar',
  'pages.clients.notify': 'Notificar',
  'pages.clients.sheet': 'Ficha',
  'pages.clients.moreActions': 'Mais ações',
  'pages.clients.user': 'Usuário',
  'pages.clients.expiry': 'Vencimento',
  'pages.clients.status': 'Situação',
  'pages.clients.plan': 'Plano',
  'pages.clients.actions': 'Ações',
  'pages.clients.selected': '{n} selecionado(s)',
  'pages.clients.clearSelection': 'Limpar seleção',
  'pages.clients.delete': 'Excluir',
  'pages.clients.filterAll': 'Todos',
  'pages.clients.filterActive': 'Ativos',
  'pages.clients.filterExpiring': 'Vencendo',
  'pages.clients.filterExpired': 'Vencidos',
  'pages.clients.statusActive': 'Ativo',
  'pages.clients.statusPaused': 'Pausado',
  'pages.clients.statusExpired': 'Vencido',
  'pages.clients.statusExpiring': 'Vencendo',
  'pages.clients.lifetime': 'Vitalício',
  'pages.clients.created': 'Criado {date}',
  'pages.clients.conn1': 'conexão',
  'pages.clients.connN': 'conexões',
  'pages.clients.panel': 'Painel',
  'pages.clients.kpiTotal': 'Total',
  'pages.clients.kpiActive': 'Ativos',
  'pages.clients.kpiExpiring': 'Vencendo',
  'pages.clients.kpiExpired': 'Vencidos',
  'pages.clients.kpiTotalHint': 'linhas na base',
  'pages.clients.kpiPctBase': '{n}% da base',
  'pages.clients.kpiExpiringHint': 'próximos 7 dias',
  'pages.clients.actionsTitle': 'Ações do cliente',
  'pages.clients.actionsDesc': 'Linha {user}{plan}',
  'pages.clients.actionsDescEmpty': 'Escolha uma ação para esta linha',
  'pages.clients.actionsGroupManage': 'Gestão',
  'pages.clients.actionsGroupComm': 'Comunicação e acesso',
  'pages.clients.actionsGroupOther': 'Outras',
  'pages.clients.edit': 'Editar',
  'pages.clients.editHint': 'Dados e observações',
  'pages.clients.sheetHint': 'Detalhes completos',
  'pages.clients.renew': 'Renovar',
  'pages.clients.renewHint': 'Estender validade',
  'pages.clients.block': 'Bloquear',
  'pages.clients.activate': 'Ativar',
  'pages.clients.blockHint': 'Suspender acesso',
  'pages.clients.activateHint': 'Reativar acesso',
  'pages.clients.notifyHint': 'Enviar no WhatsApp',
  'pages.clients.message': 'Mensagem',
  'pages.clients.messageHint': 'Template do plano',
  'pages.clients.copyPlaylist': 'Copiar playlist',
  'pages.clients.copyPlaylistHint': 'Usuário, senha e DNS',
  'pages.clients.m3uOptions': 'Opções M3U',
  'pages.clients.m3uOptionsHint': 'Links de lista',
  'pages.clients.refreshList': 'Recarregar dados',
  'pages.clients.refreshListHint': 'Somente leitura — não altera usuário, senha ou validade',
  'pages.clients.deleteHint': 'Remover linha permanentemente',
  'pages.clients.linkPlan': 'Vincular plano ao cliente',
  'pages.clients.linkPlanHint': 'Migração — plano do catálogo Office (bouquets em Servidores)',
  'pages.clients.accessCreated': 'Acesso criado com sucesso!',
  'pages.clients.renewalDone': 'Renovação concluída!',
  'pages.clients.accessCreatedHint': 'Copie a mensagem abaixo ou envie direto no WhatsApp do cliente.',
  'pages.clients.password': 'Senha',
  'pages.clients.validity': 'Validade',
  'pages.clients.dns': 'DNS',
  'pages.clients.dnsMissing': 'Sem DNS configurada',
  'pages.clients.messageForClient': 'Mensagem para o cliente',
  'pages.clients.copyMessage': 'Copiar mensagem',
  'pages.clients.sendWhatsApp': 'Enviar WhatsApp',
  'pages.clients.migrationFilter': 'Migração ({n})',
  'pages.clients.migrationLinkedFilter': 'Vinculados ({n})',
  'pages.clients.migrationLinkedHint': '· {n} já vinculado(s) — filtro «Vinculados» na lista.',
  'pages.clients.migrationLinkedOnlyBanner': '{n} cliente(s) de migração já vinculados',
  'pages.clients.migrationLinkedOnlyHint': ' — use o relatório para conferir plano Sigma vs Office ou continue vinculando os pendentes.',
  'pages.clients.migrationBanner': '{n} cliente(s) de migração',
  'pages.clients.migrationBannerHint':
    ' — escolha um plano comercial (Familiar ou Adulto incluso) e sincronize para liberar o acesso.',
  'pages.clients.viewPending': 'Ver pendentes',
  'pages.clients.selectAll': 'Selecionar todos',
  'pages.clients.notReturned': 'Não retornado',

  'pages.servers.add': 'Adicionar servidor',
  'pages.servers.addShort': 'Adicionar',
  'pages.servers.editTitle': 'Editar servidor',
  'pages.servers.addTitle': 'Adicionar servidor',
  'pages.servers.subtitle':
    'Monitore hardware e nós, configure o DNS público dos clientes e a Admin API — sem misturar os dois.',
  'pages.servers.kpiConnected': 'Painéis conectados',
  'pages.servers.kpiConnectedHint': '{n} ativos na conta',
  'pages.servers.kpiConnectedEmpty': 'Nenhum painel',
  'pages.servers.kpiOnline': 'Online agora',
  'pages.servers.kpiOnlineHint': '{n} respondendo',
  'pages.servers.kpiOnlineEmpty': 'Aguardando painéis',
  'pages.servers.kpiConnections': 'Conexões Servidor (global)',
  'pages.servers.kpiConnectionsHint': 'Total do servidor — não é escopo Office · Capacidade {n}',
  'pages.servers.kpiCpu': 'CPU médio',
  'pages.servers.kpiCpuHint': '{n} canais ao vivo',
  'pages.servers.kpiCpuEmpty': 'Hardware do painel',
  'pages.servers.monitorTitle': 'Monitoramento em tempo real',
  'pages.servers.monitorSub':
    'Hardware do painel e conexões globais do servidor. Use Sincronizar para atualizar o espelho Office (inventário de clientes e revendas).',
  'pages.servers.syncHelpTitle': 'O que faz a sincronização?',
  'pages.servers.syncHelpBody':
    'Consulta a Admin API do Servidor e atualiza o espelho local usado em Gestão → Clientes e na vinculação de planos. Não altera validades nem consome créditos — apenas reflete o estado reportado pelo servidor.',
  'pages.servers.syncHelpLive':
    'Para ver quem está assistindo agora (sessões IPTV ativas na sua árvore Office), abra Gestão → Clientes conectados — não use o número «Conexões Servidor (global)» desta página.',
  'pages.servers.tableName': 'Nome',
  'pages.servers.tableDns': 'DNS padrão',
  'pages.servers.tableAdmin': 'Admin API',
  'pages.servers.tableStatus': 'Situação',
  'pages.servers.tableLast': 'Última leitura',
  'pages.servers.tableActions': 'Ações',
  'pages.servers.statusActive': 'Ativo',
  'pages.servers.statusPending': 'Pendente',
  'pages.servers.statusOffline': 'Offline',
  'pages.servers.relayOk': 'Servidor Relay ativo',
  'pages.servers.relayBad': 'Servidor Relay inativo',
  'pages.servers.relayWarn': 'Servidor Relay não configurado',
  'pages.servers.dnsMissing': 'Sem DNS configurada',
  'pages.servers.save': 'Salvar',
  'pages.servers.cancel': 'Cancelar',
  'pages.servers.sectionApi': 'Conexão Admin API',
  'pages.servers.sectionApiHint':
    'Usada só pelo Office para gerir o painel. Não aparece nas mensagens ao cliente.',
  'pages.servers.sectionDns': 'DNS padrão (clientes)',
  'pages.servers.sectionDnsHint':
    'Usado nos planos sem DNS próprio. Se vazio (e sem DNS global), as mensagens mostram Sem DNS configurada — o domínio da Admin API nunca é usado.',
  'pages.servers.sectionBouquets': 'Bouquets padrão (catálogo)',
  'pages.servers.sectionBouquetsHint':
    'O catálogo Office usa só estes bouquets — não o catálogo completo do Servidor.',
  'pages.servers.sectionRelay': 'Dragon Tech Relay e estado',
  'pages.servers.serverName': 'Nome do servidor',
  'pages.servers.adminUrl': 'URL Admin API *',
  'pages.servers.apiKeyKeep': 'API Key (vazio = manter)',
  'pages.servers.apiKeyRequired': 'API Key *',
  'pages.servers.apiVersion': 'Versão da API',
  'pages.servers.dnsPublic': 'DNS / URL pública',
  'pages.servers.dnsEmptyHint': 'Sem DNS configurada — defina um DNS público antes de gerar acessos.',
  'pages.servers.dnsOkHint': 'Fallback dos planos: {dns}',
  'pages.servers.listBouquets': 'Listar',
  'pages.servers.serverActive': 'Servidor ativo',
  'pages.servers.relayMode': 'Modo de conexão',
  'pages.servers.update': 'Sincronizar',
  'pages.servers.edit': 'Editar',
  'pages.servers.openPanel': 'Abrir painel',
  'pages.servers.test': 'Testar',
  'pages.servers.network': 'Rede',
  'pages.servers.panelList': 'Servidores',
  'pages.servers.connectedN': '{n} conectado(s)',
  'pages.servers.emptyTitle': 'Nenhum servidor conectado ainda',
  'pages.servers.emptyHint': 'Cole a URL do painel e a API Key do código de acesso (Admin API).',
  'pages.servers.addFirst': 'Adicionar o primeiro',
  'pages.servers.descRelay':
    'Dragon Tech Relay: {status}. Informe a Admin API apenas para o Office — o DNS público dos clientes é outro campo.',
  'pages.servers.descNoRelay':
    'Informe a Admin API do painel. O DNS público dos clientes é configurado à parte — nunca use o domínio da Admin API.',

  'pages.tests.eyebrow': 'Gestão',
  'pages.tests.title': 'Testes',
  'pages.tests.subtitle':
    'Acessos de demonstração — separados dos clientes pagos, prontos para renovar e notificar.',
  'pages.tests.new': 'Novo teste',
  'pages.tests.empty': 'Nenhum teste encontrado',
  'pages.tests.emptyHint': 'Crie um acesso de demonstração para enviar ao prospect.',
  'pages.tests.loading': 'Carregando testes…',

  'pages.resellers.eyebrow': 'Gestão',
  'pages.resellers.title': 'Revendas',
  'pages.resellers.subtitle':
    'Rede de revendedores Servidor — créditos, status e métricas do painel num só lugar.',
  'pages.resellers.new': 'Nova revenda',
  'pages.resellers.referral': 'Link de indicação',
  'pages.resellers.empty': 'Nenhuma revenda encontrada',
  'pages.resellers.emptyHint': 'Cadastre uma nova revenda ou ajuste os filtros para começar.',
  'pages.resellers.loading': 'Carregando revendas…',
  'pages.resellers.search': 'Buscar por usuário, e-mail ou WhatsApp...',
  'pages.resellers.filterAll': 'Todos',
  'pages.resellers.filterActive': 'Ativos',
  'pages.resellers.filterInactive': 'Inativos',

  'chats.eyebrow': 'Atendimento',
  'chats.inbox': 'Caixa de entrada',
  'chats.inboxHint': 'Conversas WhatsApp em tempo real',
  'chats.sync.live': 'Tempo real',
  'chats.sync.liveHint': 'Canal ao vivo ativo — novas mensagens aparecem na hora.',
  'chats.sync.polling': 'Sincronizando',
  'chats.sync.pollingHint': 'Canal ao vivo indisponível — a lista atualiza automaticamente a cada ~8 s.',
  'chats.sync.reconnecting': 'Reconectando…',
  'chats.sync.reconnectingHint': 'Ligação instável por um instante — a recuperar automaticamente.',
  'chats.sync.syncing': 'Importando histórico',
  'chats.sync.syncingHint': 'WhatsApp importando conversas antigas — o tempo real volta quando terminar.',
  'chats.sync.delayed': 'Com atraso',
  'chats.sync.delayedHint': 'Há mais de 20 s sem atualização — clique em Atualizar ou verifique a conexão.',
  'chats.sync.waStale': 'WhatsApp sem receber',
  'chats.sync.waStaleHint':
    'Sessão ligada, mas o painel não recebe mensagens novas — a reparação automática está a actuar. Clique em Atualizar.',
  'chats.sync.waOffline': 'WhatsApp desconectado',
  'chats.sync.waOfflineHint': 'Nenhuma conexão WhatsApp ativa — mensagens do celular podem não chegar ao painel.',
  'chats.sync.offline': 'Sem conexão',
  'chats.sync.offlineHint': 'Sem internet ou servidor ocupado — a tentar recuperar automaticamente.',
  'chats.sync.updatedNow': 'Atualizado agora',
  'chats.sync.updatedAgo': 'Atualizado há {n} s',
  'chats.sync.refresh': 'Atualizar agora',
  "chats.sync.details": "Detalhes da conexão",
  "chats.filterConversations": "Filtrar conversas",
  "chats.moreFilters": "Outras conversas",
  "chats.chooseFilter": "Escolha um filtro",
  'chats.sync.waHistory': 'Sincronizar WhatsApp',
  'chats.sync.waHistoryHint': 'Importar mensagens da conexão ativa',
  'chats.sync.waHistoryHours': 'Últimas {n} horas',
  'chats.sync.waHistoryStarted': 'Sincronização das últimas {n}h iniciada',
  'chats.sync.waHistoryBusy': 'Sincronização já em andamento',
  'chats.sync.waHistoryOffline': 'WhatsApp não está conectado',
  'chats.sync.waHistoryError': 'Não foi possível iniciar a sincronização',
  'chats.sync.waHistoryNoConn': 'Nenhuma conexão WhatsApp disponível',
  'chats.conversations': 'Conversas',
  'chats.activeCount': '{n} ativas',
  'chats.unattendedCount': '{n} sem atendimento',
  'chats.emptyInbox': 'Caixa vazia',
  'chats.emptyInboxHint':
    'Quando chegar uma mensagem no WhatsApp, ela aparece aqui. Ou busque um contato do CRM para abrir o atendimento.',
  'chats.noWaTitle': 'WhatsApp não configurado',
  'chats.noWaHint':
    'Ainda não há nenhum número ligado nesta conta. Configure o WhatsApp para receber e responder mensagens aqui.',
  'chats.noWaCta': 'Configurar WhatsApp',
  'chats.emptyGroups': 'Nenhum grupo ativo',
  'chats.noneFound': 'Nenhuma conversa encontrada',
  'chats.noneFoundHint': 'Tente outro termo — ou abra um contato do CRM abaixo.',
  'chats.crmHitsTitle': 'Contatos do CRM',
  'chats.crmHitsLoading': 'Buscando contatos…',
  'chats.crmHitsNone': 'Nenhum contato CRM com esse termo.',
  'chats.openInOffice': 'Atendimento',
  'chats.openedFromCrm': 'Atendimento aberto no Office',
  'chats.openFromCrmFail': 'Não foi possível abrir o atendimento',
  'chats.search': 'Buscar conversa ou contato CRM…',
  'chats.loadingInbox': 'Carregando conversas…',
  'chats.loadFail': 'Falha ao carregar',
  'chats.retry': 'Tentar novamente',
  'chats.selectTitle': 'Selecione um atendimento',
  'chats.selectHint':
    'Escolha um contato na lista à esquerda. Use Cliente no cabeçalho para acesso, vendas e dados do contato.',
  'chats.chipShortcuts': 'Atalhos rápidos',
  'chats.chipCrm': 'Painel do cliente',
  'chats.chipRealtime': 'Tempo real',
  'chats.tabMine': 'Minhas',
  'chats.tabUnassigned': 'Sem atrib.',
  'chats.tabAll': 'Todas',
  'chats.tabGroups': 'Grupos',
  'chats.onlyUnattended': 'Só conversas não atendidas',
  'chats.clearJunk': 'Limpar lixo',
  'chats.clearAll': 'Limpar tudo',
  'chats.kpiActive': 'Conversas',
  'chats.kpiWaiting': 'Aguardando',
  'chats.stepPick': 'Escolha um contato na lista',
  'chats.stepCrm': 'Abra o painel do cliente no cabeçalho da conversa',
  'chats.stepReply': 'Responda em tempo real pelo compositor',
  'chats.ficha': 'Cliente',
  'chats.fichaTitle': 'Painel do cliente',
  'chats.backToInbox': 'Voltar à caixa de entrada',
  'chats.railPrev': 'Conversas anteriores',
  'chats.railNext': 'Mais conversas',
  'chats.today': 'Hoje',
  'chats.yesterday': 'Ontem',
  'chats.pressEnter': 'Enter envia · Shift+Enter nova linha',
  'chats.assignedTo': 'Com {n}',
  'chats.presenceOnline': 'Online',
  'chats.presenceOffline': 'Offline',
  'chats.system': 'Sistema',
  'chats.loadingOlder': 'Carregando anteriores…',
  'chats.loadOlder': 'Carregar mensagens anteriores',
  'chats.groupChip': 'Grupo',
  'chats.groupMembers': '{n} participantes',
  'chats.groupHint': 'Conversa em grupo no WhatsApp',
  'chats.groupLastFrom': 'Última de {n}',
  'ficha.tabAccess': 'Acesso',
  'ficha.tabCommercial': 'Comercial',
  'ficha.tabFinance': 'Financeiro',
  'ficha.tabContact': 'Contato',
  'ficha.accessEmptyTitle': 'Nenhum acesso vinculado',
  'ficha.accessEmptyHint':
    'Busque o usuário no Office/Servidor, verifique ou repare, vincule a esta conversa ou gere um acesso novo.',
  'ficha.searchUser': 'Buscar acesso',
  'ficha.searchPlaceholder': 'Usuário, WhatsApp ou ID…',
  'ficha.searchHint': 'Mínimo 2 caracteres. Resultados abaixo.',
  'ficha.searchMin': 'Digite pelo menos 3 caracteres.',
  'ficha.searchError': 'Não foi possível conectar ao Servidor.',
  'ficha.noResults': 'Nenhum usuário encontrado.',
  'ficha.link': 'Vincular',
  'ficha.linkError': 'Não foi possível vincular a linha.',
  'ficha.unlinkError': 'Não foi possível remover o vínculo.',
  'ficha.actionError': 'A ação no Servidor falhou.',
  'ficha.credential': 'Credencial',
  'ficha.username': 'Usuário',
  'ficha.password': 'Senha',
  'ficha.showPass': 'Mostrar senha',
  'ficha.hidePass': 'Ocultar senha',
  'ficha.expiry': 'Vencimento',
  'ficha.connections': 'Conexões',
  'ficha.screens': '{n} telas',
  'ficha.active': 'Ativo',
  'ficha.blocked': 'Bloqueado',
  'ficha.resetConn': 'Reiniciar conexões',
  'ficha.injectChat': 'Enviar no chat',
  'ficha.blockLine': 'Bloquear linha',
  'ficha.unblockLine': 'Desbloquear',
  'ficha.unlink': 'Desvincular',
  'ficha.copied': 'Copiado',
  'ficha.linked': 'Linha vinculada a esta conversa',
  'ficha.unlinked': 'Vínculo removido',
  'ficha.injected': 'Dados colocados no compositor',
  'ficha.goGenerate': 'Gerar um acesso novo',
  'ficha.accessMsg':
    '*DADOS DE ACESSO*\n\nUsuário: {user}\nSenha: {pass}\nValidade: {exp}\n\n_Resetamos sua conexão se precisar._',
  'ficha.referralTitle': 'Indicação e revenda',
  'ficha.referralHint': 'Copie o link de cadastro e envie ao futuro revendedor.',
  'ficha.copyLink': 'Copiar link',
  'ficha.invite': 'Enviar convite para revender',
  'ficha.referralMsg':
    '🚀 *CONVITE PARA SER UM REVENDEDOR {nome_office}*\n\nOlá! 👋\n\nTransforme oportunidades em resultados com uma plataforma completa, desenvolvida para facilitar sua operação e impulsionar seu crescimento.\n\nNa *{nome_office}*, você conta com um *Office exclusivo e totalmente próprio*, desenvolvido para oferecer uma experiência diferenciada — longe das plataformas genéricas e repetitivas do mercado.\n\n*Tudo o que você precisa em um único lugar:*\n\n✅ *Sistema CRM* para gerenciar seus clientes\n✅ *Gestão financeira* completa e organizada\n✅ *Integrações bancárias* para facilitar pagamentos e recebimentos\n✅ *Central de atendimento* integrada\n✅ *Ranking de desempenho* para acompanhar seus resultados\n✅ *Gestão de equipe* simples e eficiente\n✅ *Ativações rápidas* e gerenciamento de créditos\n✅ *Materiais exclusivos* para divulgação e revenda\n✅ *Suporte especializado* sempre que precisar\n\n📝 *Cadastre-se agora:*\n{url}\n\n*Seja {nome_office} e trabalhe com um Office realmente próprio, completo e diferente de tudo o que você já viu!* 🚀',
  'ficha.inviteSent': 'Convite enviado no WhatsApp.',
  'ficha.inviteSendFail': 'Não foi possível enviar o convite. A mensagem foi colocada no compositor.',
  'ficha.linkCopied': 'Link de indicação copiado',
  'ficha.refError': 'Não foi possível obter o código de indicação.',
  'ficha.generateTitle': 'Gerar linha',
  'ficha.generateHint':
    'Planos de cliente (checkout) e testes da Painel. Um teste fora do PIX também aparece aqui.',
  'ficha.pkgType': 'Tipo de pacote',
  'ficha.pkgAll': 'Todos',
  'ficha.pkgTrial': 'Teste',
  'ficha.pkgPaid': 'Final',
  'ficha.package': 'Pacote',
  'ficha.selectPlan': 'Selecione um plano…',
  'ficha.selectPlanFirst': 'Selecione um plano.',
  'ficha.noPlans': 'Sem planos neste filtro',
  'ficha.tryAll': 'Experimente o filtro Todos.',
  'ficha.generateSend': 'Gerar e enviar',
  'ficha.appTitle': 'Aplicativo do cliente',
  'ficha.appHint':
    'Defina o player liberado neste acesso. O WhatsApp recebe o bloco do app escolhido.',
  'ficha.loadingPkgs': 'Carregando pacotes…',
  'ficha.pkgError': 'Erro ao conectar ao Servidor.',
  'ficha.genError': 'Falha ao gerar a linha no Servidor.',
  'ficha.lineOk': 'Linha gerada.',
  'ficha.lineSent': 'Linha gerada e enviada no WhatsApp.',
  'ficha.lineSendFail': 'Linha gerada, mas o envio falhou. Clique em enviar no compositor.',
  'ficha.lineReady': 'Linha gerada.\nUsuário: {user}\nSenha: {pass}',
  'ficha.proofTitle': 'Comprovante e venda',
  'ficha.proofHint': 'Confira o comprovante, preencha os dados e confirme a baixa manualmente.',
  'ficha.dropTitle': 'Solte ou clique para selecionar o comprovante',
  'ficha.dropHint': 'PNG ou JPG — enviado somente ao confirmar a baixa',
  'ficha.saleData': 'Dados da venda',
  'ficha.amount': 'Valor',
  'ficha.method': 'Método',
  'ficha.txId': 'ID / comprovante',
  'ficha.pix': 'PIX',
  'ficha.credit': 'Crédito',
  'ficha.cash': 'Dinheiro',
  'ficha.matchSale': 'Venda correspondente',
  'ficha.settle': 'Dar baixa',
  'ficha.orNewSale': 'Ou registre como nova venda se for outro pagamento',
  'ficha.registerPaid': 'Registrar venda paga',
  'ficha.registerPending': 'Registrar venda pendente',
  'ficha.needAmount': 'Informe o valor da venda (maior que zero).',
  'ficha.needContact': 'Conversa sem contato vinculado — não foi possível registrar a venda.',
  'ficha.paidOkHint': 'Venda paga registrada. Confira em Financeiro → Visão ou Registros.',
  'ficha.pendingOkHint': 'Venda pendente registrada. Só entra no faturamento após dar baixa com comprovante.',
  'ficha.aiQuota': 'Limite da IA atingido. Tente mais tarde ou preencha valor e ID manualmente.',
  'ficha.receiptError': 'Erro ao processar o comprovante.',
  'ficha.finRegistered': 'Registrado para o financeiro.',
  'ficha.audit': 'Auditoria',
  'ficha.ocrFail': 'Não foi possível ler o comprovante com a IA.',
  'ficha.receiptOk': 'Comprovante processado.',
  'ficha.receiptNoSale': 'Comprovante lido. Nenhuma venda pendente correspondente.',
  'ficha.ocrManual': 'A IA não identificou valores — ajuste manualmente.',
  'ficha.needReceipt': 'Envie o comprovante antes de dar baixa.',
  'ficha.settled': 'Baixa concluída — comprovante no financeiro.',
  'ficha.settleError': 'Erro ao vincular a venda.',
  'ficha.paidOk': 'Venda registrada e paga com comprovante.',
  'ficha.pendingOk': 'Venda pendente registrada. Envie o comprovante para dar baixa.',
  'ficha.saveSaleError': 'Erro ao salvar a venda.',
  'ficha.saleViaChat': 'Venda via atendimento',
  'ficha.attendant': 'Atendente',
  'ficha.waOrigin': 'WhatsApp de origem',
  'ficha.group': 'Grupo',
  'ficha.copyPhone': 'Copiar telefone',
  'ficha.system': 'Sistema',
  'ficha.open': 'Aberto',
  'ficha.status': 'Status',
  'conv.status.open': 'Aberto',
  'conv.status.waiting': 'Aguardando',
  'conv.status.closed': 'Encerrado',
  'ficha.unknown': 'Contato',
  'chats.labelsTitle': 'Etiquetas',
  'chats.labelsHint': 'Marque esta conversa. Crie uma nova na hora, sem ir às configurações.',
  'chats.labelsCreateSection': 'Nova etiqueta',
  'chats.labelsPlaceholder': 'Nome da etiqueta',
  'chats.labelsCreate': 'Criar',
  'chats.labelsEmpty': 'Nenhuma etiqueta ainda',
  'chats.labelsEmptyHint': 'Escreva um nome, escolha a cor e crie. Ela já entra nesta conversa.',
  'chats.labelsApply': 'Aplicar',
  'chats.pastePrint': 'Print colado',
  'chats.pasteRemove': 'Remover print',
  'chats.pasteNotImage': 'A área de transferência não tem uma imagem.',
  'chats.captionPlaceholder': 'Legenda (opcional)…',
  'chats.typeMessage': 'Escreva uma mensagem…',
  'chats.fileSent': 'Arquivo enviado',
  'chats.fileSendError': 'Erro ao enviar arquivo',
  'chats.notifyTitle': 'Notificações',
  'chats.notifyShort': 'Sons',
  'chats.notifyHint':
    'Toques do atendimento e avisos na barra de notificações do celular e na área de trabalho.',
  'chats.notifyAllow': 'Permitir notificações',
  'chats.notifyAsking': 'A pedir permissão…',
  'chats.notifyAllowed':
    'Permissão concedida — avisos saem na barra do sistema. (O navegador não pede de novo se já autorizou.)',
  'chats.notifyDenied':
    'Bloqueadas neste navegador. Ative as notificações nas configurações do site.',
  'chats.notifyDeniedHelp':
    'No Chrome: cadeado na barra de endereço → Notificações → Permitir, depois recarregue a página.',
  'chats.notifyUnsupported': 'Este navegador não suporta avisos do sistema.',
  'chats.notifyNeedPerm': 'O navegador ainda não pediu permissão para avisar fora desta aba.',
  'chats.notifyPush': 'Avisos na tela',
  'chats.notifyPushHint':
    'Mostra na barra de notificações (celular) e na área de trabalho quando chega mensagem.',
  'chats.notifySounds': 'Toques',
  'chats.notifySoundsHint': 'Desative para silenciar todos os sons do atendimento.',
  'chats.notifyReceive': 'Receber mensagem',
  'chats.notifySend': 'Enviar mensagem',
  'chats.notifyAlert': 'Alerta do sistema',
  'chats.notifyOpenInbox': 'Abrir atendimentos',
  'chats.notifyTestPush': 'Avisos ativos. Novas mensagens aparecem aqui.',
  'chats.notifyTestRich':
    'Olá! Este é um exemplo de aviso de atendimento com telefone e horário.',
  'chats.notifyTestNow': 'Testar aviso agora',
  'chats.notifyTestOk': 'Aviso enviado. Se não aparecer, desative o Modo de concentração / Não incomodar no Windows.',
  'chats.notifyTestFail': 'Não foi possível mostrar o aviso. Recarregue a página e tente de novo.',
  'chats.notifyFocusHint':
    'Se o Centro de Notificações do Windows mostrar o ícone zzz (concentração), o sistema bloqueia os avisos do navegador.',
  'chats.notifyCatChat': 'Atendimento',
  'chats.notifyCatChatHint': 'Mensagens, anexos e escalações.',
  'chats.notifyCatTeam': 'Equipa',
  'chats.notifyCatTeamHint': 'Atendente online, pausa, offline e estados da revenda.',
  'chats.notifyCatCommerce': 'Vendas e créditos',
  'chats.notifyCatCommerceHint': 'PIX, compra/venda de créditos, renovação e faturamento do dia.',
  'chats.notifyBannerTitle': 'Não perca novas mensagens',
  'chats.notifyBannerHint': 'Ative os avisos do navegador para receber toque e alerta no celular e no computador, mesmo fora desta página.',
  'chats.notifyLater': 'Agora não',
  'chats.notifyNewMessage': 'Nova mensagem',
  'chats.notifyAttachment': 'Anexo',

  'vitrine.hiddenCheckout': 'Oculto no checkout',
  'vitrine.checkout': 'Checkout',
  'vitrine.dashboard': 'Painel',
  'vitrine.duration': 'Duração',
  'vitrine.price': 'Preço',
  'vitrine.onRequest': 'Sob consulta',
  'vitrine.search': 'Buscar plano…',
  'vitrine.filterTest': 'Teste',
  'vitrine.hintTrialOn':
    'Aparece na Painel (Teste) e no pop-up. Checkout pode ficar oculto.',
  'vitrine.hintTrialOff':
    'Plano de teste — ligue «Teste» no catálogo para a dashboard.',
  'vitrine.hintClient':
    'Um clique em Criar Cliente aplica este pacote — sem bouquet extra.',

  'league.kicker': 'Liga da semana',
  'league.title': 'Revendas em alta',
  'league.open': 'Ver ranking',
  'league.empty': 'Ainda ninguém pontuou esta semana.',
  'league.min': 'Entra na liga a partir de {n} clientes',
  'league.me': 'O seu ritmo',
  'league.unranked': 'Ainda fora da liga',
  'league.need': 'Faltam {n} clientes para entrar',
  'league.goalClients': 'Novos',
  'league.goalTests': 'Testes',
  'league.goalLogins': 'Logins',
  'league.bonusOn': 'Meta da semana: {n} créd.',
  'league.bonusGot': '{n} créd. creditados esta semana',
  'league.score': '{n} pts',
  'rank.global': 'Competição global',
  'rank.title': 'Ranking — Novos clientes',
  'rank.subtitle': 'Somente contas novas. Renovações não entram na disputa.',
  'rank.req': 'Requer {n}+ clientes para entrar',
  'rank.none': 'Nenhum revendedor atingiu {n} clientes ainda.',
  'rank.aspirantsTitle': 'Aspirantes — ainda bloqueados',
  'rank.aspirantsHint': 'Precisam atingir {n} clientes para desbloquear o ranking.',
  'rank.official': 'Classificação oficial',
  'rank.qualifiedN': '{n} qualificado(s)',
  'rank.newClients': 'novos clientes',
  'rank.totalClients': '{n} clientes totais',
  'rank.place': '{n}º lugar',
  'rank.forEntry': 'para entrar',
  'rank.notCounting': '{n} novos (ainda não conta)',
  'rank.settings': 'Liga e metas',
  'rank.settingsHint':
    'Defina o piso da classificação e o que a revenda precisa fazer na semana para ganhar créditos.',
  'rank.minClients': 'Piso para entrar (clientes totais)',
  'rank.goalClients': 'Meta semanal — novos clientes',
  'rank.goalTests': 'Meta semanal — testes gerados',
  'rank.goalLogins': 'Meta semanal — dias com login',
  'rank.bonusCredits': 'Pacote de créditos ao bater a meta',
  'rank.bonusOn': 'Pagar bônus automaticamente',
  'rank.bonusDays': 'Validade dos créditos (dias)',
  'rank.save': 'Salvar metas',
  'rank.saved': 'Metas da liga atualizadas',
  'rank.saveFail': 'Não foi possível salvar as metas',
  'rank.weekTitle': 'Calor da semana',
  'rank.weekHint':
    'Login diário, testes e ativações de clientes finais. Quem bate as três metas recebe o pacote.',
  'rank.loadFail': 'Falha ao carregar ranking',

  'settings.footer.brandHint':
    'Alterações de marca e aparência se aplicam ao escritório inteiro.',
  'settings.ops.active': 'Agente IA ativo',
  'settings.ops.activeHint': 'Quando ligado, você pode escrever em linguagem natural no Telegram.',
  'settings.ops.keyOk': 'OK',
  'settings.ops.keyMissing': 'Ausente',
  'settings.ops.keyLabel': 'Chave no bot',
  'settings.ops.service': 'Serviço',
  'settings.ops.refresh': 'Atualizar',
  'settings.ops.save': 'Salvar agente',
  'settings.ops.saved': 'Agente do bot Telegram atualizado',
  'settings.ops.saveFail': 'Erro ao salvar agente Telegram',
  'settings.ops.idsHint': 'Separados por vírgula. Só estes IDs controlam a VPS pelo bot.',
  'settings.ops.heartbeat': 'Relatório automático no Telegram',
  'settings.ops.heartbeatHint': 'Envia o status da VPS/Office periodicamente para o chat Ops.',
  'settings.ops.heartbeatInterval': 'Intervalo do relatório',
  'settings.ops.heartbeatIntervalHint': 'Quanto menor o intervalo, mais mensagens no Telegram.',
  'settings.ops.hbMin': '{n} minutos',
  'settings.ops.hb1h': '1 hora',
  'settings.ops.hbHours': '{n} horas',

  'settings.backup.title': 'Cópia de segurança externa',
  'settings.backup.tab': 'Cópia de segurança',
  'settings.backup.sub':
    'Cópia essencial e leve enviada ao Telegram. O arquivo temporário é apagado da VPS após a confirmação do envio.',
  'settings.backup.telegramOk': 'OK ({n} chat)',
  'settings.backup.telegramMissing': 'Bot Ops sem token/chat',
  'settings.backup.last': 'Último',
  'settings.backup.failed': 'Falhou',
  'settings.backup.auto': 'Cópia automática',
  'settings.backup.autoHint':
    'Roda sozinha no intervalo definido, envia para fora da VPS e mantém 8 registros.',
  'settings.backup.sendTg': 'Enviar para o Telegram',
  'settings.backup.sendTgHint':
    'Limite ~{mb} MB por arquivo. Acima disso o Office envia em várias partes (chat ou grupo). Se falhar, tenta de novo em minutos.',
  'settings.backup.interval': 'Intervalo',
  'settings.backup.interval30m': '30 minutos',
  'settings.backup.interval1h': '1 hora',
  'settings.backup.interval2h': '2 horas',
  'settings.backup.interval3h': '3 horas',
  'settings.backup.interval5h': '5 horas',
  'settings.backup.interval8h': '8 horas',
  'settings.backup.interval12h': '12 horas',
  'settings.backup.interval24h': '24 horas',
  'settings.backup.keepLocal': 'Manter local',
  'settings.backup.keepHistory': 'Histórico (registros)',
  'settings.backup.token': 'Token do bot Telegram',
  'settings.backup.tokenPhSet': 'Configurado ({masked}) — cole para substituir',
  'settings.backup.tokenPhEmpty': '123456:ABC… (ou deixe o token do Bot Ops)',
  'settings.backup.tokenHint':
    'Opcional se o Bot Ops já tiver token. Vazio ao salvar = mantém o atual.',
  'settings.backup.chats': 'Chat IDs Telegram',
  'settings.backup.chatsHint':
    'ID pessoal ou de grupo (grupos começam com -100…). Separados por vírgula. Adicione o bot ao grupo e dê permissão para enviar arquivos; o limite de tamanho é o mesmo (~49 MB/arquivo — cópias grandes vão em partes).',
  'settings.backup.refresh': 'Atualizar',
  'settings.backup.runNow': 'Gerar agora',
  'settings.backup.saveConfig': 'Salvar configuração',
  'settings.backup.restoreTitle': 'Restaurar cópia de segurança',
  'settings.backup.restoreSub':
    'Escolha um snapshot do histórico ou envie um .tgz baixado do Telegram. Digite RESTAURAR para confirmar.',
  'settings.backup.historySelect': 'Cópia do histórico',
  'settings.backup.select': 'Selecionar…',
  'settings.backup.confirm': 'Confirmação',
  'settings.backup.confirmPh': 'Digite RESTAURAR',
  'settings.backup.restoreSelected': 'Restaurar selecionado',
  'settings.backup.restoreFile': 'Restaurar de arquivo…',
  'settings.backup.historyRecent': 'Histórico recente',
  'settings.backup.historyEmpty': 'Ainda sem cópias registradas.',
  'settings.backup.statusOk': 'OK',
  'settings.backup.statusErr': 'Erro',
  'settings.backup.toastSaved': 'Cópia de segurança configurada',
  'settings.backup.toastSaveFail': 'Erro ao salvar configuração',
  'settings.backup.toastRunOk': 'Cópia criada e enviada ao Telegram',
  'settings.backup.toastRunFail': 'Falha na cópia de segurança',
  'settings.backup.toastPick': 'Escolha uma cópia do histórico',
  'settings.backup.toastConfirm': 'Digite RESTAURAR para confirmar',
  'settings.backup.confirmRestoreTitle': 'Restaurar cópia de segurança?',
  'settings.backup.confirmRestoreDesc':
    'Isso substitui a base de dados e as sessões WhatsApp pelo snapshot escolhido. Cópias antigas também podem restaurar uploads. O Office pode reiniciar serviços.',
  'settings.backup.confirmRestoreBtn': 'Restaurar agora',
  'settings.backup.toastRestoreOk':
    'Restauração concluída — faça login de novo se a sessão cair',
  'settings.backup.toastRestoreFail': 'Restauração falhou',
  'settings.backup.confirmFileTitle': 'Restaurar arquivo?',
  'settings.backup.confirmFileDesc':
    'Vai aplicar “{name}” como snapshot completo do Office.',
  'settings.backup.confirmFileBtn': 'Restaurar arquivo',
  'settings.backup.toastFileOk': 'Restauração a partir do arquivo concluída',
  'settings.backup.toastFileFail': 'Restauração por arquivo falhou',

  'meetings.title': 'Reuniões',
  'meetings.subtitle': 'Crie reuniões e compartilhe o link da sala com seus clientes',
  'meetings.eyebrow': 'Office',
  'meetings.heroKicker': 'Central de reuniões',
  'meetings.heroTitle': 'Tudo da sua agenda em um só lugar',
  'meetings.heroText':
    'Link público para revendedores, pedidos recebidos, disponibilidade semanal, convites e transmissões ao vivo — com vídeo LiveKit.',
  'meetings.resellerOnlyBadge': 'Agendamento só para revendas',
  'meetings.resellerTag': 'revenda',
  'meetings.policy.resellerTitle': 'Link público — só revendedores',
  'meetings.policy.resellerText':
    'Revendedores solicitam reunião pelo link /agendar. Após verificação de e-mail e WhatsApp, escolhem horário e recebem confirmação no Office e no WhatsApp.',
  'meetings.policy.attendantTitle': 'Atendentes — convocados por você',
  'meetings.policy.attendantText':
    'Atendentes não usam o link público. Crie a reunião confirmada aqui (nome + WhatsApp do atendente). Eles recebem pop-up, card no Painel e WhatsApp e entram marcando presença na sala.',
  'meetings.homeCard.kicker': 'Reunião convocada',
  'meetings.homeCard.title': 'Próxima reunião',
  'meetings.homeCard.hint': 'Confirme sua presença para entrar na sala de vídeo.',
  'meetings.homeCard.cta': 'Marcar presença e entrar',
  'meetings.homeCard.more': 'Ver Reuniões',
  'meetings.kpiLabel': 'Indicadores',
  'meetings.tab.overview': 'Visão geral',
  'meetings.tab.inbox': 'Pedidos',
  'meetings.tab.mine': 'Meus',
  'meetings.tab.availability': 'Agenda',
  'meetings.tab.lives': 'Transmissões',
  'meetings.overviewInbox': 'Fila rápida',
  'meetings.overviewInboxHint': '{pending} pendentes · {confirmed} confirmados',
  'meetings.bookingsHint': 'Confirme, remarque ou avise imprevistos — o revendedor recebe WhatsApp e pop-up.',
  'meetings.filter.all': 'Todos',
  'meetings.filter.pending': 'Pendentes',
  'meetings.filter.confirmed': 'Confirmados',
  'meetings.filter.unforeseen': 'Imprevistos',
  'meetings.filter.cancelled': 'Cancelados',
  'meetings.filter.completed': 'Concluídos',
  'meetings.delete': 'Excluir',
  'meetings.clearLives': 'Limpar transmissões',
  'meetings.clearFinished': 'Limpar finalizados',
  'meetings.confirmDeleteLive': 'Excluir a transmissão «{name}»?',
  'meetings.confirmDeleteBooking': 'Excluir permanentemente o pedido «{name}»?',
  'meetings.confirmClearLives': 'Remover todas as transmissões agendadas?',
  'meetings.confirmClearBookings': 'Remover pedidos cancelados, concluídos e imprevistos?',
  'meetings.toast.deleted': 'Excluído',
  'meetings.toast.liveDeleted': 'Transmissão excluída',
  'meetings.toast.cleared': '{n} item(ns) removido(s)',
  'meetings.weekdays': 'Dias ativos',
  'meetings.availabilityFoot':
    'Os dias marcados abrem slots de manhã (09–12) e tarde (14–18). Ajuste a duração e o fuso conforme a operação.',
  'meetings.liveList': 'Transmissões agendadas',
  'meetings.liveEmpty': 'Nenhuma transmissão agendada ainda.',
  'meetings.kpi.upcoming': 'Próximas',
  'meetings.kpi.pending': 'Pendentes',
  'meetings.kpi.completed': 'Concluídas',
  'meetings.kpi.lives': 'Transmissões',
  'meetings.publicLink': 'Link público de agendamento',
  'meetings.publicLinkHint': 'Clientes e parceiros escolhem horário e enviam o pedido.',
  'meetings.copyLink': 'Copiar link',
  'meetings.open': 'Abrir',
  'meetings.videoOn': 'Vídeo ativo',
  'meetings.videoOff': 'Vídeo pendente na VPS',
  'meetings.videoOffline': 'Servidor de vídeo offline',
  'meetings.broadcastTag': 'transmissão',
  'meetings.inviteTitle': 'Convocar reunião',
  'meetings.inviteHint': 'Selecione o contato do WhatsApp ou preencha manualmente. A reunião é criada já confirmada — o convidado recebe pop-up, card no Painel e mensagem no WhatsApp.',
  'meetings.contactPickLabel': 'Contato WhatsApp',
  'meetings.contactPickHint': 'Busque na lista de atendimentos ou contatos CRM — nome e telefone são preenchidos automaticamente.',
  'meetings.name': 'Nome',
  'meetings.phone': 'Telefone',
  'meetings.when': 'Quando',
  'meetings.createConfirmed': 'Criar reunião confirmada',
  'meetings.availability': 'Disponibilidade semanal',
  'meetings.availabilityHint': 'Fuso {tz} · slots de {min} min',
  'meetings.duration': 'Duração (min)',
  'meetings.timezone': 'Fuso horário',
  'meetings.save': 'Salvar',
  'meetings.saved': 'Disponibilidade salva',
  'meetings.bookings': 'Pedidos recebidos',
  'meetings.bookingsEmpty': 'Nenhum agendamento ainda.',
  'meetings.myBookings': 'Meus agendamentos',
  'meetings.myBookingsHint': 'Pedidos que você fez como revendedor neste Office',
  'meetings.myBookingsEmpty': 'Você ainda não tem pedidos de reunião',
  'meetings.confirm': 'Confirmar',
  'meetings.decline': 'Recusar',
  'meetings.enterRoom': 'Entrar na sala',
  'meetings.guestLink': 'Link do convidado',
  'meetings.resendWhatsApp': 'Reenviar WhatsApp',
  'meetings.waNotSent': 'WhatsApp não enviado',
  'meetings.complete': 'Concluir',
  'meetings.reschedule': 'Remarcar',
  'meetings.unforeseen': 'Imprevisto',
  'meetings.prompt.reschedule': 'Novo horário (AAAA-MM-DD HH:MM)',
  'meetings.prompt.reasonOptional': 'Observação (opcional)',
  'meetings.prompt.unforeseen': 'Descreva o imprevisto',
  'meetings.prompt.cancelReason': 'Motivo do cancelamento (opcional)',
  'meetings.liveTitle': 'Agendar transmissão',
  'meetings.liveHint': 'Transmissão para a rede com controle de oradores.',
  'meetings.liveName': 'Título',
  'meetings.liveDesc': 'Descrição',
  'meetings.createLive': 'Criar transmissão',
  'meetings.openLive': 'Abrir transmissão',
  'meetings.status.pending': 'Pendente',
  'meetings.status.confirmed': 'Confirmado',
  'meetings.status.cancelled': 'Cancelado',
  'meetings.status.completed': 'Concluído',
  'meetings.status.unforeseen': 'Imprevisto',
  'meetings.toast.confirmed': 'Confirmado — WhatsApp enviado ao revendedor',
  'meetings.toast.cancelled': 'Cancelado — revendedor notificado',
  'meetings.toast.rescheduled': 'Remarcado — revendedor notificado',
  'meetings.toast.unforeseen': 'Imprevisto registrado — revendedor notificado',
  'meetings.toast.updated': 'Atualizado',
  'meetings.toast.linkCopied': 'Link copiado',
  'meetings.toast.guestLinkCopied': 'Link da sala copiado — envie no WhatsApp',
  'meetings.toast.created': 'Reunião criada e confirmada',
  'meetings.toast.createdWa': 'Convite criado e enviado no WhatsApp',
  'meetings.toast.createdNoWa': 'Reunião criada, mas o WhatsApp não foi enviado — use Reenviar WhatsApp',
  'meetings.toast.needPhone': 'Informe o WhatsApp do convidado para enviar o convite',
  'meetings.toast.waResent': 'Convite reenviado no WhatsApp',
  'meetings.toast.waResendFail': 'Falha ao reenviar no WhatsApp',
  'meetings.toast.liveCreated': 'Transmissão criada',
  'meetings.toast.loadFail': 'Falha ao carregar reuniões',
  'meetings.toast.saveFail': 'Falha ao salvar',
  'meetings.toast.needInvite': 'Nome e horário obrigatórios',
  'meetings.toast.needLive': 'Título e data/hora obrigatórios',
  'meetings.room.floatKeep': 'Continuar em pop-up',
  'meetings.room.floatKeepShort': 'Pop-up',
  'meetings.room.floatTitle': 'Transmissão ao vivo',
  'meetings.room.floatExpand': 'Abrir sala',
  'meetings.room.tab.chat': 'Chat',
  'meetings.room.tab.audience': 'Audiência',
  'meetings.room.tab.network': 'Rede',
  'meetings.room.chatEmpty': 'Nenhuma mensagem ainda. Fale com a audiência aqui.',
  'meetings.room.chatPlaceholder': 'Escreva uma mensagem…',
  'meetings.room.audienceEmpty': 'Ninguém na sala no momento.',
  'meetings.room.micOff': 'Mic off',
  'meetings.room.net.quality': 'Qualidade',
  'meetings.room.net.uplink': 'Envio',
  'meetings.room.net.downlink': 'Receção',
  'meetings.room.net.rtt': 'Latência',
  'meetings.room.net.loss': 'Perda (pct)',
  'meetings.room.net.hint': 'Valores em tempo real via WebRTC. Preferível Wi-Fi estável ou cabo numa transmissão.',
  'meetings.room.net.excellent': 'Excelente',
  'meetings.room.net.good': 'Boa',
  'meetings.room.net.poor': 'Fraca',
  'meetings.room.net.lost': 'Perdida',
  'meetings.room.net.unknown': 'A medir…',
  'meetings.room.retry': 'Tentar de novo',
  'meetings.room.waiting': 'Aguardando vídeo ou compartilhamento…',
  'meetings.room.you': 'Você',
  'meetings.room.connected': 'conectada',
  'meetings.room.sharing': 'compartilhando tela',
  'meetings.room.screen': 'Tela compartilhada',
  'meetings.room.others': 'Participantes',
  'meetings.room.camOff': 'Câmera desligada',
  'meetings.room.shareStop': 'Parar tela',
  'meetings.room.shareShort': 'Tela',
  'meetings.room.hands': 'mãos: {list}',
  'meetings.room.inRoom': '{n} na sala',
  'meetings.room.back': 'Voltar',
  'meetings.room.connecting': 'Conectando à sala…',
  'meetings.room.title': 'Sala de reunião',
  'meetings.room.live': 'Transmissão ao vivo',
  'meetings.room.hangup': 'Sair',
  'meetings.room.mic': 'Microfone',
  'meetings.room.cam': 'Câmera',
  'meetings.room.share': 'Compartilhar tela ou janela',
  'meetings.room.hand': 'Levantar a mão',
  'meetings.room.role.host': 'Anfitrião',
  'meetings.room.role.guest': 'Convidado',
  'meetings.room.role.audience': 'Audiência',
  'meetings.room.role.speaker': 'Orador',
  'meetings.room.warn.mic': 'Microfone indisponível. Verifique a permissão do navegador.',
  'meetings.room.warn.cam':
    'Câmera indisponível. Continuando só com áudio — você pode ativar a câmera depois ou compartilhar a tela.',
  'meetings.room.warn.camRetry':
    'Não foi possível iniciar a câmera. Verifique as permissões e se outro app não a está usando.',
  'meetings.room.warn.share':
    'Não foi possível compartilhar a tela. Use HTTPS e permita a captura no navegador.',
  'meetings.room.err.livekit':
    'Vídeo ainda não está ativo nesta VPS. Configure o serviço LiveKit e as variáveis LIVEKIT_*.',
  'meetings.room.err.join': 'Falha ao entrar na sala',
  'meetings.room.err.signalTimeout':
    'Não foi possível conectar ao servidor de vídeo (tempo esgotado). Verifique se o LiveKit está ativo na VPS e se o Nginx permite WebSocket em /livekit/.',
  'meetings.room.err.connection': 'Falha na conexão com a sala de vídeo.',
  'meetings.room.err.troubleshoot':
    'Se o problema persistir, peça ao administrador para reiniciar o serviço LiveKit (docker) e conferir LIVEKIT_URL no backend.',
  'meetings.room.err.title': 'Não foi possível entrar',
};

const en = {
  'common.open': 'Open',
  'common.refresh': 'Refresh',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.total': 'Total',
  'common.online': 'Online',
  'common.clients': 'Clients',
  'common.more': 'More',
  'common.search': 'Search…',
  'common.all': 'All',
  'common.expiring': 'Expiring',
  'common.expired': 'Expired',
  'common.management': 'Management',

  'dash.eyebrow': 'Overview',
  'dash.welcome': 'Welcome back, {name}',
  'dash.subtitle':
    'Create tests and clients with the buttons. Below, a live pulse of your Office.',
  'dash.subtitleReseller':
    'Track clients, billing, and catalog for your network — all in one organized place.',
  'dash.sectionPerformance': 'Performance · 30 days',
  'dash.sectionOverview': 'Operational summary',
  'dash.sectionOperations': 'Operations & tools',
  'dash.execAria': 'Executive business overview',
  'dash.execKicker': 'Executive overview',
  'dash.execTitle': 'Your operation, ordered by priority',
  'dash.execSub': 'See what needs attention now and quickly access the most important workflows.',
  'dash.execActive': '{n} active clients',
  'dash.execExpiring': '{n} expire in 7 days',
  'dash.execChats': '{n} open conversations',
  'dash.manageRenewals': 'Manage renewals',
  'dash.clientsOverview': 'Client base',
  'dash.clientsOverviewHint': '{active} active · {expiring} expiring',
  'dash.toolsPanel': 'Tools',
  'dash.quickTest': 'Quick Test',
  'dash.newClient': 'New Client',
  'dash.periodLabel': 'Period',
  'dash.shortcuts': 'Shortcuts',
  'dash.periodPrev': 'Last month',
  'dash.period30d': '30 days',
  'dash.periodCur': 'Current month',
  'dash.revenuePeriod': 'Revenue · 30 days',
  'dash.salesCount': '{n} sales',
  'dash.last7d': 'Last 7 days',
  'dash.shortWindow': 'short window',
  'dash.today': 'Today',
  'dash.yesterday': 'Yesterday {value}',
  'dash.activeClients': 'Active clients',
  'dash.onlineNow': '{n} online now',
  'dash.noClientsOnline': 'No clients online',
  'dash.trialsExcluded': 'Trials are not included in this metric',
  'dash.infra': 'Servidor infra',
  'dash.servers': 'Servers',
  'dash.serversOnlineHint': '{n} online · stable link',
  'dash.connectPanel': 'Connect an Servidor panel',
  'dash.liveChannels': 'Live channels',
  'dash.activeStreams': 'Active streams',
  'dash.catalog': 'Content',
  'dash.contents': 'Contents',
  'dash.catalogHint': '{channels} channels · {movies} movies · {series} series',
  'dash.catalogHintScoped': '{channels} channels · {movies} movies · {series} series · standard bouquets',
  'dash.catalogHintEmpty': 'Configure standard bouquets in Servers',
  'dash.channels': 'Channels',
  'dash.movies': 'Movies',
  'dash.series': 'Series',
  'catalog.title': 'Content',
  'catalog.subtitle':
    'Browse channels, movies and series from standard bouquets and open the Web Player for desktop clients.',
  'catalog.eyebrow': 'IPTV',
  'catalog.openPlayer': 'Open Web Player',
  'catalog.heroKicker': 'Panel library',
  'catalog.heroTitle': 'Contents organized for your operation',
  'catalog.heroText':
    'Browse what the server offers. To watch on a computer, open the Web Player with the line username and password.',
  'catalog.statusReady': 'Catalog ready',
  'catalog.statusOffline': 'Servidor disconnected',
  'catalog.statusLoading': 'Loading…',
  'catalog.guideBouquets': 'Default bouquets',
  'catalog.guideBouquetsText':
    'Only contents from the bouquets set in Servers appear — not the full Servidor catalog.',
  'catalog.guideSearch': 'Quick search',
  'catalog.guideSearchText':
    'Filter by category or type a title to find channels, movies and series in seconds.',
  'catalog.guidePlayer': 'Web Player',
  'catalog.guidePlayerText':
    'Ideal for PC clients: open the player with the IPTV line and watch without an external app.',
  'catalog.inactiveTitle': 'Connect an Servidor panel to unlock the catalog',
  'catalog.inactiveText':
    'Without an active server, the Office cannot list channels, movies or series. Set up the Admin API and default bouquets to build this library.',
  'catalog.inactiveStep1': 'Open Servers and add (or enable) the Servidor panel',
  'catalog.inactiveStep2': 'Enter Admin URL, API key and public DNS',
  'catalog.inactiveStep3': 'Pick default bouquets and sync',
  'catalog.inactiveCta': 'Go to Servers',
  'catalog.inactiveHint':
    'After sync, totals and categories appear here automatically.',
  'catalog.statLive': 'Channels',
  'catalog.statMovies': 'Movies',
  'catalog.statSeries': 'Series',
  'catalog.tabLive': 'Live',
  'catalog.tabMovies': 'Movies',
  'catalog.tabSeries': 'Series',
  'catalog.searchPh': 'Search title…',
  'catalog.categories': 'Categories',
  'catalog.all': 'All',
  'catalog.showing': '{n} items',
  'catalog.showingZero': 'No results',
  'catalog.empty': 'No content in this category.',
  'catalog.emptyHint':
    'Try another category, clear the search, or check that default bouquets include this content type.',
  'catalog.loadError': 'Could not load the catalog.',
  'catalog.watch': 'Watch in Web Player',
  'catalog.loadMore': 'Load more',
  'catalog.channelInfo': 'Details',
  'catalog.liveHint': 'Live channel. Open the Web Player with the line username and password to watch.',
  'catalog.adultTitle': 'Restricted content (+18)',
  'catalog.adultCategory': 'Age rating',
  'catalog.adultMessage':
    'This content is not shown in the Office catalog per platform policy. To watch, open the Web Player with your IPTV line username and password.',
  'catalog.adultRestricted': 'Adult content (+18)',
  'catalog.retry': 'Try again',
  'catalog.openServers': 'Configure servers',
  'catalog.catsEmpty': 'Categories appear after syncing Servidor.',
  'catalog.gridHint': 'Click an item for details and to open the Web Player.',
  'dash.commercialNet': 'Commercial network',
  'dash.resellers': 'Resellers',
  'dash.resellersActiveHint': '{active} active of {total}',
  'dash.resellersOperationalHint': '{active} active of {total} · {review} historical records under review',
  'dash.migrationReview': 'History under review',
  'dash.awaitingActivation': 'Awaiting activation',
  'dash.resellerHierarchy': 'Reseller hierarchy',
  'dash.actives': 'Active',
  'dash.inventoryBase': 'Office base',
  'dash.awaitingSigma': 'Servidor panel inventory is not imported — sync Sigma to bring your clients.',
  'dash.expiring7d': 'Expiring · 7d',
  'dash.newInPeriod': 'New in 30 days',
  'dash.activeResellers': 'Active resellers',
  'dash.growthPeriod': 'Growth — 30 days',
  'dash.viewClients': 'View clients',
  'dash.activityPeriod': 'Activity · last 30 days',
  'dash.revenueInPeriod': 'Revenue in the last 30 days',
  'dash.clientBase30d': 'Customer base — 30 days',
  'dash.geoSection': 'Geographic presence',
  'dash.geoSectionSub': 'Focused on Brazil; the map expands when clients appear in other countries (real IP)',
  'dash.geoKicker': 'Map · Brazil focus',
  'dash.geoTitle': 'Client origins',
  'dash.geoMajority': 'Majority in {country} ({pct}%)',
  'dash.geoMapped': '{countries} countries · {online} online now',
  'dash.geoMappedStates': '{states} states · {online} online now',
  'dash.geoViewLive': 'Connected clients',
  'dash.geoLoading': 'Analyzing locations…',
  'dash.geoLoadingBrazil': 'Loading Brazil map…',
  'dash.geoMapLoadError': 'Could not load the Brazil map.',
  'dash.geoBrazilAria': 'Interactive Brazil map by state',
  'dash.geoMapCaption': 'Hover states · scroll to zoom',
  'dash.geoEmptyTitle': 'No client map yet',
  'dash.geoEmptySub':
    'When a client connects via the IPTV app (real IP), the map shows the state. Web Player connections use the VPS IP and are ignored.',
  'dash.geoClientsSuffix': ' clients',
  'dash.geoRankKicker': 'By origin',
  'dash.geoRankTitle': 'Top origins',
  'dash.geoRankStates': 'Top states',
  'dash.geoRankOnline': '{n} online',
  'dash.geoRankKnown': 'Last known IP',
  'dash.geoSideFoot': 'Real IP · Brazil states',
  'dash.clientRevenue30d': 'Client revenue — 30 days',
  'dash.paidRenewals': '{n} paid renewals',
  'dash.newClientsStable': '+{n} new · stable total',
  'dash.chartEmptyTitle': 'No activity in the last 30 days',
  'dash.chartEmptySub':
    'When there are sales or new clients, the chart shows cumulative growth.',
  'dash.awaitingActivity': 'Waiting for activity',
  'dash.clientBaseLegend': 'Cumulative base + new/day',
  'dash.chartBase': 'Base',
  'dash.chartNew': 'New',
  'dash.chartRevenue': 'Revenue',
  'dash.creditsKicker': 'Resellers · PIX',
  'dash.creditsTitle': 'Credit sales revenue',
  'dash.creditsBilled': 'Billed',
  'dash.creditsUnits': 'Units',
  'dash.viewSales': 'View sales',
  'dash.creditsEmptyTitle': 'No credit sales in the last 30 days',
  'dash.creditsEmptySub':
    'Packages bought by resellers via PIX appear here — revenue and credited units.',
  'dash.iptvOps': 'IPTV operations',
  'dash.renewRetention': 'Renewal & retention',
  'dash.renewHint':
    'Prioritize lines about to expire, recover expired ones and track who is online now.',
  'dash.baseHealth': 'Base health',
  'dash.activeSuffix': 'active',
  'dash.linesOf': '{active} of {total} lines',
  'dash.onlineNowLabel': 'Online now',
  'dash.inbox': 'Inbox',
  'dash.renewQueue': 'Renewal queue',
  'dash.renewQueueWarn':
    '{n} line(s) expiring in 7 days — contact and renew now.',
  'dash.renewQueueOk': 'No critical lines expiring. Keep your renewal rhythm.',
  'dash.openClients': 'Open clients',
  'dash.quickAnalysis': 'Quick analysis',
  'dash.analysisHint':
    'Generate a summary based on renewals, revenue and Servidor activity.',
  'dash.generating': 'Generating…',
  'dash.generateAnalysis': 'Generate analysis',
  'dash.dnsNotice': 'Notice — new DNS available',
  'dash.hideDns': 'Hide for 3 days',
  'dash.vodReleases': 'Featured catalog',
  'dash.vodHeadline': 'New picks for your customers',
  'dash.vodCopyReport': 'Copy highlights',
  'dash.vodSendWhatsApp': 'Share',
  'dash.vodCopied': 'Report copied!',
  'dash.vodCopyFail': 'Could not copy.',
  'dash.vodWhatsAppOpened': 'WhatsApp opened with the report.',
  'dash.vodWhatsAppPaste': 'Report copied! Paste into WhatsApp with Ctrl+V (too long for the share link).',
  'dash.vodReportTitle': 'NEW RELEASES — CATALOG',
  'dash.vodReportFooter': 'Check them out in the catalog!',
  'dash.vodCategory': 'Server category',
  'dash.vodCategoryUnknown': 'Category not set on the panel',
  'dash.vodGenre': 'Genre',
  'dash.vodRating': 'Rating',
  'dash.vodSynopsis': 'Synopsis',
  'dash.vodNoPlot': 'Synopsis unavailable for this title.',
  'dash.vodDirector': 'Director',
  'dash.vodCast': 'Cast',
  'dash.vodDuration': 'Runtime',
  'dash.vodDetailHint': 'Release details from the Servidor catalog',
  'dash.vodLocale': 'en-US',
  'dash.vodScrollPrev': 'Previous titles',
  'dash.vodScrollNext': 'More titles',
  'dash.aiBase':
    'Your base has {active} active clients of {total} total',
  'dash.aiExpiring': ', with {n} expiring in 7 days.',
  'dash.aiRevenue': ' Period revenue: {value}. ',
  'dash.aiAction':
    'Recommended action: contact expiring clients via WhatsApp and use the renewal flow.',
  'dash.aiKeep': 'Keep activation pace and monitor average ticket.',
  'dash.openArrow': 'Open',

  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.name': 'Name',
  'common.email': 'Email',
  'common.role': 'Role',
  'common.remove': 'Remove',

  'account.profileTitle': 'My profile',
  'account.profileHint': 'Your account details and profile photo.',
  'account.uploadPhoto': 'Upload photo',
  'account.fromEmail': 'From email',
  'account.fromEmailHint':
    'Looks up a public photo (Gravatar). Gmail/Google photos need Google sign-in or a manual upload.',
  'account.avatarHelp':
    'Prefer «Upload photo». «From email» only finds a photo if it exists on Gravatar (Gmail photos are not public from the address alone).',
  'account.settingsTitle': 'Settings',
  'account.settingsHint': 'Change your account password.',
  'account.currentPassword': 'Current password',
  'account.newPassword': 'New password',
  'account.confirmPassword': 'Confirm password',
  'account.confirmNewPassword': 'Confirm new password',
  'account.changePassword': 'Change password',
  'account.placeholderCurrent': 'Enter your current password',
  'account.placeholderNew': 'At least 8 characters',
  'account.placeholderConfirm': 'Repeat the new password',
  'account.role.user': 'User',
  'account.role.attendant': 'Agent',
  'pages.resellers.mfaOn': '2FA on',
  'pages.resellers.mfaOff': '2FA off',

  'sub.dashboard':
    'Real-time summary of your Office — clients, revenue and Servidor activity.',
  'sub.chats': 'Real-time WhatsApp conversations',
  'sub.finance': 'Office revenue, sales and financial movements.',
  'sub.financeLogs': 'All movements with custom filters.',
  'sub.globalLogs': 'All office actions in real time.',
  'sub.ranking': 'Weekly league, goals and new-client ranking.',
  'sub.templates': 'Reseller, credits and security WhatsApp notices.',
  'sub.buyCredits': 'Top up prepaid credits to operate the panel.',
  'sub.addBalance': 'Buy credits by PIX to keep your operation active.',
  'sub.clients':
    'Office IPTV lines — renew, notify and sync with Servidor in one place.',
  'sub.tests':
    'Demo access lines — separate from paid clients, ready to renew and notify.',
  'sub.resellers':
    'Servidor reseller network — credits, status and panel metrics in one place.',
  'sub.myPortfolio':
    'Relink clients missing from your list after migration — without changing passwords or disconnecting TVs.',
  'sub.categories':
    'What your network sells and trials — edit here; resellers just pick the card.',
  'sub.catalog':
    'Browse channels, movies and series from the Servidor panel — and open the Web Player for desktop clients.',
  'sub.whatsapp':
    'Connect Evolution numbers, scan the QR and sync history for support.',
  'sub.team': 'Members, roles and Office access.',
  'sub.teamMonitor':
    'Live clock-in, score, medical docs and attendant performance — auto-refreshes.',
  'sub.settings': 'Profile, security and visual identity of your Office.',
  'sub.communitySupport':
    'Community links, reseller support contact and info channel used in access messages.',
  'sub.servers': 'Connect, monitor and sync the panels used by your Office.',
  'sub.permissions':
    'Define what each profile sees — Servidor groups, templates and reseller exceptions.',
  'sub.leads': 'Office address book — numbers and stages stay in the CRM even if WhatsApp disconnects.',
  'sub.funnel':
    'Lead Kanban pipeline — drag between stages; every move is saved automatically.',
  'sub.planPricing':
    'What your network sells and trials — edit here; resellers just pick the card.',
  'sub.credentials': 'Default username and password when creating lines.',
  'sub.resellerModes': 'Set validity and Credit Mode rules for the network.',
  'sub.myResellerBilling':
    'Choose allowed modes for sub-resellers in your tree — does not affect the admin or other resellers.',
  'sub.gateway': 'Mercado Pago and other banks — PIX checkouts, credits and wallet.',
  'sub.creditPacks': 'Build the prepaid showcase resellers see in Buy credits.',
  'sub.checkoutNotif': 'Automatic payment notices at checkout.',
  'sub.salesMonitor':
    'Renewals, PIX and credits — buyer contact, WhatsApp and receipts when available.',
  'sub.creditLedger': 'IPTV wallet movements — debits, top-ups and refunds.',
  'sub.triggers': 'Configure automations and quick replies for WhatsApp support.',
  'sub.recuperacao':
    'Personalized WhatsApp campaigns with an AI agent, anti-block intervals and professional reports.',
  'sub.inactiveClients':
    'Expired lines, abandoned trials and expiring clients — notify or clean in bulk.',
  'sub.inactiveResellers':
    'Detect idle resellers, suspend on the Servidor panel and notify or bulk delete.',
  'sub.resellerMigration':
    'Import clients from M3U or Xtream URLs and validate them before creating anything.',
  'eyebrow.tools': 'Tools',
  'eyebrow.management': 'Management',
  'eyebrow.crm': 'Contacts',
  'eyebrow.ops': 'Operations',
  'eyebrow.config': 'Settings',
  'eyebrow.credits': 'Credits',
  'eyebrow.iptv': 'IPTV',
  'eyebrow.home': 'Overview',

  'pages.clients.eyebrow': 'Management',
  'pages.clients.title': 'Clients',
  'pages.clients.subtitle':
    'Office IPTV lines — renew, notify and sync with Servidor in one place.',
  'pages.clients.new': 'New Client',
  'pages.clients.search': 'Search by name, username or WhatsApp…',
  'pages.clients.empty': 'No clients found',
  'pages.clients.emptyHint': 'Adjust filters or create a new line to get started.',
  'pages.clients.syncing': 'Syncing clients…',
  'pages.clients.viewTable': 'Table view',
  'pages.clients.viewCards': 'Card view',
  'pages.clients.import': 'Import',
  'pages.clients.notify': 'Notify',
  'pages.clients.sheet': 'Profile',
  'pages.clients.moreActions': 'More actions',
  'pages.clients.user': 'User',
  'pages.clients.expiry': 'Expiry',
  'pages.clients.status': 'Status',
  'pages.clients.plan': 'Plan',
  'pages.clients.actions': 'Actions',
  'pages.clients.selected': '{n} selected',
  'pages.clients.clearSelection': 'Clear selection',
  'pages.clients.delete': 'Delete',
  'pages.clients.filterAll': 'All',
  'pages.clients.filterActive': 'Active',
  'pages.clients.filterExpiring': 'Expiring',
  'pages.clients.filterExpired': 'Expired',
  'pages.clients.statusActive': 'Active',
  'pages.clients.statusPaused': 'Paused',
  'pages.clients.statusExpired': 'Expired',
  'pages.clients.statusExpiring': 'Expiring',
  'pages.clients.lifetime': 'Lifetime',
  'pages.clients.created': 'Created {date}',
  'pages.clients.conn1': 'connection',
  'pages.clients.connN': 'connections',
  'pages.clients.panel': 'Panel',
  'pages.clients.kpiTotal': 'Total',
  'pages.clients.kpiActive': 'Active',
  'pages.clients.kpiExpiring': 'Expiring',
  'pages.clients.kpiExpired': 'Expired',
  'pages.clients.kpiTotalHint': 'lines in database',
  'pages.clients.kpiPctBase': '{n}% of base',
  'pages.clients.kpiExpiringHint': 'next 7 days',
  'pages.clients.actionsTitle': 'Client actions',
  'pages.clients.actionsDesc': 'Line {user}{plan}',
  'pages.clients.actionsDescEmpty': 'Choose an action for this line',
  'pages.clients.actionsGroupManage': 'Management',
  'pages.clients.actionsGroupComm': 'Communication & access',
  'pages.clients.actionsGroupOther': 'Other',
  'pages.clients.edit': 'Edit',
  'pages.clients.editHint': 'Details and notes',
  'pages.clients.sheetHint': 'Full profile',
  'pages.clients.renew': 'Renew',
  'pages.clients.renewHint': 'Extend expiry',
  'pages.clients.block': 'Block',
  'pages.clients.activate': 'Activate',
  'pages.clients.blockHint': 'Suspend access',
  'pages.clients.activateHint': 'Restore access',
  'pages.clients.notifyHint': 'Send via WhatsApp',
  'pages.clients.message': 'Message',
  'pages.clients.messageHint': 'Plan template',
  'pages.clients.copyPlaylist': 'Copy playlist',
  'pages.clients.copyPlaylistHint': 'User, password and DNS',
  'pages.clients.m3uOptions': 'M3U options',
  'pages.clients.m3uOptionsHint': 'Playlist links',
  'pages.clients.refreshList': 'Reload data',
  'pages.clients.refreshListHint': 'Read only — does not change username, password, or expiry',
  'pages.clients.deleteHint': 'Permanently remove line',
  'pages.clients.linkPlan': 'Link plan to client',
  'pages.clients.linkPlanHint': 'Migration — Office catalog plan (bouquets in Servers)',
  'pages.clients.accessCreated': 'Access created successfully!',
  'pages.clients.renewalDone': 'Renewal completed!',
  'pages.clients.accessCreatedHint': 'Copy the message below or send it on the client’s WhatsApp.',
  'pages.clients.password': 'Password',
  'pages.clients.validity': 'Expiry',
  'pages.clients.dns': 'DNS',
  'pages.clients.dnsMissing': 'No DNS configured',
  'pages.clients.messageForClient': 'Message for the client',
  'pages.clients.copyMessage': 'Copy message',
  'pages.clients.sendWhatsApp': 'Send WhatsApp',
  'pages.clients.migrationFilter': 'Migration ({n})',
  'pages.clients.migrationLinkedFilter': 'Linked ({n})',
  'pages.clients.migrationLinkedHint': '· {n} already linked — use the «Linked» filter in the list.',
  'pages.clients.migrationLinkedOnlyBanner': '{n} migration client(s) already linked',
  'pages.clients.migrationLinkedOnlyHint': ' — use the report to review Sigma vs Office plans or continue linking pending ones.',
  'pages.clients.migrationBanner': '{n} migration client(s)',
  'pages.clients.migrationBannerHint':
    ' — pick a commercial plan (Family or Adult included) and sync to unlock access.',
  'pages.clients.viewPending': 'View pending',
  'pages.clients.selectAll': 'Select all',
  'pages.clients.notReturned': 'Not returned',

  'pages.servers.add': 'Add Servidor server',
  'pages.servers.addShort': 'Add',
  'pages.servers.editTitle': 'Edit server',
  'pages.servers.addTitle': 'Add Servidor server',
  'pages.servers.subtitle':
    'Monitor hardware and nodes, set the public client DNS and Admin API — keep them separate.',
  'pages.servers.kpiConnected': 'Connected panels',
  'pages.servers.kpiConnectedHint': '{n} active on account',
  'pages.servers.kpiConnectedEmpty': 'No panels',
  'pages.servers.kpiOnline': 'Online now',
  'pages.servers.kpiOnlineHint': '{n} responding',
  'pages.servers.kpiOnlineEmpty': 'Waiting for panels',
  'pages.servers.kpiConnections': 'Servidor connections (global)',
  'pages.servers.kpiConnectionsHint': 'Full Servidor panel total — not Office scope · Capacity {n}',
  'pages.servers.kpiCpu': 'Average CPU',
  'pages.servers.kpiCpuHint': '{n} live channels',
  'pages.servers.kpiCpuEmpty': 'Panel hardware',
  'pages.servers.monitorTitle': 'Real-time monitoring',
  'pages.servers.monitorSub':
    'Panel hardware and global server connections. Use Sync to refresh the Office mirror (client and reseller inventory).',
  'pages.servers.syncHelpTitle': 'What does sync do?',
  'pages.servers.syncHelpBody':
    'Queries the Servidor Admin API and updates the local mirror used in Management → Clients and plan linking. Does not change expiry dates or consume credits — only reflects the server state.',
  'pages.servers.syncHelpLive':
    'To see who is watching now (active IPTV sessions in your Office tree), open Management → Connected clients — not the «Servidor connections (global)» number on this page.',
  'pages.servers.tableName': 'Name',
  'pages.servers.tableDns': 'Default DNS',
  'pages.servers.tableAdmin': 'Admin API',
  'pages.servers.tableStatus': 'Status',
  'pages.servers.tableLast': 'Last reading',
  'pages.servers.tableActions': 'Actions',
  'pages.servers.statusActive': 'Active',
  'pages.servers.statusPending': 'Pending',
  'pages.servers.statusOffline': 'Offline',
  'pages.servers.relayOk': 'Relay server active',
  'pages.servers.relayBad': 'Relay server inactive',
  'pages.servers.relayWarn': 'Relay server not configured',
  'pages.servers.dnsMissing': 'No DNS configured',
  'pages.servers.save': 'Save',
  'pages.servers.cancel': 'Cancel',
  'pages.servers.sectionApi': 'Admin API connection',
  'pages.servers.sectionApiHint':
    'Used only by the Office to manage the panel. Never shown in client messages.',
  'pages.servers.sectionDns': 'Default DNS (clients)',
  'pages.servers.sectionDnsHint':
    'Used for plans without their own DNS. If empty (and no global DNS), messages show No DNS configured — Admin API domain is never used.',
  'pages.servers.sectionBouquets': 'Default bouquets (catalog)',
  'pages.servers.sectionBouquetsHint':
    'The Office catalog uses only these bouquets — not the full Servidor catalog.',
  'pages.servers.sectionRelay': 'Dragon Tech Relay and status',
  'pages.servers.serverName': 'Server name',
  'pages.servers.adminUrl': 'Admin API URL *',
  'pages.servers.apiKeyKeep': 'API Key (empty = keep)',
  'pages.servers.apiKeyRequired': 'API Key *',
  'pages.servers.apiVersion': 'API version',
  'pages.servers.dnsPublic': 'DNS / public URL',
  'pages.servers.dnsEmptyHint': 'No DNS configured — set a public DNS before generating access.',
  'pages.servers.dnsOkHint': 'Plan fallback: {dns}',
  'pages.servers.listBouquets': 'List',
  'pages.servers.serverActive': 'Server active',
  'pages.servers.relayMode': 'Connection mode',
  'pages.servers.update': 'Sync',
  'pages.servers.edit': 'Edit',
  'pages.servers.openPanel': 'Open panel',
  'pages.servers.test': 'Test',
  'pages.servers.network': 'Network',
  'pages.servers.panelList': 'Servidor panels',
  'pages.servers.connectedN': '{n} connected',
  'pages.servers.emptyTitle': 'No Servidor panel connected yet',
  'pages.servers.emptyHint': 'Paste the panel URL and access-code API Key (Admin API).',
  'pages.servers.addFirst': 'Add the first one',
  'pages.servers.descRelay':
    'Dragon Tech Relay: {status}. Provide Admin API for the Office only — public client DNS is a separate field.',
  'pages.servers.descNoRelay':
    'Enter the panel Admin API. Public client DNS is configured separately — never use the Admin API domain.',

  'pages.tests.eyebrow': 'Management',
  'pages.tests.title': 'Trials',
  'pages.tests.subtitle':
    'Demo access lines — separate from paid clients, ready to renew and notify.',
  'pages.tests.new': 'New trial',
  'pages.tests.empty': 'No trials found',
  'pages.tests.emptyHint': 'Create a demo access to send to a prospect.',
  'pages.tests.loading': 'Loading trials…',

  'pages.resellers.eyebrow': 'Management',
  'pages.resellers.title': 'Resellers',
  'pages.resellers.subtitle':
    'Servidor reseller network — credits, status and panel metrics in one place.',
  'pages.resellers.new': 'New reseller',
  'pages.resellers.referral': 'Referral link',
  'pages.resellers.empty': 'No resellers found',
  'pages.resellers.emptyHint': 'Register a new reseller or adjust filters to get started.',
  'pages.resellers.loading': 'Loading resellers…',
  'pages.resellers.search': 'Search by user, email or WhatsApp...',
  'pages.resellers.filterAll': 'All',
  'pages.resellers.filterActive': 'Active',
  'pages.resellers.filterInactive': 'Inactive',

  'chats.eyebrow': 'Support',
  'chats.inbox': 'Inbox',
  'chats.inboxHint': 'Real-time WhatsApp conversations',
  'chats.sync.live': 'Live',
  'chats.sync.liveHint': 'Live channel active — new messages appear instantly.',
  'chats.sync.polling': 'Syncing',
  'chats.sync.pollingHint': 'Live channel unavailable — inbox refreshes automatically every ~8 s.',
  'chats.sync.reconnecting': 'Reconnecting…',
  'chats.sync.reconnectingHint': 'Brief connection hiccup — recovering automatically.',
  'chats.sync.syncing': 'Importing history',
  'chats.sync.syncingHint': 'WhatsApp is importing older chats — live updates resume when done.',
  'chats.sync.delayed': 'Delayed',
  'chats.sync.delayedHint': 'No update for 20+ s — click Refresh or check your connection.',
  'chats.sync.waStale': 'WhatsApp not receiving',
  'chats.sync.waStaleHint':
    'Session is connected, but the inbox is not getting new messages — auto-repair is running. Click Refresh.',
  'chats.sync.waOffline': 'WhatsApp offline',
  'chats.sync.waOfflineHint': 'No active WhatsApp connection — phone messages may not reach the inbox.',
  'chats.sync.offline': 'Offline',
  'chats.sync.offlineHint': 'No internet or busy server — retrying automatically.',
  'chats.sync.updatedNow': 'Updated just now',
  'chats.sync.updatedAgo': 'Updated {n} s ago',
  'chats.sync.refresh': 'Refresh now',
  "chats.sync.details": "Connection details",
  "chats.filterConversations": "Filter conversations",
  "chats.moreFilters": "Other conversations",
  "chats.chooseFilter": "Choose a filter",
  'chats.sync.waHistory': 'Sync WhatsApp',
  'chats.sync.waHistoryHint': 'Import messages from the active connection',
  'chats.sync.waHistoryHours': 'Last {n} hours',
  'chats.sync.waHistoryStarted': 'Sync for the last {n}h started',
  'chats.sync.waHistoryBusy': 'Sync already in progress',
  'chats.sync.waHistoryOffline': 'WhatsApp is not connected',
  'chats.sync.waHistoryError': 'Could not start sync',
  'chats.sync.waHistoryNoConn': 'No WhatsApp connection available',
  'chats.conversations': 'Conversations',
  'chats.activeCount': '{n} active',
  'chats.unattendedCount': '{n} unattended',
  'chats.emptyInbox': 'Inbox clear',
  'chats.emptyInboxHint':
    'When a WhatsApp message arrives, it shows up here. Or search a CRM contact to open the chat.',
  'chats.noWaTitle': 'WhatsApp not set up',
  'chats.noWaHint':
    'This account has no linked WhatsApp number yet. Connect WhatsApp to receive and reply to messages here.',
  'chats.noWaCta': 'Set up WhatsApp',
  'chats.emptyGroups': 'No active groups',
  'chats.noneFound': 'No conversations found',
  'chats.noneFoundHint': 'Try another term — or open a CRM contact below.',
  'chats.crmHitsTitle': 'CRM contacts',
  'chats.crmHitsLoading': 'Searching contacts…',
  'chats.crmHitsNone': 'No CRM contacts match that term.',
  'chats.openInOffice': 'Open chat',
  'chats.openedFromCrm': 'Chat opened in Office',
  'chats.openFromCrmFail': 'Could not open the chat',
  'chats.search': 'Search conversation or CRM contact…',
  'chats.loadingInbox': 'Loading conversations…',
  'chats.loadFail': 'Failed to load',
  'chats.retry': 'Try again',
  'chats.selectTitle': 'Select a conversation',
  'chats.selectHint':
    'Pick a contact from the list on the left. Use Client in the header for access, sales and contact data.',
  'chats.chipShortcuts': 'Quick shortcuts',
  'chats.chipCrm': 'Client panel',
  'chats.chipRealtime': 'Real time',
  'chats.tabMine': 'Mine',
  'chats.tabUnassigned': 'Unassigned',
  'chats.tabAll': 'All',
  'chats.tabGroups': 'Groups',
  'chats.onlyUnattended': 'Unattended only',
  'chats.clearJunk': 'Clear junk',
  'chats.clearAll': 'Clear all',
  'chats.kpiActive': 'Conversations',
  'chats.kpiWaiting': 'Waiting',
  'chats.stepPick': 'Pick a contact from the list',
  'chats.stepCrm': 'Open the client panel in the thread header',
  'chats.stepReply': 'Reply in real time with the composer',
  'chats.ficha': 'Client',
  'chats.fichaTitle': 'Client panel',
  'chats.backToInbox': 'Back to inbox',
  'chats.railPrev': 'Previous conversations',
  'chats.railNext': 'More conversations',
  'chats.today': 'Today',
  'chats.yesterday': 'Yesterday',
  'chats.pressEnter': 'Enter to send · Shift+Enter for a new line',
  'chats.assignedTo': 'With {n}',
  'chats.presenceOnline': 'Online',
  'chats.presenceOffline': 'Offline',
  'chats.system': 'System',
  'chats.loadingOlder': 'Loading earlier messages…',
  'chats.loadOlder': 'Load earlier messages',
  'chats.groupChip': 'Group',
  'chats.groupMembers': '{n} participants',
  'chats.groupHint': 'WhatsApp group conversation',
  'chats.groupLastFrom': 'Last from {n}',
  'ficha.tabAccess': 'Access',
  'ficha.tabCommercial': 'Sales',
  'ficha.tabFinance': 'Finance',
  'ficha.tabContact': 'Contact',
  'ficha.accessEmptyTitle': 'No line linked',
  'ficha.accessEmptyHint': 'Search the Servidor user or generate access in the Sales tab.',
  'ficha.searchUser': 'Search Servidor',
  'ficha.searchPlaceholder': 'Username, email or ID…',
  'ficha.searchHint': 'At least 3 characters. Results appear below.',
  'ficha.searchMin': 'Type at least 3 characters.',
  'ficha.searchError': 'Could not connect to Servidor.',
  'ficha.noResults': 'No users found.',
  'ficha.link': 'Link',
  'ficha.linkError': 'Could not link the line.',
  'ficha.unlinkError': 'Could not remove the link.',
  'ficha.actionError': 'The Servidor action failed.',
  'ficha.credential': 'Credential',
  'ficha.username': 'Username',
  'ficha.password': 'Password',
  'ficha.showPass': 'Show password',
  'ficha.hidePass': 'Hide password',
  'ficha.expiry': 'Expiry',
  'ficha.connections': 'Connections',
  'ficha.screens': '{n} screens',
  'ficha.active': 'Active',
  'ficha.blocked': 'Blocked',
  'ficha.resetConn': 'Restart connections',
  'ficha.injectChat': 'Send to chat',
  'ficha.blockLine': 'Block line',
  'ficha.unblockLine': 'Unblock',
  'ficha.unlink': 'Unlink',
  'ficha.copied': 'Copied',
  'ficha.linked': 'Line linked to this conversation',
  'ficha.unlinked': 'Link removed',
  'ficha.injected': 'Details placed in the composer',
  'ficha.goGenerate': 'Generate a new access',
  'ficha.accessMsg':
    '*ACCESS DETAILS*\n\nUser: {user}\nPassword: {pass}\nExpiry: {exp}\n\n_We can reset the connection if needed._',
  'ficha.referralTitle': 'Referral & resale',
  'ficha.referralHint': 'Copy the signup link and send it to a future reseller.',
  'ficha.copyLink': 'Copy link',
  'ficha.invite': 'Send reseller invite',
  'ficha.referralMsg':
    '🚀 *INVITE TO BECOME A {nome_office} RESELLER*\n\nHello! 👋\n\nTurn opportunities into results with a complete platform built to simplify your operation and drive growth.\n\nAt *{nome_office}*, you get your own *exclusive Office* — a differentiated experience, far from generic platforms.\n\n*Everything you need in one place:*\n\n✅ *CRM* to manage clients\n✅ Complete *financial management*\n✅ *Bank integrations* for payments\n✅ Integrated *support center*\n✅ *Performance ranking*\n✅ Simple *team management*\n✅ Fast activations and credit management\n✅ Exclusive *marketing materials*\n✅ Specialized *support*\n\n📝 *Sign up now:*\n{url}\n\n*Be {nome_office} and work with an Office that is truly your own!* 🚀',
  'ficha.inviteSent': 'Invite sent on WhatsApp.',
  'ficha.inviteSendFail': 'Could not send the invite. The message was placed in the composer.',
  'ficha.linkCopied': 'Referral link copied',
  'ficha.refError': 'Could not get the referral code.',
  'ficha.generateTitle': 'Generate line',
  'ficha.generateHint':
    'Client plans (checkout) and Panel tests. A test hidden from PIX still appears here.',
  'ficha.pkgType': 'Package type',
  'ficha.pkgAll': 'All',
  'ficha.pkgTrial': 'Trial',
  'ficha.pkgPaid': 'Paid',
  'ficha.package': 'Package',
  'ficha.selectPlan': 'Select a plan…',
  'ficha.selectPlanFirst': 'Select a plan.',
  'ficha.noPlans': 'No plans in this filter',
  'ficha.tryAll': 'Try the All filter.',
  'ficha.generateSend': 'Generate and send',
  'ficha.appTitle': 'Client app',
  'ficha.appHint':
    'Choose the player for this access. WhatsApp will include the selected app block.',
  'ficha.loadingPkgs': 'Loading packages…',
  'ficha.pkgError': 'Could not connect to Servidor.',
  'ficha.genError': 'Failed to generate the line on Servidor.',
  'ficha.lineOk': 'Line generated.',
  'ficha.lineSent': 'Line generated and sent on WhatsApp.',
  'ficha.lineSendFail': 'Line generated, but sending failed. Click send in the composer.',
  'ficha.lineReady': 'Line generated.\nUser: {user}\nPassword: {pass}',
  'ficha.proofTitle': 'Receipt and sale',
  'ficha.proofHint': 'Review the receipt, enter the details and confirm settlement manually.',
  'ficha.dropTitle': 'Drop or click to upload',
  'ficha.dropHint': 'PNG or JPG — one upload for audit and settlement',
  'ficha.saleData': 'Sale details',
  'ficha.amount': 'Amount',
  'ficha.method': 'Method',
  'ficha.txId': 'ID / receipt',
  'ficha.pix': 'PIX',
  'ficha.credit': 'Card',
  'ficha.cash': 'Cash',
  'ficha.matchSale': 'Matching sale',
  'ficha.settle': 'Settle',
  'ficha.orNewSale': 'Or register as a new sale if this is another payment',
  'ficha.registerPaid': 'Register paid sale',
  'ficha.registerPending': 'Register pending sale',
  'ficha.needAmount': 'Enter the sale amount (greater than zero).',
  'ficha.needContact': 'Conversation has no linked contact — could not register the sale.',
  'ficha.paidOkHint': 'Paid sale recorded. Check Finance → Overview or Logs.',
  'ficha.pendingOkHint': 'Pending sale recorded. It counts in billing only after receipt settlement.',
  'ficha.aiQuota': 'AI limit reached. Try later or fill amount and ID manually.',
  'ficha.receiptError': 'Could not process the receipt.',
  'ficha.finRegistered': 'Posted to finance.',
  'ficha.audit': 'Audit',
  'ficha.ocrFail': 'AI could not read the receipt.',
  'ficha.receiptOk': 'Receipt processed.',
  'ficha.receiptNoSale': 'Receipt read. No matching pending sale.',
  'ficha.ocrManual': 'AI did not find amounts — adjust manually.',
  'ficha.needReceipt': 'Upload the receipt before settling.',
  'ficha.settled': 'Settled — receipt is in finance.',
  'ficha.settleError': 'Could not link the sale.',
  'ficha.paidOk': 'Sale recorded and paid with receipt.',
  'ficha.pendingOk': 'Pending sale recorded. Upload the receipt to settle.',
  'ficha.saveSaleError': 'Could not save the sale.',
  'ficha.saleViaChat': 'Sale via inbox',
  'ficha.attendant': 'Agent',
  'ficha.waOrigin': 'WhatsApp origin',
  'ficha.group': 'Group',
  'ficha.copyPhone': 'Copy phone',
  'ficha.system': 'System',
  'ficha.open': 'Open',
  'ficha.status': 'Status',
  'conv.status.open': 'Open',
  'conv.status.waiting': 'Waiting',
  'conv.status.closed': 'Closed',
  'ficha.unknown': 'Contact',
  'chats.labelsTitle': 'Labels',
  'chats.labelsHint': 'Tag this conversation. Create a new label instantly — no settings page.',
  'chats.labelsCreateSection': 'New label',
  'chats.labelsPlaceholder': 'Label name',
  'chats.labelsCreate': 'Create',
  'chats.labelsEmpty': 'No labels yet',
  'chats.labelsEmptyHint': 'Type a name, pick a color and create. It is applied to this chat.',
  'chats.labelsApply': 'Apply',
  'chats.pastePrint': 'Screenshot pasted',
  'chats.pasteRemove': 'Remove screenshot',
  'chats.pasteNotImage': 'The clipboard does not contain an image.',
  'chats.captionPlaceholder': 'Caption (optional)…',
  'chats.typeMessage': 'Write a message…',
  'chats.fileSent': 'File sent',
  'chats.fileSendError': 'Failed to send file',
  'chats.notifyTitle': 'Notifications',
  'chats.notifyShort': 'Sounds',
  'chats.notifyHint':
    'Inbox tones and alerts on the phone notification bar and on the desktop.',
  'chats.notifyAllow': 'Allow notifications',
  'chats.notifyAsking': 'Requesting permission…',
  'chats.notifyAllowed':
    'Permission granted — alerts appear in the system tray. (The browser will not ask again if already allowed.)',
  'chats.notifyDenied': 'Blocked in this browser. Enable notifications in the site settings.',
  'chats.notifyDeniedHelp':
    'In Chrome: lock icon in the address bar → Notifications → Allow, then reload the page.',
  'chats.notifyUnsupported': 'This browser does not support system alerts.',
  'chats.notifyNeedPerm': 'The browser has not asked to notify outside this tab yet.',
  'chats.notifyPush': 'On-screen alerts',
  'chats.notifyPushHint':
    'Shows on the mobile notification bar and on the desktop when a message arrives.',
  'chats.notifySounds': 'Tones',
  'chats.notifySoundsHint': 'Turn off to mute every inbox sound.',
  'chats.notifyReceive': 'Incoming message',
  'chats.notifySend': 'Outgoing message',
  'chats.notifyAlert': 'System alert',
  'chats.notifyOpenInbox': 'Open inbox',
  'chats.notifyTestPush': 'Alerts are on. New messages will show up here.',
  'chats.notifyTestRich':
    'Hi! This is a sample inbox alert with phone and time.',
  'chats.notifyTestNow': 'Test alert now',
  'chats.notifyTestOk': 'Alert sent. If nothing appears, turn off Focus assist / Do Not Disturb on Windows.',
  'chats.notifyTestFail': 'Could not show the alert. Reload the page and try again.',
  'chats.notifyFocusHint':
    'If Windows Notification Center shows a zzz icon (Focus), the OS is blocking browser alerts.',
  'chats.notifyCatChat': 'Inbox',
  'chats.notifyCatChatHint': 'Messages, attachments and escalations.',
  'chats.notifyCatTeam': 'Team',
  'chats.notifyCatTeamHint': 'Attendant online, break, offline and reseller status.',
  'chats.notifyCatCommerce': 'Sales & credits',
  'chats.notifyCatCommerceHint': 'PIX, credit buy/sell, renewals and daily billing.',
  'chats.notifyBannerTitle': 'Don’t miss new messages',
  'chats.notifyBannerHint': 'Enable browser alerts to get sound and push on your phone and computer, even when this page is in the background.',
  'chats.notifyLater': 'Not now',
  'chats.notifyNewMessage': 'New message',
  'chats.notifyAttachment': 'Attachment',

  'vitrine.hiddenCheckout': 'Hidden from checkout',
  'vitrine.checkout': 'Checkout',
  'vitrine.dashboard': 'Dashboard',
  'vitrine.duration': 'Duration',
  'vitrine.price': 'Price',
  'vitrine.onRequest': 'On request',
  'vitrine.search': 'Search plan…',
  'vitrine.filterTest': 'Trial',
  'vitrine.hintTrialOn':
    'Shows on the dashboard (Quick Test) and in the pop-up. Checkout can stay hidden.',
  'vitrine.hintTrialOff':
    'Trial plan — turn on Quick Test in the catalog for the dashboard.',
  'vitrine.hintClient':
    'One click in Create Client applies this package — no extra bouquet.',

  'league.kicker': 'Weekly league',
  'league.title': 'Top resellers',
  'league.open': 'Open ranking',
  'league.empty': 'Nobody has scored this week yet.',
  'league.min': 'League unlocks at {n} clients',
  'league.me': 'Your pace',
  'league.unranked': 'Still outside the league',
  'league.need': '{n} more clients to enter',
  'league.goalClients': 'New',
  'league.goalTests': 'Trials',
  'league.goalLogins': 'Logins',
  'league.bonusOn': 'Weekly goal: {n} cr.',
  'league.bonusGot': '{n} cr. credited this week',
  'league.score': '{n} pts',
  'rank.global': 'Global competition',
  'rank.title': 'Ranking — New clients',
  'rank.subtitle': 'New accounts only. Renewals do not count.',
  'rank.req': 'Requires {n}+ clients to enter',
  'rank.none': 'No reseller has reached {n} clients yet.',
  'rank.aspirantsTitle': 'Challengers — still locked',
  'rank.aspirantsHint': 'They need {n} clients to unlock the ranking.',
  'rank.official': 'Official standings',
  'rank.qualifiedN': '{n} qualified',
  'rank.newClients': 'new clients',
  'rank.totalClients': '{n} total clients',
  'rank.place': '{n}st',
  'rank.forEntry': 'to enter',
  'rank.notCounting': '{n} new (not counting yet)',
  'rank.settings': 'League and goals',
  'rank.settingsHint':
    'Set the ranking floor and what a reseller must do this week to earn credits.',
  'rank.minClients': 'Entry floor (total clients)',
  'rank.goalClients': 'Weekly goal — new clients',
  'rank.goalTests': 'Weekly goal — trials generated',
  'rank.goalLogins': 'Weekly goal — days with login',
  'rank.bonusCredits': 'Credit pack when the goal is hit',
  'rank.bonusOn': 'Pay bonus automatically',
  'rank.bonusDays': 'Credit validity (days)',
  'rank.save': 'Save goals',
  'rank.saved': 'League goals updated',
  'rank.saveFail': 'Could not save the goals',
  'rank.weekTitle': 'This week’s heat',
  'rank.weekHint':
    'Daily login, trials and end-client activations. Hitting all three goals awards the pack.',
  'rank.loadFail': 'Failed to load ranking',

  'settings.footer.brandHint':
    'Brand and appearance changes apply to the entire office.',
  'settings.ops.active': 'AI agent enabled',
  'settings.ops.activeHint': 'When on, you can write in natural language on Telegram.',
  'settings.ops.keyOk': 'OK',
  'settings.ops.keyMissing': 'Missing',
  'settings.ops.keyLabel': 'Bot key',
  'settings.ops.service': 'Service',
  'settings.ops.refresh': 'Refresh',
  'settings.ops.save': 'Save agent',
  'settings.ops.saved': 'Telegram bot agent updated',
  'settings.ops.saveFail': 'Failed to save Telegram agent',
  'settings.ops.idsHint': 'Comma-separated. Only these IDs control the VPS via the bot.',
  'settings.ops.heartbeat': 'Automatic Telegram report',
  'settings.ops.heartbeatHint': 'Periodically sends VPS/Office status to the Ops chat.',
  'settings.ops.heartbeatInterval': 'Report interval',
  'settings.ops.heartbeatIntervalHint': 'Shorter intervals mean more Telegram messages.',
  'settings.ops.hbMin': '{n} minutes',
  'settings.ops.hb1h': '1 hour',
  'settings.ops.hbHours': '{n} hours',

  'settings.backup.title': 'External security copy',
  'settings.backup.tab': 'Security copy',
  'settings.backup.sub':
    'Lightweight core backup sent to Telegram. The temporary VPS file is deleted after upload confirmation.',
  'settings.backup.telegramOk': 'OK ({n} chat)',
  'settings.backup.telegramMissing': 'Ops bot missing token/chat',
  'settings.backup.last': 'Last',
  'settings.backup.failed': 'Failed',
  'settings.backup.auto': 'Automatic security copy',
  'settings.backup.autoHint':
    'Runs on schedule, sends the copy off the VPS, and keeps 8 records.',
  'settings.backup.sendTg': 'Send to Telegram',
  'settings.backup.sendTgHint':
    'Limit ~{mb} MB per file. Larger backups are split into parts (DM or group). On failure, retries in a few minutes.',
  'settings.backup.interval': 'Interval',
  'settings.backup.interval30m': '30 minutes',
  'settings.backup.interval1h': '1 hour',
  'settings.backup.interval2h': '2 hours',
  'settings.backup.interval3h': '3 hours',
  'settings.backup.interval5h': '5 hours',
  'settings.backup.interval8h': '8 hours',
  'settings.backup.interval12h': '12 hours',
  'settings.backup.interval24h': '24 hours',
  'settings.backup.keepLocal': 'Keep local',
  'settings.backup.keepHistory': 'History (records)',
  'settings.backup.token': 'Telegram bot token',
  'settings.backup.tokenPhSet': 'Configured ({masked}) — paste to replace',
  'settings.backup.tokenPhEmpty': '123456:ABC… (or leave the Ops bot token)',
  'settings.backup.tokenHint':
    'Optional if the Ops bot already has a token. Empty on save = keep current.',
  'settings.backup.chats': 'Telegram chat IDs',
  'settings.backup.chatsHint':
    'Personal or group id (groups start with -100…). Comma-separated. Add the bot to the group with permission to send files; size limit is the same (~49 MB/file — large copies go in parts).',
  'settings.backup.refresh': 'Refresh',
  'settings.backup.runNow': 'Generate now',
  'settings.backup.saveConfig': 'Save configuration',
  'settings.backup.restoreTitle': 'Restore security copy',
  'settings.backup.restoreSub':
    'Pick a history snapshot or upload a .tgz downloaded from Telegram. Type RESTAURAR to confirm.',
  'settings.backup.historySelect': 'History copy',
  'settings.backup.select': 'Select…',
  'settings.backup.confirm': 'Confirmation',
  'settings.backup.confirmPh': 'Type RESTAURAR',
  'settings.backup.restoreSelected': 'Restore selected',
  'settings.backup.restoreFile': 'Restore from file…',
  'settings.backup.historyRecent': 'Recent history',
  'settings.backup.historyEmpty': 'No security copies recorded yet.',
  'settings.backup.statusOk': 'OK',
  'settings.backup.statusErr': 'Error',
  'settings.backup.toastSaved': 'Security copy configured',
  'settings.backup.toastSaveFail': 'Error saving configuration',
  'settings.backup.toastRunOk': 'Copy created and sent to Telegram',
  'settings.backup.toastRunFail': 'Security copy failed',
  'settings.backup.toastPick': 'Choose a copy from history',
  'settings.backup.toastConfirm': 'Type RESTAURAR to confirm',
  'settings.backup.confirmRestoreTitle': 'Restore security copy?',
  'settings.backup.confirmRestoreDesc':
    'This replaces the database and WhatsApp sessions with the chosen snapshot. Older backups may also restore uploads. The Office may restart services.',
  'settings.backup.confirmRestoreBtn': 'Restore now',
  'settings.backup.toastRestoreOk':
    'Restore complete — sign in again if the session drops',
  'settings.backup.toastRestoreFail': 'Restore failed',
  'settings.backup.confirmFileTitle': 'Restore file?',
  'settings.backup.confirmFileDesc':
    'Will apply “{name}” as a full Office snapshot.',
  'settings.backup.confirmFileBtn': 'Restore file',
  'settings.backup.toastFileOk': 'Restore from file completed',
  'settings.backup.toastFileFail': 'Restore from file failed',
  'settings.backup.toastFileOk': 'File restore completed',
  'settings.backup.toastFileFail': 'File restore failed',

  'meetings.title': 'Meetings',
  'meetings.subtitle': 'Schedule, availability and video rooms for your network',
  'meetings.eyebrow': 'Office',
  'meetings.heroKicker': 'Meetings hub',
  'meetings.heroTitle': 'Your whole schedule in one place',
  'meetings.heroText':
    'Public reseller booking link, incoming requests, weekly availability, invites and lives — with LiveKit video.',
  'meetings.resellerOnlyBadge': 'Reseller booking only',
  'meetings.resellerTag': 'reseller',
  'meetings.policy.resellerTitle': 'Public link — resellers only',
  'meetings.policy.resellerText':
    'Resellers request meetings via the /schedule link. After email and WhatsApp verification they pick a slot and get confirmation in Office and WhatsApp.',
  'meetings.policy.attendantTitle': 'Agents — invited by you',
  'meetings.policy.attendantText':
    'Agents do not use the public link. Create a confirmed meeting here (name + agent WhatsApp). They get popup, dashboard card and WhatsApp and join by marking presence in the room.',
  'meetings.homeCard.kicker': 'Meeting invited',
  'meetings.homeCard.title': 'Next meeting',
  'meetings.homeCard.hint': 'Confirm your presence to join the video room.',
  'meetings.homeCard.cta': 'Mark presence and join',
  'meetings.homeCard.more': 'View Meetings',
  'meetings.kpiLabel': 'Indicators',
  'meetings.tab.overview': 'Overview',
  'meetings.tab.inbox': 'Requests',
  'meetings.tab.mine': 'Mine',
  'meetings.tab.availability': 'Schedule',
  'meetings.tab.lives': 'Lives',
  'meetings.overviewInbox': 'Quick queue',
  'meetings.overviewInboxHint': '{pending} pending · {confirmed} confirmed',
  'meetings.bookingsHint': 'Confirm, reschedule or flag issues — the reseller gets WhatsApp and a popup.',
  'meetings.filter.all': 'All',
  'meetings.filter.pending': 'Pending',
  'meetings.filter.confirmed': 'Confirmed',
  'meetings.filter.unforeseen': 'Unforeseen',
  'meetings.filter.cancelled': 'Cancelled',
  'meetings.filter.completed': 'Completed',
  'meetings.delete': 'Delete',
  'meetings.clearLives': 'Clear lives',
  'meetings.clearFinished': 'Clear finished',
  'meetings.confirmDeleteLive': 'Delete live «{name}»?',
  'meetings.confirmDeleteBooking': 'Permanently delete booking «{name}»?',
  'meetings.confirmClearLives': 'Remove all scheduled lives?',
  'meetings.confirmClearBookings': 'Remove cancelled, completed and unforeseen bookings?',
  'meetings.toast.deleted': 'Deleted',
  'meetings.toast.liveDeleted': 'Live deleted',
  'meetings.toast.cleared': '{n} item(s) removed',
  'meetings.weekdays': 'Active days',
  'meetings.availabilityFoot':
    'Selected days open morning (09–12) and afternoon (14–18) slots. Adjust duration and timezone to match operations.',
  'meetings.liveList': 'Scheduled lives',
  'meetings.liveEmpty': 'No lives created yet.',
  'meetings.kpi.upcoming': 'Upcoming',
  'meetings.kpi.pending': 'Pending',
  'meetings.kpi.completed': 'Completed',
  'meetings.kpi.lives': 'Lives',
  'meetings.publicLink': 'Public booking link',
  'meetings.publicLinkHint': 'Clients and partners pick a slot and send a request.',
  'meetings.copyLink': 'Copy link',
  'meetings.open': 'Open',
  'meetings.videoOn': 'Video active',
  'meetings.videoOff': 'Video pending on VPS',
  'meetings.videoOffline': 'Video server offline',
  'meetings.broadcastTag': 'broadcast',
  'meetings.inviteTitle': 'Invite to meeting',
  'meetings.inviteHint': 'Pick a WhatsApp contact or fill in manually. Creates as confirmed — guest gets pop-up, dashboard card and WhatsApp message.',
  'meetings.contactPickLabel': 'WhatsApp contact',
  'meetings.contactPickHint': 'Search inbox or CRM contacts — name and phone fill in automatically.',
  'meetings.name': 'Name',
  'meetings.phone': 'Phone',
  'meetings.when': 'When',
  'meetings.createConfirmed': 'Create confirmed meeting',
  'meetings.availability': 'Weekly availability',
  'meetings.availabilityHint': 'Timezone {tz} · {min} min slots',
  'meetings.duration': 'Duration (min)',
  'meetings.timezone': 'Timezone',
  'meetings.save': 'Save',
  'meetings.saved': 'Availability saved',
  'meetings.bookings': 'Incoming requests',
  'meetings.bookingsEmpty': 'No bookings yet.',
  'meetings.myBookings': 'My bookings',
  'meetings.myBookingsHint': 'Requests you made as a reseller in this Office',
  'meetings.myBookingsEmpty': 'You have no meeting requests yet',
  'meetings.confirm': 'Confirm',
  'meetings.decline': 'Decline',
  'meetings.enterRoom': 'Join room',
  'meetings.guestLink': 'Guest link',
  'meetings.resendWhatsApp': 'Resend WhatsApp',
  'meetings.waNotSent': 'WhatsApp not sent',
  'meetings.complete': 'Complete',
  'meetings.reschedule': 'Reschedule',
  'meetings.unforeseen': 'Unforeseen',
  'meetings.prompt.reschedule': 'New time (YYYY-MM-DD HH:MM)',
  'meetings.prompt.reasonOptional': 'Note (optional)',
  'meetings.prompt.unforeseen': 'Describe the issue',
  'meetings.prompt.cancelReason': 'Cancellation reason (optional)',
  'meetings.liveTitle': 'Propose live',
  'meetings.liveHint': 'Broadcast to your network with speaker controls.',
  'meetings.liveName': 'Title',
  'meetings.liveDesc': 'Description',
  'meetings.createLive': 'Create live',
  'meetings.openLive': 'Open live',
  'meetings.status.pending': 'Pending',
  'meetings.status.confirmed': 'Confirmed',
  'meetings.status.cancelled': 'Cancelled',
  'meetings.status.completed': 'Completed',
  'meetings.status.unforeseen': 'Unforeseen',
  'meetings.toast.confirmed': 'Confirmed — WhatsApp sent to reseller',
  'meetings.toast.cancelled': 'Cancelled — reseller notified',
  'meetings.toast.rescheduled': 'Rescheduled — reseller notified',
  'meetings.toast.unforeseen': 'Unforeseen noted — reseller notified',
  'meetings.toast.updated': 'Updated',
  'meetings.toast.linkCopied': 'Link copied',
  'meetings.toast.guestLinkCopied': 'Room link copied — send on WhatsApp',
  'meetings.toast.created': 'Meeting created and confirmed',
  'meetings.toast.createdWa': 'Invite created and sent on WhatsApp',
  'meetings.toast.createdNoWa': 'Meeting created, but WhatsApp was not sent — use Resend WhatsApp',
  'meetings.toast.needPhone': 'Enter the guest WhatsApp number to send the invite',
  'meetings.toast.waResent': 'Invite resent on WhatsApp',
  'meetings.toast.waResendFail': 'Failed to resend on WhatsApp',
  'meetings.toast.liveCreated': 'Live created',
  'meetings.toast.loadFail': 'Failed to load meetings',
  'meetings.toast.saveFail': 'Failed to save',
  'meetings.toast.needInvite': 'Name and time required',
  'meetings.toast.needLive': 'Title and date/time required',
  'meetings.room.floatKeep': 'Keep in pop-up',
  'meetings.room.floatKeepShort': 'Pop-up',
  'meetings.room.floatTitle': 'Live broadcast',
  'meetings.room.floatExpand': 'Open room',
  'meetings.room.tab.chat': 'Chat',
  'meetings.room.tab.audience': 'Audience',
  'meetings.room.tab.network': 'Network',
  'meetings.room.chatEmpty': 'No messages yet. Talk to the audience here.',
  'meetings.room.chatPlaceholder': 'Write a message…',
  'meetings.room.audienceEmpty': 'Nobody in the room right now.',
  'meetings.room.micOff': 'Mic off',
  'meetings.room.net.quality': 'Quality',
  'meetings.room.net.uplink': 'Upload',
  'meetings.room.net.downlink': 'Download',
  'meetings.room.net.rtt': 'Latency',
  'meetings.room.net.loss': 'Loss (pkts)',
  'meetings.room.net.hint': 'Real-time WebRTC stats. Prefer stable Wi-Fi or ethernet for lives.',
  'meetings.room.net.excellent': 'Excellent',
  'meetings.room.net.good': 'Good',
  'meetings.room.net.poor': 'Poor',
  'meetings.room.net.lost': 'Lost',
  'meetings.room.net.unknown': 'Measuring…',
  'meetings.room.title': 'Meeting room',
  'meetings.room.live': 'Live',
  'meetings.room.back': 'Back',
  'meetings.room.connecting': 'Connecting to room…',
  'meetings.room.connected': 'connected',
  'meetings.room.inRoom': '{n} in room',
  'meetings.room.you': 'You',
  'meetings.room.others': 'Participants',
  'meetings.room.camOff': 'Camera off',
  'meetings.room.mic': 'Microphone',
  'meetings.room.cam': 'Camera',
  'meetings.room.share': 'Share screen or window',
  'meetings.room.shareShort': 'Screen',
  'meetings.room.shareStop': 'Stop share',
  'meetings.room.shareOn': 'Screen sharing',
  'meetings.room.shareOff': 'Screen sharing stopped',
  'meetings.room.shareCancel': 'Screen sharing cancelled',
  'meetings.room.sharing': 'sharing screen',
  'meetings.room.screen': 'Shared screen',
  'meetings.room.waiting': 'Waiting for video or screen share…',
  'meetings.room.hand': 'Raise hand',
  'meetings.room.handOk': 'Hand raised — host notified',
  'meetings.room.hangup': 'Leave',
  'meetings.room.retry': 'Try again',
  'meetings.room.role.host': 'Host',
  'meetings.room.role.guest': 'Guest',
  'meetings.room.role.audience': 'Audience',
  'meetings.room.role.speaker': 'Speaker',
  'meetings.room.warn.mic': 'Microphone unavailable. Check browser permission.',
  'meetings.room.warn.cam':
    'Camera unavailable. Continuing with audio only — you can enable camera later or share your screen.',
  'meetings.room.warn.camRetry':
    'Could not start the camera. Check permissions and that another app is not using it.',
  'meetings.room.warn.share':
    'Could not share the screen. Use HTTPS and allow screen capture in the browser.',
  'meetings.room.err.livekit':
    'Video is not active on this VPS yet. Configure LiveKit and LIVEKIT_* env vars.',
  'meetings.room.err.join': 'Failed to join the room',
  'meetings.room.err.signalTimeout':
    'Could not connect to the video server (timed out). Check that LiveKit is running on the VPS and Nginx allows WebSocket on /livekit/.',
  'meetings.room.err.connection': 'Failed to connect to the video room.',
  'meetings.room.err.troubleshoot':
    'If the issue persists, ask the administrator to restart LiveKit (docker) and verify LIVEKIT_URL in the backend.',
  'meetings.room.err.title': 'Could not join',
  'meetings.room.hands': 'hands: {list}',
};

const es = {
  'common.open': 'Abrir',
  'common.refresh': 'Actualizar',
  'common.active': 'Activos',
  'common.inactive': 'Inactivos',
  'common.total': 'Total',
  'common.online': 'Online',
  'common.clients': 'Clientes',
  'common.more': 'Más',
  'common.search': 'Buscar…',
  'common.all': 'Todos',
  'common.expiring': 'Por vencer',
  'common.expired': 'Vencidos',
  'common.management': 'Gestión',

  'dash.eyebrow': 'Visión general',
  'dash.welcome': 'Bienvenido de nuevo, {name}',
  'dash.subtitle':
    'Genera pruebas y clientes con los botones. Abajo, el pulso del Office en tiempo real.',
  'dash.subtitleReseller':
    'Sigue clientes, facturación y catálogo de tu red — todo organizado en un solo lugar.',
  'dash.sectionPerformance': 'Desempeño · 30 días',
  'dash.sectionOverview': 'Resumen operativo',
  'dash.sectionOperations': 'Operación y herramientas',
  'dash.execAria': 'Visión ejecutiva del negocio',
  'dash.execKicker': 'Visión ejecutiva',
  'dash.execTitle': 'Tu operación, ordenada por prioridad',
  'dash.execSub': 'Consulta lo que requiere atención ahora y accede rápidamente a las rutinas más importantes.',
  'dash.execActive': '{n} clientes activos',
  'dash.execExpiring': '{n} vencen en 7 días',
  'dash.execChats': '{n} atenciones abiertas',
  'dash.manageRenewals': 'Gestionar renovaciones',
  'dash.clientsOverview': 'Base de clientes',
  'dash.clientsOverviewHint': '{active} activos · {expiring} por vencer',
  'dash.toolsPanel': 'Herramientas',
  'dash.quickTest': 'Prueba rápida',
  'dash.newClient': 'Nuevo cliente',
  'dash.periodLabel': 'Período',
  'dash.shortcuts': 'Atajos',
  'dash.periodPrev': 'Mes pasado',
  'dash.period30d': '30 días',
  'dash.periodCur': 'Mes actual',
  'dash.revenuePeriod': 'Facturación · 30 días',
  'dash.salesCount': '{n} ventas',
  'dash.last7d': 'Últimos 7 días',
  'dash.shortWindow': 'ventana corta',
  'dash.today': 'Hoy',
  'dash.yesterday': 'Ayer {value}',
  'dash.activeClients': 'Clientes activos',
  'dash.onlineNow': '{n} online ahora',
  'dash.noClientsOnline': 'Ningún cliente online',
  'dash.trialsExcluded': 'Las pruebas no entran en este indicador',
  'dash.infra': 'Infra Servidor',
  'dash.servers': 'Servidores',
  'dash.serversOnlineHint': '{n} online · enlace estable',
  'dash.connectPanel': 'Conecta un panel Servidor',
  'dash.liveChannels': 'Canales en vivo',
  'dash.activeStreams': 'Streams activos',
  'dash.catalog': 'Contenidos',
  'dash.contents': 'Contenidos',
  'dash.catalogHint': '{channels} canales · {movies} películas · {series} series',
  'dash.catalogHintScoped': '{channels} canales · {movies} películas · {series} series · bouquets estándar',
  'dash.catalogHintEmpty': 'Configure bouquets estándar en Servidores',
  'dash.channels': 'Canales',
  'dash.movies': 'Películas',
  'dash.series': 'Series',
  'catalog.title': 'Contenidos',
  'catalog.subtitle':
    'Consulta canales, películas y series de los bouquets estándar y abre el Web Player para clientes de PC.',
  'catalog.eyebrow': 'IPTV',
  'catalog.openPlayer': 'Abrir Web Player',
  'catalog.heroKicker': 'Biblioteca del panel',
  'catalog.heroTitle': 'Contenidos organizados para tu operación',
  'catalog.heroText':
    'Explora lo que ofrece el servidor. Para ver en el PC, abre el Web Player con usuario y contraseña de la línea.',
  'catalog.statusReady': 'Catálogo listo',
  'catalog.statusOffline': 'Servidor desconectado',
  'catalog.statusLoading': 'Cargando…',
  'catalog.guideBouquets': 'Bouquets estándar',
  'catalog.guideBouquetsText':
    'Solo entran contenidos de los bouquets definidos en Servidores — no el catálogo Servidor completo.',
  'catalog.guideSearch': 'Búsqueda rápida',
  'catalog.guideSearchText':
    'Filtra por categoría o escribe el título para encontrar canales, películas y series en segundos.',
  'catalog.guidePlayer': 'Web Player',
  'catalog.guidePlayerText':
    'Ideal para clientes de PC: abre el player con la línea IPTV y mira sin app externa.',
  'catalog.inactiveTitle': 'Conecta el panel Servidor para liberar el catálogo',
  'catalog.inactiveText':
    'Sin un servidor activo, el Office no puede listar canales, películas ni series. Configura la API Admin y los bouquets estándar para montar esta biblioteca.',
  'catalog.inactiveStep1': 'Abre Servidores y añade (o activa) el panel Servidor',
  'catalog.inactiveStep2': 'Indica URL Admin, clave API y DNS público',
  'catalog.inactiveStep3': 'Elige los bouquets estándar y sincroniza',
  'catalog.inactiveCta': 'Ir a Servidores',
  'catalog.inactiveHint':
    'Tras la sincronización, los totales y las categorías aparecen aquí automáticamente.',
  'catalog.statLive': 'Canales',
  'catalog.statMovies': 'Películas',
  'catalog.statSeries': 'Series',
  'catalog.tabLive': 'En vivo',
  'catalog.tabMovies': 'Películas',
  'catalog.tabSeries': 'Series',
  'catalog.searchPh': 'Buscar título…',
  'catalog.categories': 'Categorías',
  'catalog.all': 'Todas',
  'catalog.showing': '{n} ítems',
  'catalog.showingZero': 'Sin resultados',
  'catalog.empty': 'Ningún contenido en esta categoría.',
  'catalog.emptyHint':
    'Prueba otra categoría, limpia la búsqueda o comprueba que los bouquets estándar incluyen este tipo de contenido.',
  'catalog.loadError': 'No se pudo cargar el catálogo.',
  'catalog.watch': 'Ver en Web Player',
  'catalog.loadMore': 'Cargar más',
  'catalog.channelInfo': 'Información',
  'catalog.liveHint': 'Canal en vivo. Abre el Web Player con usuario y contraseña de la línea para ver.',
  'catalog.adultTitle': 'Contenido restringido (+18)',
  'catalog.adultCategory': 'Clasificación etaria',
  'catalog.adultMessage':
    'Este contenido no se muestra en el catálogo Office por política de la plataforma. Para verlo, abre el Web Player con usuario y contraseña de la línea IPTV.',
  'catalog.adultRestricted': 'Contenido +18',
  'catalog.retry': 'Reintentar',
  'catalog.openServers': 'Configurar servidores',
  'catalog.catsEmpty': 'Las categorías aparecen tras sincronizar el Servidor.',
  'catalog.gridHint': 'Haz clic en un ítem para ver detalles y abrir el Web Player.',
  'dash.commercialNet': 'Red comercial',
  'dash.resellers': 'Revendedores',
  'dash.resellersActiveHint': '{active} activos de {total}',
  'dash.resellersOperationalHint': '{active} activos de {total} · {review} registros históricos en revisión',
  'dash.migrationReview': 'Historial en revisión',
  'dash.awaitingActivation': 'Pendientes de activación',
  'dash.resellerHierarchy': 'Jerarquía de revendedores',
  'dash.actives': 'Activas',
  'dash.inventoryBase': 'Base del Office',
  'dash.awaitingSigma': 'El inventario del panel Servidor no se importa — sincroniza Sigma para traer tus clientes.',
  'dash.expiring7d': 'Por vencer · 7d',
  'dash.newInPeriod': 'Nuevos en 30 días',
  'dash.activeResellers': 'Revendedores activos',
  'dash.growthPeriod': 'Crecimiento — 30 días',
  'dash.viewClients': 'Ver clientes',
  'dash.activityPeriod': 'Actividad · últimos 30 días',
  'dash.revenueInPeriod': 'Ingresos de los últimos 30 días',
  'dash.clientBase30d': 'Base de clientes — 30 días',
  'dash.geoSection': 'Presencia geográfica',
  'dash.geoSectionSub': 'Foco en Brasil; el mapa se amplía cuando hay clientes en otros países (IP real)',
  'dash.geoKicker': 'Mapa · foco Brasil',
  'dash.geoTitle': 'Origen de los clientes',
  'dash.geoMajority': 'Mayoría en {country} ({pct}%)',
  'dash.geoMapped': '{countries} países · {online} online ahora',
  'dash.geoMappedStates': '{states} estados · {online} online ahora',
  'dash.geoViewLive': 'Clientes conectados',
  'dash.geoLoading': 'Analizando ubicaciones…',
  'dash.geoLoadingBrazil': 'Cargando mapa de Brasil…',
  'dash.geoMapLoadError': 'No se pudo cargar el mapa de Brasil.',
  'dash.geoBrazilAria': 'Mapa interactivo de Brasil por estados',
  'dash.geoMapCaption': 'Pasa el ratón por los estados · usa la rueda para ampliar',
  'dash.geoEmptyTitle': 'Aún sin mapa de clientes',
  'dash.geoEmptySub':
    'Cuando un cliente se conecte por la app IPTV (IP real), el mapa muestra el estado. Las conexiones del Web Player usan la IP del VPS y se ignoran.',
  'dash.geoClientsSuffix': ' clientes',
  'dash.geoRankKicker': 'Estudio por origen',
  'dash.geoRankTitle': 'Top orígenes',
  'dash.geoRankStates': 'Principales estados',
  'dash.geoRankOnline': '{n} online',
  'dash.geoRankKnown': 'Último IP conocido',
  'dash.geoSideFoot': 'IP real · estados de Brasil',
  'dash.clientRevenue30d': 'Facturación de clientes — 30 días',
  'dash.paidRenewals': '{n} renovaciones pagadas',
  'dash.newClientsStable': '+{n} nuevos · acumulado estable',
  'dash.chartEmptyTitle': 'Sin movimiento en los últimos 30 días',
  'dash.chartEmptySub':
    'Cuando haya ventas o clientes nuevos, el gráfico muestra la evolución acumulada.',
  'dash.awaitingActivity': 'Esperando actividad',
  'dash.clientBaseLegend': 'Base acumulada + nuevos/día',
  'dash.chartBase': 'Base',
  'dash.chartNew': 'Nuevos',
  'dash.chartRevenue': 'Ingresos',
  'dash.creditsKicker': 'Revendedores · PIX',
  'dash.creditsTitle': 'Facturación de créditos',
  'dash.creditsBilled': 'Facturado',
  'dash.creditsUnits': 'Unidades',
  'dash.viewSales': 'Ver ventas',
  'dash.creditsEmptyTitle': 'Sin ventas de créditos en los últimos 30 días',
  'dash.creditsEmptySub':
    'Los paquetes comprados por revendedores vía PIX aparecen aquí — facturación y créditos acreditados.',
  'dash.iptvOps': 'Operación IPTV',
  'dash.renewRetention': 'Renovación y retención',
  'dash.renewHint':
    'Prioriza líneas por vencer, recupera vencidas y sigue quién está online ahora.',
  'dash.baseHealth': 'Salud de la base',
  'dash.activeSuffix': 'activos',
  'dash.linesOf': '{active} de {total} líneas',
  'dash.onlineNowLabel': 'Online ahora',
  'dash.inbox': 'Atenciones',
  'dash.renewQueue': 'Cola de renovación',
  'dash.renewQueueWarn':
    '{n} línea(s) por vencer en 7 días — contacta y renueva ahora.',
  'dash.renewQueueOk': 'Ninguna línea crítica por vencer. Mantén el ritmo de renovaciones.',
  'dash.openClients': 'Abrir clientes',
  'dash.quickAnalysis': 'Análisis rápido',
  'dash.analysisHint':
    'Genera un resumen con renovaciones, ingresos y actividad Servidor.',
  'dash.generating': 'Generando…',
  'dash.generateAnalysis': 'Generar análisis',
  'dash.dnsNotice': 'Aviso — nuevas DNS disponibles',
  'dash.hideDns': 'Ocultar por 3 días',
  'dash.vodReleases': 'Catálogo destacado',
  'dash.vodHeadline': 'Novedades para tus clientes',
  'dash.vodCopyReport': 'Copiar novedades',
  'dash.vodSendWhatsApp': 'Compartir',
  'dash.vodCopied': '¡Informe copiado!',
  'dash.vodCopyFail': 'No se pudo copiar.',
  'dash.vodWhatsAppOpened': 'WhatsApp abierto con el informe.',
  'dash.vodWhatsAppPaste': '¡Informe copiado! Pégalo en WhatsApp con Ctrl+V (el texto es demasiado largo para el enlace).',
  'dash.vodReportTitle': 'ESTRENOS — CATÁLOGO',
  'dash.vodReportFooter': '¡Míralos ya en el catálogo!',
  'dash.vodCategory': 'Categoría en el servidor',
  'dash.vodCategoryUnknown': 'Categoría no informada en el panel',
  'dash.vodGenre': 'Género',
  'dash.vodRating': 'Nota',
  'dash.vodSynopsis': 'Sinopsis',
  'dash.vodNoPlot': 'Sinopsis no disponible para este título.',
  'dash.vodDirector': 'Dirección',
  'dash.vodCast': 'Reparto',
  'dash.vodDuration': 'Duración',
  'dash.vodDetailHint': 'Detalles del estreno en el catálogo Servidor',
  'dash.vodLocale': 'es-ES',
  'dash.vodScrollPrev': 'Títulos anteriores',
  'dash.vodScrollNext': 'Más títulos',
  'dash.aiBase':
    'Tu base tiene {active} clientes activos de {total} en total',
  'dash.aiExpiring': ', con {n} por vencer en 7 días.',
  'dash.aiRevenue': ' Ingresos del período: {value}. ',
  'dash.aiAction':
    'Acción recomendada: contacta a los clientes por vencer por WhatsApp y usa el flujo de renovación.',
  'dash.aiKeep': 'Mantén el ritmo de activaciones y monitorea el ticket medio.',
  'dash.openArrow': 'Abrir',

  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.save': 'Guardar',
  'common.name': 'Nombre',
  'common.email': 'Email',
  'common.role': 'Función',
  'common.remove': 'Eliminar',

  'account.profileTitle': 'Mi perfil',
  'account.profileHint': 'Datos de tu cuenta y foto de perfil.',
  'account.uploadPhoto': 'Subir foto',
  'account.fromEmail': 'Del email',
  'account.fromEmailHint':
    'Busca foto pública (Gravatar). La foto de Gmail/Google solo entra con login Google o subida manual.',
  'account.avatarHelp':
    'Preferencia: usa «Subir foto». «Del email» solo encuentra foto si existe en Gravatar (la de Gmail no es pública solo con la dirección).',
  'account.settingsTitle': 'Configuración',
  'account.settingsHint': 'Cambia la contraseña de acceso a tu cuenta.',
  'account.currentPassword': 'Contraseña actual',
  'account.newPassword': 'Nueva contraseña',
  'account.confirmPassword': 'Confirmar contraseña',
  'account.confirmNewPassword': 'Confirmar nueva contraseña',
  'account.changePassword': 'Cambiar contraseña',
  'account.placeholderCurrent': 'Escribe tu contraseña actual',
  'account.placeholderNew': 'Mínimo 8 caracteres',
  'account.placeholderConfirm': 'Repite la nueva contraseña',
  'account.role.user': 'Usuario',
  'account.role.attendant': 'Agente',
  'pages.resellers.mfaOn': '2FA activo',
  'pages.resellers.mfaOff': '2FA desactivado',

  'sub.dashboard':
    'Resumen en tiempo real de tu Office — clientes, facturación y actividad Servidor.',
  'sub.chats': 'Conversaciones WhatsApp en tiempo real',
  'sub.finance': 'Ingresos, ventas y movimientos financieros del Office.',
  'sub.financeLogs': 'Todos los movimientos con filtros personalizados.',
  'sub.globalLogs': 'Todas las acciones del office en tiempo real.',
  'sub.ranking': 'Liga semanal, metas y ranking de clientes nuevos.',
  'sub.templates': 'Avisos WhatsApp de reventa, créditos y seguridad.',
  'sub.buyCredits': 'Recarga créditos prepago para operar en el panel.',
  'sub.addBalance': 'Recarga la cartera pospago por PIX. Cada crédito equivale a una activación.',
  'sub.clients':
    'Líneas IPTV de la oficina — renovar, notificar y sincronizar con Servidor en un solo lugar.',
  'sub.tests':
    'Accesos de demostración — separados de clientes de pago, listos para renovar y notificar.',
  'sub.resellers':
    'Red de revendedores Servidor — créditos, estado y métricas del panel en un solo lugar.',
  'sub.myPortfolio':
    'Vuelve a vincular clientes que desaparecieron de la lista tras la migración — sin cambiar contraseña ni cortar la TV.',
  'sub.categories':
    'Lo que vende y prueba tu red — edita aquí; la reventa solo elige la tarjeta.',
  'sub.catalog':
    'Explora canales, películas y series del panel Servidor — y abre el Web Player para clientes de PC.',
  'sub.whatsapp':
    'Conecta números Evolution, escanea el QR y sincroniza el historial para la atención.',
  'sub.team': 'Miembros, roles y acceso al Office.',
  'sub.teamMonitor':
    'Punto en tiempo real, score, atestados y rendimiento de los agentes — actualización automática.',
  'sub.settings': 'Perfil, seguridad e identidad visual de tu Office.',
  'sub.communitySupport':
    'Enlaces de la comunidad, contacto de soporte para revendedores y canal de información en los mensajes.',
  'sub.servers': 'Conecta, supervisa y sincroniza los paneles utilizados por tu Office.',
  'sub.permissions':
    'Define lo que cada perfil ve — grupos do Servidor, plantillas y excepciones por revendedor.',
  'sub.leads': 'Agenda del Office — números y etapas quedan en el CRM aunque se desconecte WhatsApp.',
  'sub.funnel':
    'Tablero de contactos — arrastra entre etapas; cada movimiento se guarda automáticamente.',
  'sub.planPricing':
    'Lo que vende y prueba tu red — edita aquí; la reventa solo elige la tarjeta.',
  'sub.credentials': 'Usuario y contraseña por defecto al crear líneas.',
  'sub.resellerModes': 'Opera solo prepago, solo pospago o ambos.',
  'sub.myResellerBilling':
    'Elige los modos permitidos para sub-revendedores de tu red — no afecta al administrador ni a otras revendas.',
  'sub.gateway': 'Mercado Pago y otros bancos — checkouts PIX, créditos y cartera.',
  'sub.creditPacks': 'Monte la vitrina prepago que ven los revendedores en Comprar créditos.',
  'sub.checkoutNotif': 'Avisos automáticos de pago en el checkout.',
  'sub.salesMonitor':
    'Renovaciones, PIX y créditos — contacto del comprador, WhatsApp y comprobantes cuando haya.',
  'sub.creditLedger': 'Movimientos de cartera IPTV — débitos, recargas y reembolsos.',
  'sub.triggers': 'Configura automatizaciones y respuestas rápidas para WhatsApp.',
  'sub.recuperacao':
    'Campañas personalizadas en WhatsApp con agente IA, intervalos anti-bloqueo e informes profesionales.',
  'sub.inactiveClients':
    'Líneas vencidas, pruebas abandonadas y clientes por vencer — notifica o limpia en masa.',
  'sub.inactiveResellers':
    'Detecta revendedores parados, suspende en el panel Servidor y notifica o elimina en masa.',
  'sub.resellerMigration':
    'Importa clientes desde URLs M3U o Xtream y valídalos antes de crear cualquier registro.',
  'eyebrow.tools': 'Herramientas',
  'eyebrow.management': 'Gestión',
  'eyebrow.crm': 'Agenda',
  'eyebrow.ops': 'Operación',
  'eyebrow.config': 'Configuración',
  'eyebrow.credits': 'Créditos',
  'eyebrow.iptv': 'IPTV',
  'eyebrow.home': 'Visión general',

  'pages.clients.eyebrow': 'Gestión',
  'pages.clients.title': 'Clientes',
  'pages.clients.subtitle':
    'Líneas IPTV de la oficina — renovar, notificar y sincronizar con Servidor en un solo lugar.',
  'pages.clients.new': 'Nuevo cliente',
  'pages.clients.search': 'Buscar por nombre, usuario o WhatsApp…',
  'pages.clients.empty': 'Ningún cliente encontrado',
  'pages.clients.emptyHint': 'Ajusta los filtros o registra una nueva línea para empezar.',
  'pages.clients.syncing': 'Sincronizando clientes…',
  'pages.clients.viewTable': 'Ver tabla',
  'pages.clients.viewCards': 'Ver tarjetas',
  'pages.clients.import': 'Importar',
  'pages.clients.notify': 'Notificar',
  'pages.clients.sheet': 'Ficha',
  'pages.clients.moreActions': 'Más acciones',
  'pages.clients.user': 'Usuario',
  'pages.clients.expiry': 'Vencimiento',
  'pages.clients.status': 'Situación',
  'pages.clients.plan': 'Plan',
  'pages.clients.actions': 'Acciones',
  'pages.clients.selected': '{n} seleccionado(s)',
  'pages.clients.clearSelection': 'Limpiar selección',
  'pages.clients.delete': 'Eliminar',
  'pages.clients.filterAll': 'Todos',
  'pages.clients.filterActive': 'Activos',
  'pages.clients.filterExpiring': 'Por vencer',
  'pages.clients.filterExpired': 'Vencidos',
  'pages.clients.statusActive': 'Activo',
  'pages.clients.statusPaused': 'Pausado',
  'pages.clients.statusExpired': 'Vencido',
  'pages.clients.statusExpiring': 'Por vencer',
  'pages.clients.lifetime': 'Vitalicio',
  'pages.clients.created': 'Creado {date}',
  'pages.clients.conn1': 'conexión',
  'pages.clients.connN': 'conexiones',
  'pages.clients.panel': 'Panel',
  'pages.clients.kpiTotal': 'Total',
  'pages.clients.kpiActive': 'Activos',
  'pages.clients.kpiExpiring': 'Por vencer',
  'pages.clients.kpiExpired': 'Vencidos',
  'pages.clients.kpiTotalHint': 'líneas en la base',
  'pages.clients.kpiPctBase': '{n}% de la base',
  'pages.clients.kpiExpiringHint': 'próximos 7 días',
  'pages.clients.actionsTitle': 'Acciones del cliente',
  'pages.clients.actionsDesc': 'Línea {user}{plan}',
  'pages.clients.actionsDescEmpty': 'Elige una acción para esta línea',
  'pages.clients.actionsGroupManage': 'Gestión',
  'pages.clients.actionsGroupComm': 'Comunicación y acceso',
  'pages.clients.actionsGroupOther': 'Otras',
  'pages.clients.edit': 'Editar',
  'pages.clients.editHint': 'Datos y observaciones',
  'pages.clients.sheetHint': 'Detalles completos',
  'pages.clients.renew': 'Renovar',
  'pages.clients.renewHint': 'Extender validez',
  'pages.clients.block': 'Bloquear',
  'pages.clients.activate': 'Activar',
  'pages.clients.blockHint': 'Suspender acceso',
  'pages.clients.activateHint': 'Reactivar acceso',
  'pages.clients.notifyHint': 'Enviar por WhatsApp',
  'pages.clients.message': 'Mensaje',
  'pages.clients.messageHint': 'Plantilla del plan',
  'pages.clients.copyPlaylist': 'Copiar playlist',
  'pages.clients.copyPlaylistHint': 'Usuario, contraseña y DNS',
  'pages.clients.m3uOptions': 'Opciones M3U',
  'pages.clients.m3uOptionsHint': 'Enlaces de lista',
  'pages.clients.refreshList': 'Recargar datos',
  'pages.clients.refreshListHint': 'Solo lectura: no cambia usuario, contraseña ni vencimiento',
  'pages.clients.deleteHint': 'Eliminar línea permanentemente',
  'pages.clients.linkPlan': 'Vincular plan al cliente',
  'pages.clients.linkPlanHint': 'Migración — plan del catálogo Office (bouquets en Servidores)',
  'pages.clients.accessCreated': '¡Acceso creado con éxito!',
  'pages.clients.renewalDone': '¡Renovación completada!',
  'pages.clients.accessCreatedHint': 'Copia el mensaje abajo o envíalo al WhatsApp del cliente.',
  'pages.clients.password': 'Contraseña',
  'pages.clients.validity': 'Validez',
  'pages.clients.dns': 'DNS',
  'pages.clients.dnsMissing': 'Sin DNS configurada',
  'pages.clients.messageForClient': 'Mensaje para el cliente',
  'pages.clients.copyMessage': 'Copiar mensaje',
  'pages.clients.sendWhatsApp': 'Enviar WhatsApp',
  'pages.clients.migrationFilter': 'Migración ({n})',
  'pages.clients.migrationLinkedFilter': 'Vinculados ({n})',
  'pages.clients.migrationLinkedHint': '· {n} ya vinculado(s) — filtro «Vinculados» en la lista.',
  'pages.clients.migrationLinkedOnlyBanner': '{n} cliente(s) de migración ya vinculados',
  'pages.clients.migrationLinkedOnlyHint': ' — usa el informe para revisar plan Sigma vs Office o sigue vinculando pendientes.',
  'pages.clients.migrationBanner': '{n} cliente(s) de migración',
  'pages.clients.migrationBannerHint':
    ' — elige un plan comercial (Familiar o Adulto incluido) y sincroniza para liberar el acceso.',
  'pages.clients.viewPending': 'Ver pendientes',
  'pages.clients.selectAll': 'Seleccionar todos',
  'pages.clients.notReturned': 'No devuelto',

  'pages.servers.add': 'Añadir servidor',
  'pages.servers.addShort': 'Añadir',
  'pages.servers.editTitle': 'Editar servidor',
  'pages.servers.addTitle': 'Añadir servidor',
  'pages.servers.subtitle':
    'Monitorea hardware y nodos, configura el DNS público de clientes y la Admin API — sin mezclarlos.',
  'pages.servers.kpiConnected': 'Paneles conectados',
  'pages.servers.kpiConnectedHint': '{n} activos en la cuenta',
  'pages.servers.kpiConnectedEmpty': 'Ningún panel',
  'pages.servers.kpiOnline': 'Online ahora',
  'pages.servers.kpiOnlineHint': '{n} respondiendo',
  'pages.servers.kpiOnlineEmpty': 'Esperando paneles',
  'pages.servers.kpiConnections': 'Conexiones Servidor (global)',
  'pages.servers.kpiConnectionsHint': 'Total del panel Servidor — no es alcance Office · Capacidad {n}',
  'pages.servers.kpiCpu': 'CPU medio',
  'pages.servers.kpiCpuHint': '{n} canales en vivo',
  'pages.servers.kpiCpuEmpty': 'Hardware del panel',
  'pages.servers.monitorTitle': 'Monitoreo en tiempo real',
  'pages.servers.monitorSub':
    'Hardware del panel y conexiones globales del servidor. Use Sincronizar para actualizar el espejo Office (inventario de clientes y revendedores).',
  'pages.servers.syncHelpTitle': '¿Qué hace la sincronización?',
  'pages.servers.syncHelpBody':
    'Consulta la Admin API del Servidor y actualiza el espejo local usado en Gestión → Clientes y la vinculación de planes. No altera vencimientos ni consume créditos — solo refleja el estado del servidor.',
  'pages.servers.syncHelpLive':
    'Para ver quién está viendo ahora (sesiones IPTV activas en su árbol Office), abra Gestión → Clientes conectados — no use el número «Conexiones Servidor (global)» de esta página.',
  'pages.servers.tableName': 'Nombre',
  'pages.servers.tableDns': 'DNS predeterminado',
  'pages.servers.tableAdmin': 'Admin API',
  'pages.servers.tableStatus': 'Situación',
  'pages.servers.tableLast': 'Última lectura',
  'pages.servers.tableActions': 'Acciones',
  'pages.servers.statusActive': 'Activo',
  'pages.servers.statusPending': 'Pendiente',
  'pages.servers.statusOffline': 'Offline',
  'pages.servers.relayOk': 'Servidor Relay activo',
  'pages.servers.relayBad': 'Servidor Relay inactivo',
  'pages.servers.relayWarn': 'Servidor Relay no configurado',
  'pages.servers.dnsMissing': 'Sin DNS configurada',
  'pages.servers.save': 'Guardar',
  'pages.servers.cancel': 'Cancelar',
  'pages.servers.sectionApi': 'Conexión Admin API',
  'pages.servers.sectionApiHint':
    'Usada solo por el Office para gestionar el panel. No aparece en mensajes al cliente.',
  'pages.servers.sectionDns': 'DNS predeterminado (clientes)',
  'pages.servers.sectionDnsHint':
    'Usado en planes sin DNS propio. Si está vacío (y sin DNS global), los mensajes muestran Sin DNS configurada — el dominio Admin API nunca se usa.',
  'pages.servers.sectionBouquets': 'Bouquets predeterminados (catálogo)',
  'pages.servers.sectionBouquetsHint':
    'El catálogo Office usa solo estos bouquets — no el catálogo completo del Servidor.',
  'pages.servers.sectionRelay': 'Dragon Tech Relay y estado',
  'pages.servers.serverName': 'Nombre del servidor',
  'pages.servers.adminUrl': 'URL Admin API *',
  'pages.servers.apiKeyKeep': 'API Key (vacío = mantener)',
  'pages.servers.apiKeyRequired': 'API Key *',
  'pages.servers.apiVersion': 'Versión de la API',
  'pages.servers.dnsPublic': 'DNS / URL pública',
  'pages.servers.dnsEmptyHint': 'Sin DNS configurada — define un DNS público antes de generar accesos.',
  'pages.servers.dnsOkHint': 'Fallback de planes: {dns}',
  'pages.servers.listBouquets': 'Listar',
  'pages.servers.serverActive': 'Servidor activo',
  'pages.servers.relayMode': 'Modo de conexión',
  'pages.servers.update': 'Sincronizar',
  'pages.servers.edit': 'Editar',
  'pages.servers.openPanel': 'Abrir panel',
  'pages.servers.test': 'Probar',
  'pages.servers.network': 'Red',
  'pages.servers.panelList': 'Paneles Servidor',
  'pages.servers.connectedN': '{n} conectado(s)',
  'pages.servers.emptyTitle': 'Ningún panel Servidor conectado aún',
  'pages.servers.emptyHint': 'Pega la URL del panel y la API Key del código de acceso (Admin API).',
  'pages.servers.addFirst': 'Añadir el primero',
  'pages.servers.descRelay':
    'Dragon Tech Relay: {status}. Indica la Admin API solo para el Office — el DNS público de clientes es otro campo.',
  'pages.servers.descNoRelay':
    'Indica la Admin API del panel. El DNS público de clientes se configura aparte — nunca uses el dominio Admin API.',

  'pages.tests.eyebrow': 'Gestión',
  'pages.tests.title': 'Pruebas',
  'pages.tests.subtitle':
    'Accesos de demostración — separados de clientes de pago, listos para renovar y notificar.',
  'pages.tests.new': 'Nueva prueba',
  'pages.tests.empty': 'Ninguna prueba encontrada',
  'pages.tests.emptyHint': 'Crea un acceso de demostración para enviar al prospecto.',
  'pages.tests.loading': 'Cargando pruebas…',

  'pages.resellers.eyebrow': 'Gestión',
  'pages.resellers.title': 'Revendedores',
  'pages.resellers.subtitle':
    'Red de revendedores Servidor — créditos, estado y métricas del panel en un solo lugar.',
  'pages.resellers.new': 'Nuevo revendedor',
  'pages.resellers.referral': 'Enlace de referidos',
  'pages.resellers.empty': 'Ningún revendedor encontrado',
  'pages.resellers.emptyHint': 'Registra un nuevo revendedor o ajusta los filtros para empezar.',
  'pages.resellers.loading': 'Cargando revendedores…',
  'pages.resellers.search': 'Buscar por usuario, e-mail o WhatsApp...',
  'pages.resellers.filterAll': 'Todos',
  'pages.resellers.filterActive': 'Activos',
  'pages.resellers.filterInactive': 'Inactivos',

  'chats.eyebrow': 'Atención',
  'chats.inbox': 'Bandeja de entrada',
  'chats.inboxHint': 'Conversaciones WhatsApp en tiempo real',
  'chats.sync.live': 'Tiempo real',
  'chats.sync.liveHint': 'Canal en vivo activo — los mensajes nuevos aparecen al instante.',
  'chats.sync.polling': 'Sincronizando',
  'chats.sync.pollingHint': 'Canal en vivo no disponible — la bandeja se actualiza cada ~8 s.',
  'chats.sync.reconnecting': 'Reconectando…',
  'chats.sync.reconnectingHint': 'Conexión inestable un momento — recuperando automáticamente.',
  'chats.sync.syncing': 'Importando historial',
  'chats.sync.syncingHint': 'WhatsApp importa chats antiguos — el tiempo real vuelve al terminar.',
  'chats.sync.delayed': 'Con retraso',
  'chats.sync.delayedHint': 'Sin actualización en 20+ s — pulsa Actualizar o revisa la conexión.',
  'chats.sync.waStale': 'WhatsApp sin recibir',
  'chats.sync.waStaleHint':
    'Sesión conectada, pero el panel no recibe mensajes nuevos — la reparación automática está actuando. Pulsa Actualizar.',
  'chats.sync.waOffline': 'WhatsApp desconectado',
  'chats.sync.waOfflineHint': 'Ninguna conexión WhatsApp activa — los mensajes pueden no llegar al panel.',
  'chats.sync.offline': 'Sin conexión',
  'chats.sync.offlineHint': 'Sin internet o servidor ocupado — reintentando automáticamente.',
  'chats.sync.updatedNow': 'Actualizado ahora',
  'chats.sync.updatedAgo': 'Actualizado hace {n} s',
  'chats.sync.refresh': 'Actualizar ahora',
  "chats.sync.details": "Detalles de la conexión",
  "chats.filterConversations": "Filtrar conversaciones",
  "chats.moreFilters": "Otras conversaciones",
  "chats.chooseFilter": "Elige un filtro",
  'chats.sync.waHistory': 'Sincronizar WhatsApp',
  'chats.sync.waHistoryHint': 'Importar mensajes de la conexión activa',
  'chats.sync.waHistoryHours': 'Últimas {n} horas',
  'chats.sync.waHistoryStarted': 'Sincronización de las últimas {n}h iniciada',
  'chats.sync.waHistoryBusy': 'Sincronización ya en curso',
  'chats.sync.waHistoryOffline': 'WhatsApp no está conectado',
  'chats.sync.waHistoryError': 'No se pudo iniciar la sincronización',
  'chats.sync.waHistoryNoConn': 'Ninguna conexión WhatsApp disponible',
  'chats.conversations': 'Conversaciones',
  'chats.activeCount': '{n} activas',
  'chats.unattendedCount': '{n} sin atender',
  'chats.emptyInbox': 'Bandeja limpia',
  'chats.emptyInboxHint':
    'Cuando llegue un mensaje de WhatsApp, aparece aquí. O busca un contacto del CRM para abrir la atención.',
  'chats.noWaTitle': 'WhatsApp no configurado',
  'chats.noWaHint':
    'Esta cuenta aún no tiene un número de WhatsApp vinculado. Configúralo para recibir y responder mensajes aquí.',
  'chats.noWaCta': 'Configurar WhatsApp',
  'chats.emptyGroups': 'Ningún grupo activo',
  'chats.noneFound': 'Ninguna conversación encontrada',
  'chats.noneFoundHint': 'Prueba otro término — o abre un contacto del CRM abajo.',
  'chats.crmHitsTitle': 'Contactos del CRM',
  'chats.crmHitsLoading': 'Buscando contactos…',
  'chats.crmHitsNone': 'Ningún contacto CRM con ese término.',
  'chats.openInOffice': 'Atención',
  'chats.openedFromCrm': 'Atención abierta en Office',
  'chats.openFromCrmFail': 'No se pudo abrir la atención',
  'chats.search': 'Buscar conversación o contacto CRM…',
  'chats.loadingInbox': 'Cargando conversaciones…',
  'chats.loadFail': 'Error al cargar',
  'chats.retry': 'Reintentar',
  'chats.selectTitle': 'Selecciona una atención',
  'chats.selectHint':
    'Elige un contacto en la lista de la izquierda. Usa Cliente en el encabezado para acceso, ventas y datos del contacto.',
  'chats.chipShortcuts': 'Atajos rápidos',
  'chats.chipCrm': 'Panel del cliente',
  'chats.chipRealtime': 'Tiempo real',
  'chats.tabMine': 'Mías',
  'chats.tabUnassigned': 'Sin asig.',
  'chats.tabAll': 'Todas',
  'chats.tabGroups': 'Grupos',
  'chats.onlyUnattended': 'Solo no atendidas',
  'chats.clearJunk': 'Limpiar basura',
  'chats.clearAll': 'Limpiar todo',
  'chats.kpiActive': 'Conversaciones',
  'chats.kpiWaiting': 'En espera',
  'chats.stepPick': 'Elige un contacto en la lista',
  'chats.stepCrm': 'Abre el panel del cliente en el encabezado del hilo',
  'chats.stepReply': 'Responde en tiempo real con el compositor',
  'chats.ficha': 'Cliente',
  'chats.fichaTitle': 'Panel del cliente',
  'chats.backToInbox': 'Volver a la bandeja',
  'chats.railPrev': 'Conversaciones anteriores',
  'chats.railNext': 'Más conversaciones',
  'chats.today': 'Hoy',
  'chats.yesterday': 'Ayer',
  'chats.pressEnter': 'Enter envía · Shift+Enter nueva línea',
  'chats.assignedTo': 'Con {n}',
  'chats.presenceOnline': 'En línea',
  'chats.presenceOffline': 'Desconectado',
  'chats.system': 'Sistema',
  'chats.loadingOlder': 'Cargando anteriores…',
  'chats.loadOlder': 'Cargar mensajes anteriores',
  'chats.groupChip': 'Grupo',
  'chats.groupMembers': '{n} participantes',
  'chats.groupHint': 'Conversación de grupo en WhatsApp',
  'chats.groupLastFrom': 'Última de {n}',
  'ficha.tabAccess': 'Acceso',
  'ficha.tabCommercial': 'Comercial',
  'ficha.tabFinance': 'Financiero',
  'ficha.tabContact': 'Contacto',
  'ficha.accessEmptyTitle': 'Ninguna línea vinculada',
  'ficha.accessEmptyHint':
    'Busca el usuario en Servidor o genera un acceso en la pestaña Comercial.',
  'ficha.searchUser': 'Buscar en Servidor',
  'ficha.searchPlaceholder': 'Usuario, correo o ID…',
  'ficha.searchHint': 'Mínimo 3 caracteres. El resultado aparece abajo.',
  'ficha.searchMin': 'Escribe al menos 3 caracteres.',
  'ficha.searchError': 'No fue posible conectar con Servidor.',
  'ficha.noResults': 'No se encontraron usuarios.',
  'ficha.link': 'Vincular',
  'ficha.linkError': 'No fue posible vincular la línea.',
  'ficha.unlinkError': 'No fue posible quitar el vínculo.',
  'ficha.actionError': 'La acción en Servidor falló.',
  'ficha.credential': 'Credencial',
  'ficha.username': 'Usuario',
  'ficha.password': 'Contraseña',
  'ficha.showPass': 'Mostrar contraseña',
  'ficha.hidePass': 'Ocultar contraseña',
  'ficha.expiry': 'Vencimiento',
  'ficha.connections': 'Conexiones',
  'ficha.screens': '{n} pantallas',
  'ficha.active': 'Activo',
  'ficha.blocked': 'Bloqueado',
  'ficha.resetConn': 'Reiniciar conexiones',
  'ficha.injectChat': 'Enviar al chat',
  'ficha.blockLine': 'Bloquear línea',
  'ficha.unblockLine': 'Desbloquear',
  'ficha.unlink': 'Desvincular',
  'ficha.copied': 'Copiado',
  'ficha.linked': 'Línea vinculada a esta conversación',
  'ficha.unlinked': 'Vínculo eliminado',
  'ficha.injected': 'Datos colocados en el compositor',
  'ficha.goGenerate': 'Generar un acceso nuevo',
  'ficha.accessMsg':
    '*DATOS DE ACCESO*\n\nUsuario: {user}\nContraseña: {pass}\nVencimiento: {exp}\n\n_Reseteamos la conexión si hace falta._',
  'ficha.referralTitle': 'Indicación y reventa',
  'ficha.referralHint': 'Copia el enlace de registro y envíalo al futuro revendedor.',
  'ficha.copyLink': 'Copiar enlace',
  'ficha.invite': 'Enviar invitación para revender',
  'ficha.referralMsg':
    '🚀 *INVITACIÓN PARA SER REVENDEDOR DE {nome_office}*\n\n¡Hola! 👋\n\nConvierte oportunidades en resultados con una plataforma completa, pensada para facilitar tu operación e impulsar tu crecimiento.\n\nEn *{nome_office}* cuentas con un *Office exclusivo y propio*, lejos de las plataformas genéricas del mercado.\n\n*Todo lo que necesitas en un solo lugar:*\n\n✅ *CRM* para gestionar clientes\n✅ *Gestión financiera* completa\n✅ *Integraciones bancarias*\n✅ *Central de atención* integrada\n✅ *Ranking de desempeño*\n✅ *Gestión de equipo*\n✅ Activaciones rápidas y créditos\n✅ *Materiales exclusivos* para revender\n✅ *Soporte especializado*\n\n📝 *Regístrate ahora:*\n{url}\n\n*Sé {nome_office} y trabaja con un Office realmente propio y diferente!* 🚀',
  'ficha.inviteSent': 'Invitación enviada por WhatsApp.',
  'ficha.inviteSendFail': 'No fue posible enviar la invitación. El mensaje quedó en el compositor.',
  'ficha.linkCopied': 'Enlace de indicación copiado',
  'ficha.refError': 'No fue posible obtener el código de indicación.',
  'ficha.generateTitle': 'Generar línea',
  'ficha.generateHint':
    'Planes de cliente (checkout) y pruebas del Panel. Una prueba fuera del PIX también aparece aquí.',
  'ficha.pkgType': 'Tipo de paquete',
  'ficha.pkgAll': 'Todos',
  'ficha.pkgTrial': 'Prueba',
  'ficha.pkgPaid': 'Final',
  'ficha.package': 'Paquete',
  'ficha.selectPlan': 'Selecciona un plan…',
  'ficha.selectPlanFirst': 'Selecciona un plan.',
  'ficha.noPlans': 'Sin planes en este filtro',
  'ficha.tryAll': 'Prueba el filtro Todos.',
  'ficha.generateSend': 'Generar y enviar',
  'ficha.appTitle': 'Aplicación del cliente',
  'ficha.appHint':
    'Defina el reproductor de este acceso. WhatsApp recibe el bloque de la app elegida.',
  'ficha.loadingPkgs': 'Cargando paquetes…',
  'ficha.pkgError': 'Error al conectar con Servidor.',
  'ficha.genError': 'Fallo al generar la línea en Servidor.',
  'ficha.lineOk': 'Línea generada.',
  'ficha.lineSent': 'Línea generada y enviada por WhatsApp.',
  'ficha.lineSendFail': 'Línea generada, pero el envío falló. Pulse enviar en el compositor.',
  'ficha.lineReady': 'Línea generada.\nUsuario: {user}\nContraseña: {pass}',
  'ficha.proofTitle': 'Comprobante y venta',
  'ficha.proofHint': 'Revisa el comprobante, completa los datos y confirma la baja manualmente.',
  'ficha.dropTitle': 'Suelta o haz clic para enviar',
  'ficha.dropHint': 'PNG o JPG — un envío para auditoría y baja',
  'ficha.saleData': 'Datos de la venta',
  'ficha.amount': 'Importe',
  'ficha.method': 'Método',
  'ficha.txId': 'ID / comprobante',
  'ficha.pix': 'PIX',
  'ficha.credit': 'Crédito',
  'ficha.cash': 'Efectivo',
  'ficha.matchSale': 'Venta correspondiente',
  'ficha.settle': 'Dar de baja',
  'ficha.orNewSale': 'O registra como venta nueva si es otro pago',
  'ficha.registerPaid': 'Registrar venta pagada',
  'ficha.registerPending': 'Registrar venta pendiente',
  'ficha.needAmount': 'Indique el importe de la venta (mayor que cero).',
  'ficha.needContact': 'Conversación sin contacto vinculado — no fue posible registrar la venta.',
  'ficha.paidOkHint': 'Venta pagada registrada. Revise en Finanzas → Visión o Registros.',
  'ficha.pendingOkHint': 'Venta pendiente registrada. Solo entra en facturación tras la baja con comprobante.',
  'ficha.aiQuota': 'Límite de IA alcanzado. Inténtalo más tarde o completa importe e ID a mano.',
  'ficha.receiptError': 'Error al procesar el comprobante.',
  'ficha.finRegistered': 'Registrado en financiero.',
  'ficha.audit': 'Auditoría',
  'ficha.ocrFail': 'No fue posible leer el comprobante con la IA.',
  'ficha.receiptOk': 'Comprobante procesado.',
  'ficha.receiptNoSale': 'Comprobante leído. Ninguna venta pendiente correspondiente.',
  'ficha.ocrManual': 'La IA no identificó importes — ajústalo a mano.',
  'ficha.needReceipt': 'Envía el comprobante antes de dar de baja.',
  'ficha.settled': 'Baja concluida — comprobante en financiero.',
  'ficha.settleError': 'Error al vincular la venta.',
  'ficha.paidOk': 'Venta registrada y pagada con comprobante.',
  'ficha.pendingOk': 'Venta pendiente registrada. Envía el comprobante para dar de baja.',
  'ficha.saveSaleError': 'Error al guardar la venta.',
  'ficha.saleViaChat': 'Venta vía atención',
  'ficha.attendant': 'Agente',
  'ficha.waOrigin': 'WhatsApp de origen',
  'ficha.group': 'Grupo',
  'ficha.copyPhone': 'Copiar teléfono',
  'ficha.system': 'Sistema',
  'ficha.open': 'Abierto',
  'ficha.status': 'Estado',
  'conv.status.open': 'Abierto',
  'conv.status.waiting': 'En espera',
  'conv.status.closed': 'Cerrado',
  'ficha.unknown': 'Contacto',
  'chats.labelsTitle': 'Etiquetas',
  'chats.labelsHint': 'Marca esta conversación. Crea una etiqueta al momento, sin ir a ajustes.',
  'chats.labelsCreateSection': 'Nueva etiqueta',
  'chats.labelsPlaceholder': 'Nombre de la etiqueta',
  'chats.labelsCreate': 'Crear',
  'chats.labelsEmpty': 'Aún no hay etiquetas',
  'chats.labelsEmptyHint': 'Escribe un nombre, elige el color y crea. Ya entra en esta conversación.',
  'chats.labelsApply': 'Aplicar',
  'chats.pastePrint': 'Captura pegada',
  'chats.pasteRemove': 'Quitar captura',
  'chats.pasteNotImage': 'El portapapeles no tiene una imagen.',
  'chats.captionPlaceholder': 'Leyenda (opcional)…',
  'chats.typeMessage': 'Escribe un mensaje…',
  'chats.fileSent': 'Archivo enviado',
  'chats.fileSendError': 'Error al enviar el archivo',
  'chats.notifyTitle': 'Notificaciones',
  'chats.notifyShort': 'Sonidos',
  'chats.notifyHint':
    'Tonos del inbox y avisos en la barra de notificaciones del móvil y en el escritorio.',
  'chats.notifyAllow': 'Permitir notificaciones',
  'chats.notifyAsking': 'Solicitando permiso…',
  'chats.notifyAllowed':
    'Permiso concedido — los avisos salen en la barra del sistema. (El navegador no vuelve a pedir si ya autorizó.)',
  'chats.notifyDenied':
    'Bloqueadas en este navegador. Activa las notificaciones en la configuración del sitio.',
  'chats.notifyDeniedHelp':
    'En Chrome: candado en la barra de dirección → Notificaciones → Permitir, luego recarga la página.',
  'chats.notifyUnsupported': 'Este navegador no admite avisos del sistema.',
  'chats.notifyNeedPerm': 'El navegador aún no pidió permiso para avisar fuera de esta pestaña.',
  'chats.notifyPush': 'Avisos en pantalla',
  'chats.notifyPushHint':
    'Aparecen en la barra de notificaciones (móvil) y en el escritorio cuando llega un mensaje.',
  'chats.notifySounds': 'Tonos',
  'chats.notifySoundsHint': 'Desactiva para silenciar todos los sonidos del inbox.',
  'chats.notifyReceive': 'Recibir mensaje',
  'chats.notifySend': 'Enviar mensaje',
  'chats.notifyAlert': 'Alerta del sistema',
  'chats.notifyOpenInbox': 'Abrir inbox',
  'chats.notifyTestPush': 'Avisos activos. Los mensajes nuevos aparecen aquí.',
  'chats.notifyTestRich':
    '¡Hola! Este es un ejemplo de aviso de atención con teléfono y hora.',
  'chats.notifyTestNow': 'Probar aviso ahora',
  'chats.notifyTestOk': 'Aviso enviado. Si no aparece, desactiva Concentración / No molestar en Windows.',
  'chats.notifyTestFail': 'No se pudo mostrar el aviso. Recarga la página e inténtalo de nuevo.',
  'chats.notifyFocusHint':
    'Si el Centro de notificaciones de Windows muestra el icono zzz (concentración), el sistema bloquea los avisos del navegador.',
  'chats.notifyCatChat': 'Atención',
  'chats.notifyCatChatHint': 'Mensajes, adjuntos y escalaciones.',
  'chats.notifyCatTeam': 'Equipo',
  'chats.notifyCatTeamHint': 'Atendente en línea, pausa, offline y estado de reventa.',
  'chats.notifyCatCommerce': 'Ventas y créditos',
  'chats.notifyCatCommerceHint': 'PIX, compra/venta de créditos, renovación y facturación del día.',
  'chats.notifyBannerTitle': 'No pierdas mensajes nuevos',
  'chats.notifyBannerHint': 'Activa los avisos del navegador para recibir tono y alerta en el móvil y el ordenador, incluso fuera de esta página.',
  'chats.notifyLater': 'Ahora no',
  'chats.notifyNewMessage': 'Nuevo mensaje',
  'chats.notifyAttachment': 'Adjunto',

  'vitrine.hiddenCheckout': 'Oculto en el checkout',
  'vitrine.checkout': 'Checkout',
  'vitrine.dashboard': 'Panel',
  'vitrine.duration': 'Duración',
  'vitrine.price': 'Precio',
  'vitrine.onRequest': 'A consultar',
  'vitrine.search': 'Buscar plan…',
  'vitrine.filterTest': 'Prueba',
  'vitrine.hintTrialOn':
    'Aparece en el Panel (Prueba rápida) y en el pop-up. El checkout puede quedar oculto.',
  'vitrine.hintTrialOff':
    'Plan de prueba — activa «Prueba rápida» en el catálogo para el dashboard.',
  'vitrine.hintClient':
    'Un clic en Crear cliente aplica este paquete — sin bouquet extra.',

  'league.kicker': 'Liga de la semana',
  'league.title': 'Reventas en alza',
  'league.open': 'Ver ranking',
  'league.empty': 'Nadie ha puntuado esta semana.',
  'league.min': 'Entra en la liga a partir de {n} clientes',
  'league.me': 'Tu ritmo',
  'league.unranked': 'Aún fuera de la liga',
  'league.need': 'Faltan {n} clientes para entrar',
  'league.goalClients': 'Nuevos',
  'league.goalTests': 'Pruebas',
  'league.goalLogins': 'Inicios',
  'league.bonusOn': 'Meta de la semana: {n} créd.',
  'league.bonusGot': '{n} créd. acreditados esta semana',
  'league.score': '{n} pts',
  'rank.global': 'Competición global',
  'rank.title': 'Ranking — Clientes nuevos',
  'rank.subtitle': 'Solo cuentas nuevas. Las renovaciones no entran.',
  'rank.req': 'Requiere {n}+ clientes para entrar',
  'rank.none': 'Ningún revendedor alcanzó {n} clientes todavía.',
  'rank.aspirantsTitle': 'Aspirantes — aún bloqueados',
  'rank.aspirantsHint': 'Necesitan {n} clientes para desbloquear el ranking.',
  'rank.official': 'Clasificación oficial',
  'rank.qualifiedN': '{n} clasificado(s)',
  'rank.newClients': 'clientes nuevos',
  'rank.totalClients': '{n} clientes totales',
  'rank.place': '{n}º puesto',
  'rank.forEntry': 'para entrar',
  'rank.notCounting': '{n} nuevos (aún no cuenta)',
  'rank.settings': 'Liga y metas',
  'rank.settingsHint':
    'Define el piso de la clasificación y lo que la reventa debe hacer en la semana para ganar créditos.',
  'rank.minClients': 'Piso para entrar (clientes totales)',
  'rank.goalClients': 'Meta semanal — clientes nuevos',
  'rank.goalTests': 'Meta semanal — pruebas generadas',
  'rank.goalLogins': 'Meta semanal — días con inicio de sesión',
  'rank.bonusCredits': 'Paquete de créditos al cumplir la meta',
  'rank.bonusOn': 'Pagar bono automáticamente',
  'rank.bonusDays': 'Validez de los créditos (días)',
  'rank.save': 'Guardar metas',
  'rank.saved': 'Metas de la liga actualizadas',
  'rank.saveFail': 'No se pudieron guardar las metas',
  'rank.weekTitle': 'Calor de la semana',
  'rank.weekHint':
    'Login diario, pruebas y altas de clientes finales. Quien cumple las tres metas recibe el paquete.',
  'rank.loadFail': 'Fallo al cargar el ranking',

  'settings.footer.brandHint':
    'Los cambios de marca y apariencia se aplican a toda la oficina.',
  'settings.ops.active': 'Agente IA activo',
  'settings.ops.activeHint':
    'Cuando está activo, puedes escribir en lenguaje natural en Telegram.',
  'settings.ops.keyOk': 'OK',
  'settings.ops.keyMissing': 'Ausente',
  'settings.ops.keyLabel': 'Clave en el bot',
  'settings.ops.service': 'Servicio',
  'settings.ops.refresh': 'Actualizar',
  'settings.ops.save': 'Guardar agente',
  'settings.ops.saved': 'Agente del bot de Telegram actualizado',
  'settings.ops.saveFail': 'Error al guardar el agente de Telegram',
  'settings.ops.idsHint':
    'Separados por coma. Solo estos IDs controlan la VPS con el bot.',
  'settings.ops.heartbeat': 'Informe automático en Telegram',
  'settings.ops.heartbeatHint': 'Envía el estado de la VPS/Office periódicamente al chat Ops.',
  'settings.ops.heartbeatInterval': 'Intervalo del informe',
  'settings.ops.heartbeatIntervalHint': 'Cuanto menor el intervalo, más mensajes en Telegram.',
  'settings.ops.hbMin': '{n} minutos',
  'settings.ops.hb1h': '1 hora',
  'settings.ops.hbHours': '{n} horas',

  'settings.backup.title': 'Copia de seguridad externa',
  'settings.backup.tab': 'Copia de seguridad',
  'settings.backup.sub':
    'Copia esencial y ligera enviada a Telegram. El archivo temporal se elimina de la VPS tras confirmar el envío.',
  'settings.backup.telegramOk': 'OK ({n} chat)',
  'settings.backup.telegramMissing': 'Bot Ops sin token/chat',
  'settings.backup.last': 'Último',
  'settings.backup.failed': 'Falló',
  'settings.backup.auto': 'Copia automática',
  'settings.backup.autoHint':
    'Se ejecuta en el intervalo definido, envía la copia fuera de la VPS y mantiene 8 registros.',
  'settings.backup.sendTg': 'Enviar a Telegram',
  'settings.backup.sendTgHint':
    'Límite ~{mb} MB por archivo. Si es mayor, se envía en varias partes (chat o grupo). Si falla, reintenta en minutos.',
  'settings.backup.interval': 'Intervalo',
  'settings.backup.interval30m': '30 minutos',
  'settings.backup.interval1h': '1 hora',
  'settings.backup.interval2h': '2 horas',
  'settings.backup.interval3h': '3 horas',
  'settings.backup.interval5h': '5 horas',
  'settings.backup.interval8h': '8 horas',
  'settings.backup.interval12h': '12 horas',
  'settings.backup.interval24h': '24 horas',
  'settings.backup.keepLocal': 'Mantener local',
  'settings.backup.keepHistory': 'Historial (registros)',
  'settings.backup.token': 'Token del bot de Telegram',
  'settings.backup.tokenPhSet': 'Configurado ({masked}) — pega para reemplazar',
  'settings.backup.tokenPhEmpty': '123456:ABC… (o deja el token del Bot Ops)',
  'settings.backup.tokenHint':
    'Opcional si el Bot Ops ya tiene token. Vacío al guardar = mantiene el actual.',
  'settings.backup.chats': 'Chat IDs de Telegram',
  'settings.backup.chatsHint':
    'ID personal o de grupo (los grupos empiezan por -100…). Separados por coma. Añade el bot al grupo con permiso para enviar archivos; el límite de tamaño es el mismo (~49 MB/archivo — copias grandes van en partes).',
  'settings.backup.refresh': 'Actualizar',
  'settings.backup.runNow': 'Generar ahora',
  'settings.backup.saveConfig': 'Guardar configuración',
  'settings.backup.restoreTitle': 'Restaurar copia de seguridad',
  'settings.backup.restoreSub':
    'Elige un snapshot del historial o sube un .tgz descargado de Telegram. Escribe RESTAURAR para confirmar.',
  'settings.backup.historySelect': 'Copia del historial',
  'settings.backup.select': 'Seleccionar…',
  'settings.backup.confirm': 'Confirmación',
  'settings.backup.confirmPh': 'Escribe RESTAURAR',
  'settings.backup.restoreSelected': 'Restaurar seleccionado',
  'settings.backup.restoreFile': 'Restaurar desde archivo…',
  'settings.backup.historyRecent': 'Historial reciente',
  'settings.backup.historyEmpty': 'Aún sin copias registradas.',
  'settings.backup.statusOk': 'OK',
  'settings.backup.statusErr': 'Error',
  'settings.backup.toastSaved': 'Copia de seguridad configurada',
  'settings.backup.toastSaveFail': 'Error al guardar la configuración',
  'settings.backup.toastRunOk': 'Copia creada y enviada a Telegram',
  'settings.backup.toastRunFail': 'Fallo en la copia de seguridad',
  'settings.backup.toastPick': 'Elige una copia del historial',
  'settings.backup.toastConfirm': 'Escribe RESTAURAR para confirmar',
  'settings.backup.confirmRestoreTitle': '¿Restaurar copia de seguridad?',
  'settings.backup.confirmRestoreDesc':
    'Esto reemplaza la base de datos y las sesiones de WhatsApp por el snapshot elegido. Las copias antiguas también pueden restaurar uploads. La Office puede reiniciar servicios.',
  'settings.backup.confirmRestoreBtn': 'Restaurar ahora',
  'settings.backup.toastRestoreOk':
    'Restauración completada — inicia sesión de nuevo si cae la sesión',
  'settings.backup.toastRestoreFail': 'La restauración falló',
  'settings.backup.confirmFileTitle': '¿Restaurar archivo?',
  'settings.backup.confirmFileDesc':
    'Se aplicará “{name}” como snapshot completo de la Office.',
  'settings.backup.confirmFileBtn': 'Restaurar archivo',
  'settings.backup.toastFileOk': 'Restauración desde archivo completada',
  'settings.backup.toastFileFail': 'Falló la restauración por archivo',

  'meetings.title': 'Reuniones',
  'meetings.subtitle': 'Agenda, disponibilidad y salas de vídeo de su red',
  'meetings.eyebrow': 'Office',
  'meetings.heroKicker': 'Central de reuniones',
  'meetings.heroTitle': 'Toda su agenda en un solo lugar',
  'meetings.heroText':
    'Enlace público para revendedores, solicitudes, disponibilidad semanal, invitaciones y lives — con vídeo LiveKit.',
  'meetings.resellerOnlyBadge': 'Reserva solo para revendedores',
  'meetings.resellerTag': 'reventa',
  'meetings.policy.resellerTitle': 'Enlace público — solo revendedores',
  'meetings.policy.resellerText':
    'Los revendedores solicitan reunión por el enlace /agendar. Tras verificar e-mail y WhatsApp eligen horario y reciben confirmación en Office y WhatsApp.',
  'meetings.policy.attendantTitle': 'Agentes — convocados por usted',
  'meetings.policy.attendantText':
    'Los agentes no usan el enlace público. Cree la reunión confirmada aquí (nombre + WhatsApp del agente). Reciben pop-up, tarjeta en el Panel y WhatsApp y entran marcando presencia.',
  'meetings.homeCard.kicker': 'Reunión convocada',
  'meetings.homeCard.title': 'Próxima reunión',
  'meetings.homeCard.hint': 'Confirme su presencia para entrar a la sala de vídeo.',
  'meetings.homeCard.cta': 'Marcar presencia y entrar',
  'meetings.homeCard.more': 'Ver Reuniones',
  'meetings.kpiLabel': 'Indicadores',
  'meetings.tab.overview': 'Resumen',
  'meetings.tab.inbox': 'Solicitudes',
  'meetings.tab.mine': 'Mías',
  'meetings.tab.availability': 'Agenda',
  'meetings.tab.lives': 'Transmisiones',
  'meetings.overviewInbox': 'Cola rápida',
  'meetings.overviewInboxHint': '{pending} pendientes · {confirmed} confirmados',
  'meetings.bookingsHint': 'Confirme, reprograme o avise imprevistos — el revendedor recibe WhatsApp y pop-up.',
  'meetings.filter.all': 'Todos',
  'meetings.filter.pending': 'Pendientes',
  'meetings.filter.confirmed': 'Confirmados',
  'meetings.filter.unforeseen': 'Imprevistos',
  'meetings.filter.cancelled': 'Cancelados',
  'meetings.filter.completed': 'Concluidos',
  'meetings.delete': 'Eliminar',
  'meetings.clearLives': 'Limpiar transmisiones',
  'meetings.clearFinished': 'Limpiar finalizados',
  'meetings.confirmDeleteLive': '¿Eliminar la transmisión «{name}»?',
  'meetings.confirmDeleteBooking': '¿Eliminar permanentemente el pedido «{name}»?',
  'meetings.confirmClearLives': '¿Quitar todas las transmisiones programadas?',
  'meetings.confirmClearBookings': '¿Quitar pedidos cancelados, concluidos e imprevistos?',
  'meetings.toast.deleted': 'Eliminado',
  'meetings.toast.liveDeleted': 'Transmisión eliminada',
  'meetings.toast.cleared': '{n} elemento(s) eliminado(s)',
  'meetings.weekdays': 'Días activos',
  'meetings.availabilityFoot':
    'Los días marcados abren slots de mañana (09–12) y tarde (14–18). Ajuste duración y zona horaria según la operación.',
  'meetings.liveList': 'Transmisiones programadas',
  'meetings.liveEmpty': 'Aún no hay transmisiones programadas.',
  'meetings.kpi.upcoming': 'Próximas',
  'meetings.kpi.pending': 'Pendientes',
  'meetings.kpi.completed': 'Concluidas',
  'meetings.kpi.lives': 'Transmisiones',
  'meetings.publicLink': 'Enlace público de reserva',
  'meetings.publicLinkHint': 'Clientes y socios eligen horario y envían la solicitud.',
  'meetings.copyLink': 'Copiar enlace',
  'meetings.open': 'Abrir',
  'meetings.videoOn': 'Vídeo activo',
  'meetings.videoOff': 'Vídeo pendiente en la VPS',
  'meetings.videoOffline': 'Servidor de vídeo offline',
  'meetings.broadcastTag': 'transmisión',
  'meetings.inviteTitle': 'Convocar reunión',
  'meetings.inviteHint': 'Seleccione el contacto de WhatsApp o complete manualmente. Se crea confirmada — el invitado recibe pop-up, tarjeta en el Panel y mensaje en WhatsApp.',
  'meetings.contactPickLabel': 'Contacto WhatsApp',
  'meetings.contactPickHint': 'Busque en atenciones o contactos CRM — nombre y teléfono se completan solos.',
  'meetings.name': 'Nombre',
  'meetings.phone': 'Teléfono',
  'meetings.when': 'Cuándo',
  'meetings.createConfirmed': 'Crear reunión confirmada',
  'meetings.availability': 'Disponibilidad semanal',
  'meetings.availabilityHint': 'Zona {tz} · slots de {min} min',
  'meetings.duration': 'Duración (min)',
  'meetings.timezone': 'Zona horaria',
  'meetings.save': 'Guardar',
  'meetings.saved': 'Disponibilidad guardada',
  'meetings.bookings': 'Solicitudes recibidas',
  'meetings.bookingsEmpty': 'Aún no hay reservas.',
  'meetings.myBookings': 'Mis reservas',
  'meetings.myBookingsHint': 'Pedidos que hiciste como revendedor en este Office',
  'meetings.myBookingsEmpty': 'Aún no tienes pedidos de reunión',
  'meetings.confirm': 'Confirmar',
  'meetings.decline': 'Rechazar',
  'meetings.enterRoom': 'Entrar a la sala',
  'meetings.guestLink': 'Enlace del invitado',
  'meetings.resendWhatsApp': 'Reenviar WhatsApp',
  'meetings.waNotSent': 'WhatsApp no enviado',
  'meetings.complete': 'Concluir',
  'meetings.reschedule': 'Reprogramar',
  'meetings.unforeseen': 'Imprevisto',
  'meetings.prompt.reschedule': 'Nueva hora (AAAA-MM-DD HH:MM)',
  'meetings.prompt.reasonOptional': 'Nota (opcional)',
  'meetings.prompt.unforeseen': 'Describa el imprevisto',
  'meetings.prompt.cancelReason': 'Motivo de cancelación (opcional)',
  'meetings.liveTitle': 'Programar transmisión',
  'meetings.liveHint': 'Transmisión para la red con control de oradores.',
  'meetings.liveName': 'Título',
  'meetings.liveDesc': 'Descripción',
  'meetings.createLive': 'Crear transmisión',
  'meetings.openLive': 'Abrir transmisión',
  'meetings.status.pending': 'Pendiente',
  'meetings.status.confirmed': 'Confirmado',
  'meetings.status.cancelled': 'Cancelado',
  'meetings.status.completed': 'Concluido',
  'meetings.status.unforeseen': 'Imprevisto',
  'meetings.toast.confirmed': 'Confirmado — WhatsApp enviado al revendedor',
  'meetings.toast.cancelled': 'Cancelado — revendedor notificado',
  'meetings.toast.rescheduled': 'Reprogramado — revendedor notificado',
  'meetings.toast.unforeseen': 'Imprevisto registrado — revendedor notificado',
  'meetings.toast.updated': 'Actualizado',
  'meetings.toast.linkCopied': 'Enlace copiado',
  'meetings.toast.guestLinkCopied': 'Enlace de la sala copiado — envíe por WhatsApp',
  'meetings.toast.created': 'Reunión creada y confirmada',
  'meetings.toast.createdWa': 'Invitación creada y enviada por WhatsApp',
  'meetings.toast.createdNoWa': 'Reunión creada, pero WhatsApp no se envió — use Reenviar WhatsApp',
  'meetings.toast.needPhone': 'Indique el WhatsApp del invitado para enviar la invitación',
  'meetings.toast.waResent': 'Invitación reenviada por WhatsApp',
  'meetings.toast.waResendFail': 'Error al reenviar por WhatsApp',
  'meetings.toast.liveCreated': 'Transmisión creada',
  'meetings.toast.loadFail': 'Error al cargar reuniones',
  'meetings.toast.saveFail': 'Error al guardar',
  'meetings.toast.needInvite': 'Nombre y horario obligatorios',
  'meetings.toast.needLive': 'Título y fecha/hora obligatorios',
  'meetings.room.floatKeep': 'Continuar en pop-up',
  'meetings.room.floatKeepShort': 'Pop-up',
  'meetings.room.floatTitle': 'Transmisión en vivo',
  'meetings.room.floatExpand': 'Abrir sala',
  'meetings.room.tab.chat': 'Chat',
  'meetings.room.tab.audience': 'Audiencia',
  'meetings.room.tab.network': 'Red',
  'meetings.room.chatEmpty': 'Aún no hay mensajes. Habla con la audiencia aquí.',
  'meetings.room.chatPlaceholder': 'Escribe un mensaje…',
  'meetings.room.audienceEmpty': 'Nadie en la sala por ahora.',
  'meetings.room.micOff': 'Mic off',
  'meetings.room.net.quality': 'Calidad',
  'meetings.room.net.uplink': 'Envío',
  'meetings.room.net.downlink': 'Recepción',
  'meetings.room.net.rtt': 'Latencia',
  'meetings.room.net.loss': 'Pérdida (pkt)',
  'meetings.room.net.hint': 'Valores WebRTC en tiempo real. Prefiera Wi-Fi estable o cable en una live.',
  'meetings.room.net.excellent': 'Excelente',
  'meetings.room.net.good': 'Buena',
  'meetings.room.net.poor': 'Débil',
  'meetings.room.net.lost': 'Perdida',
  'meetings.room.net.unknown': 'Midiendo…',
  'meetings.room.title': 'Sala de reunión',
  'meetings.room.live': 'Transmisión en vivo',
  'meetings.room.back': 'Volver',
  'meetings.room.connecting': 'Conectando a la sala…',
  'meetings.room.connected': 'conectada',
  'meetings.room.inRoom': '{n} en la sala',
  'meetings.room.you': 'Usted',
  'meetings.room.others': 'Participantes',
  'meetings.room.camOff': 'Cámara apagada',
  'meetings.room.mic': 'Micrófono',
  'meetings.room.cam': 'Cámara',
  'meetings.room.share': 'Compartir pantalla o ventana',
  'meetings.room.shareShort': 'Pantalla',
  'meetings.room.shareStop': 'Parar pantalla',
  'meetings.room.shareOn': 'Compartiendo pantalla',
  'meetings.room.shareOff': 'Compartición finalizada',
  'meetings.room.shareCancel': 'Compartición cancelada',
  'meetings.room.sharing': 'compartiendo pantalla',
  'meetings.room.screen': 'Pantalla compartida',
  'meetings.room.waiting': 'Esperando vídeo o compartición…',
  'meetings.room.hand': 'Levantar la mano',
  'meetings.room.handOk': 'Mano levantada — anfitrión avisado',
  'meetings.room.hangup': 'Salir',
  'meetings.room.retry': 'Intentar de nuevo',
  'meetings.room.role.host': 'Anfitrión',
  'meetings.room.role.guest': 'Invitado',
  'meetings.room.role.audience': 'Audiencia',
  'meetings.room.role.speaker': 'Orador',
  'meetings.room.warn.mic': 'Micrófono no disponible. Revise el permiso del navegador.',
  'meetings.room.warn.cam':
    'Cámara no disponible. Continuando solo con audio — puede activar la cámara después o compartir la pantalla.',
  'meetings.room.warn.camRetry':
    'No se pudo iniciar la cámara. Revise permisos y si otra app la está usando.',
  'meetings.room.warn.share':
    'No se pudo compartir la pantalla. Use HTTPS y permita la captura en el navegador.',
  'meetings.room.err.livekit':
    'El vídeo aún no está activo en esta VPS. Configure LiveKit y las variables LIVEKIT_*.',
  'meetings.room.err.join': 'Error al entrar en la sala',
  'meetings.room.err.signalTimeout':
    'No fue posible conectar al servidor de vídeo (tiempo agotado). Verifique que LiveKit esté activo en la VPS y que Nginx permita WebSocket en /livekit/.',
  'meetings.room.err.connection': 'Fallo en la conexión con la sala de vídeo.',
  'meetings.room.err.troubleshoot':
    'Si persiste, pida al administrador reiniciar LiveKit (docker) y revisar LIVEKIT_URL en el backend.',
  'meetings.room.err.title': 'No fue posible entrar',
  'meetings.room.hands': 'manos: {list}',
};

export const PAGE_MESSAGES = {
  'pt-BR': ptBR,
  en,
  es,
};

export function intlLocaleFor(code) {
  if (code === 'en') return 'en-US';
  if (code === 'es') return 'es-ES';
  return 'pt-BR';
}
